/**
 * A function to create a log object for the 'templatesPageTabClicked' event (evid: 185)
 *
 * Event description: User clicks on one of the tabs 'Templates'/'Wireframes'.
 *
 * @param {templatesPageTabClickedParams} params - The parameters for this event
 * @property {string} tab_name - Templates, Wireframes
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<templatesPageTabClickedParams>} LogObject<templatesPageTabClickedParams>
 */
export function templatesPageTabClicked(params) {
    return { evid: 185, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesCtaClick' event (evid: 2001)
 *
 * Event description: Click on any  of the CTA in design classes pages
 *
 * @param {designClassesCtaClickParams} params - The parameters for this event
 * @property {number} ctaLocation - Serial, top-down per page
 * @property {string} ctaName - Same as CTA caption
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesCtaClickParams>} LogObject<designClassesCtaClickParams>
 */
export function designClassesCtaClick(params) {
    return { evid: 2001, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesVideoThumbnailClick' event (evid: 2002)
 *
 * Event description: Video thumbnail click
 *
 * @param {designClassesVideoThumbnailClickParams} params - The parameters for this event
 * @property {number} videoLocation - Serial, top-down per page
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesVideoThumbnailClickParams>} LogObject<designClassesVideoThumbnailClickParams>
 */
export function designClassesVideoThumbnailClick(params) {
    return { evid: 2002, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesPlayVideoClick' event (evid: 2003)
 *
 * Event description: Click on the video itself (not thumbnail)
 *
 * @param {designClassesPlayVideoClickParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesPlayVideoClickParams>} LogObject<designClassesPlayVideoClickParams>
 */
export function designClassesPlayVideoClick(params) {
    return { evid: 2003, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesLessonClick' event (evid: 2004)
 *
 * Event description: Click on any  of the lessons in design classes inner pages. Lessons are static (not videos)
 *
 * @param {designClassesLessonClickParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} lessonName - Same as lesson caption
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesLessonClickParams>} LogObject<designClassesLessonClickParams>
 */
export function designClassesLessonClick(params) {
    return { evid: 2004, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesClassViewWatchedFirst3Seconds' event (evid: 2010)
 *
 * Event description: Triggered after a video is played, according to watch time. For class videos only (not intro)
 *
 * @param {designClassesClassViewWatchedFirst3SecondsParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesClassViewWatchedFirst3SecondsParams>} LogObject<designClassesClassViewWatchedFirst3SecondsParams>
 */
export function designClassesClassViewWatchedFirst3Seconds(params) {
    return { evid: 2010, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesClassViewWatchedFirst50OfFullLength' event (evid: 2011)
 *
 * Event description: Triggered after a video is played, according to watch time. For class videos only (not intro)
 *
 * @param {designClassesClassViewWatchedFirst50OfFullLengthParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesClassViewWatchedFirst50OfFullLengthParams>} LogObject<designClassesClassViewWatchedFirst50OfFullLengthParams>
 */
export function designClassesClassViewWatchedFirst50OfFullLength(params) {
    return { evid: 2011, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesClassViewWatchedFirst90OfFullLength' event (evid: 2012)
 *
 * Event description: Triggered after a video is played, according to watch time. For class videos only (not intro)
 *
 * @param {designClassesClassViewWatchedFirst90OfFullLengthParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesClassViewWatchedFirst90OfFullLengthParams>} LogObject<designClassesClassViewWatchedFirst90OfFullLengthParams>
 */
export function designClassesClassViewWatchedFirst90OfFullLength(params) {
    return { evid: 2012, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designClassesClassViewCompletionRate' event (evid: 2013)
 *
 * Event description: Triggered at the end of a session, once the video has ended or been interrupted. For class videos only (not intro)
 *
 * @param {designClassesClassViewCompletionRateParams} params - The parameters for this event
 * @property {string} artistName - Artist name
 * @property {string} className - Same as class caption, only for classes (not intro videos)
 * @property {number} videoFullLengthSeconds - Full length of the video in seconds
 * @property {string} stopAction - The action performed by the viewer that ended the watch session, if completion rate is 100% then null
 * @property {number} completionRate - Ratio: Actual time of video watched/full length of video
 * @property {string} videoType - Class or intro
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designClassesClassViewCompletionRateParams>} LogObject<designClassesClassViewCompletionRateParams>
 */
export function designClassesClassViewCompletionRate(params) {
    return { evid: 2013, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fromTheXTeamCtaClick' event (evid: 2050)
 *
 * Event description: Click on any  of the CTA on 'From the X team' page
 *
 * @param {fromTheXTeamCtaClickParams} params - The parameters for this event
 * @property {string} author - author
 * @property {string} lesson - lesson
 * @property {string} ctaName - Same as CTA caption
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<fromTheXTeamCtaClickParams>} LogObject<fromTheXTeamCtaClickParams>
 */
export function fromTheXTeamCtaClick(params) {
    return { evid: 2050, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20PlayVideoClick' event (evid: 2100)
 *
 * Event description: Triggered when a user clicks "play" on one of the videos in the academy.
 * Can be clicked from various pages inside the academy
 *
 * @param {editorXAcademy20PlayVideoClickParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20PlayVideoClickParams>} LogObject<editorXAcademy20PlayVideoClickParams>
 */
export function editorXAcademy20PlayVideoClick(params) {
    return { evid: 2100, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20VideoViewWatchedFirst3Seconds' event (evid: 2101)
 *
 * Event description: Triggered when a user watches first 3 seconds of the video
 *
 * @param {editorXAcademy20VideoViewWatchedFirst3SecondsParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20VideoViewWatchedFirst3SecondsParams>} LogObject<editorXAcademy20VideoViewWatchedFirst3SecondsParams>
 */
export function editorXAcademy20VideoViewWatchedFirst3Seconds(params) {
    return { evid: 2101, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20VideoViewWatched50OfVideoLength' event (evid: 2102)
 *
 * Event description: Triggered when a user watches 50% of Video Length
 *
 * @param {editorXAcademy20VideoViewWatched50OfVideoLengthParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20VideoViewWatched50OfVideoLengthParams>} LogObject<editorXAcademy20VideoViewWatched50OfVideoLengthParams>
 */
export function editorXAcademy20VideoViewWatched50OfVideoLength(params) {
    return { evid: 2102, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20VideoViewWatched90OfVideoLength' event (evid: 2103)
 *
 * Event description: Triggered when a user watches 90% of Video Length
 *
 * @param {editorXAcademy20VideoViewWatched90OfVideoLengthParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20VideoViewWatched90OfVideoLengthParams>} LogObject<editorXAcademy20VideoViewWatched90OfVideoLengthParams>
 */
export function editorXAcademy20VideoViewWatched90OfVideoLength(params) {
    return { evid: 2103, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20VideoViewCompletionRate' event (evid: 2104)
 *
 * Event description: Triggered when watching session ended, generates the percent from video's full length that was watched.
 *
 * @param {editorXAcademy20VideoViewCompletionRateParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {number} completionRate - percents
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20VideoViewCompletionRateParams>} LogObject<editorXAcademy20VideoViewCompletionRateParams>
 */
export function editorXAcademy20VideoViewCompletionRate(params) {
    return { evid: 2104, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20LessonViewStart' event (evid: 2105)
 *
 * Event description: Triggered when a lesson page is open
 *
 * @param {editorXAcademy20LessonViewStartParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users opened the lesson. examples: all lessons page, home page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20LessonViewStartParams>} LogObject<editorXAcademy20LessonViewStartParams>
 */
export function editorXAcademy20LessonViewStart(params) {
    return { evid: 2105, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20LessonViewFinish' event (evid: 2106)
 *
 * Event description: Triggered when a user scroll Scroll down until “exercise” (at the bottom of the lesson page) is visible
 *
 * @param {editorXAcademy20LessonViewFinishParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sourcePage - the page from which the users opened the lesson. examples: all lessons page, home page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20LessonViewFinishParams>} LogObject<editorXAcademy20LessonViewFinishParams>
 */
export function editorXAcademy20LessonViewFinish(params) {
    return { evid: 2106, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20LessonViewInThisLessonClick' event (evid: 2107)
 *
 * Event description: Triggered when a user clicks on inner-page navigation button (top-right corner of the lesson page) to skip sections inside a lesson
 *
 * @param {editorXAcademy20LessonViewInThisLessonClickParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} sectionName - the section (name of the button) on which the user clicked. example: "Background Colors"
 * @property {string} sourcePage - the page from which the users opened the lesson. examples: all lessons page, home page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20LessonViewInThisLessonClickParams>} LogObject<editorXAcademy20LessonViewInThisLessonClickParams>
 */
export function editorXAcademy20LessonViewInThisLessonClick(params) {
    return { evid: 2107, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademy20LessonViewVoteForALesson' event (evid: 2108)
 *
 * Event description: Triggered when a user votes for an article (did you find this lesson helpful?)
 *
 * @param {editorXAcademy20LessonViewVoteForALessonParams} params - The parameters for this event
 * @property {string} lessonName - examples: "Grid", "Containers"
 * @property {string} lessonCategory - examples: "Editor X Essentials", "Design & Layouting"
 * @property {string} feedback - textual feedback the user wrote
 * @property {string} response - users vote. "Yes"/"No"/"Kind of"
 * @property {string} sourcePage - the page from which the users opened the lesson. examples: all lessons page, home page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademy20LessonViewVoteForALessonParams>} LogObject<editorXAcademy20LessonViewVoteForALessonParams>
 */
export function editorXAcademy20LessonViewVoteForALesson(params) {
    return { evid: 2108, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfEditorXAcademy20EditorXEntryPointClick' event (evid: 2109)
 *
 * Event description: Triggered when a user clicks on one of the entry points to Editor-X
 *
 * @param {copyOfEditorXAcademy20EditorXEntryPointClickParams} params - The parameters for this event
 * @property {string} entryPointName - "Start now"/"Open editor"/'Start create"
 * @property {string} sourcePage - the page from which the users clicked the entry point. homepage, lessons name if from a lesson page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<copyOfEditorXAcademy20EditorXEntryPointClickParams>} LogObject<copyOfEditorXAcademy20EditorXEntryPointClickParams>
 */
export function copyOfEditorXAcademy20EditorXEntryPointClick(params) {
    return { evid: 2109, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyMenuNavigation' event (evid: 2110)
 *
 * Event description: Triggered when a user clicks on one of the tabs in the menu navigation
 *
 * @param {editorXAcademyMenuNavigationParams} params - The parameters for this event
 * @property {string} tab_name - name of the tab
 * @property {string} level - tab/sub_tab/...
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyMenuNavigationParams>} LogObject<editorXAcademyMenuNavigationParams>
 */
export function editorXAcademyMenuNavigation(params) {
    return { evid: 2110, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfEditorXAcademyMenuNavigation' event (evid: 2111)
 *
 * Event description: Triggered when a user answer to the helpful question at the end of the lesson
 *
 * @param {copyOfEditorXAcademyMenuNavigationParams} params - The parameters for this event
 * @property {string} lesson_category - lesson_category
 * @property {string} lesson_name - lesson_name
 * @property {string} feedback - feedback
 * @property {string} vote_choice - vote_choice
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<copyOfEditorXAcademyMenuNavigationParams>} LogObject<copyOfEditorXAcademyMenuNavigationParams>
 */
export function copyOfEditorXAcademyMenuNavigation(params) {
    return { evid: 2111, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyCtaClick' event (evid: 2112)
 *
 * Event description: Triggered when the user clicks on one of the CTAs in the academy
 *
 * @param {editorXAcademyCtaClickParams} params - The parameters for this event
 * @property {string} redirection - redirection
 * @property {string} cta_loc - cta_loc
 * @property {string} cta_name - name of the cta
 * @property {string} source_page - page of the cta
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyCtaClickParams>} LogObject<editorXAcademyCtaClickParams>
 */
export function editorXAcademyCtaClick(params) {
    return { evid: 2112, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyNextVideosLessons' event (evid: 2113)
 *
 * Event description: Triggered when the user clicks on the next resource proposed after watching video/lesson
 *
 * @param {editorXAcademyNextVideosLessonsParams} params - The parameters for this event
 * @property {string} lesson_category - lesson_category
 * @property {string} lesson_name - lesson_name
 * @property {string} cta_name - cta_name
 * @property {string} source_page - source_page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyNextVideosLessonsParams>} LogObject<editorXAcademyNextVideosLessonsParams>
 */
export function editorXAcademyNextVideosLessons(params) {
    return { evid: 2113, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyOpenEditor' event (evid: 2114)
 *
 * Event description: Triggered when the user clicks on one of the CTA which redirects him to the editor builder
 *
 * @param {editorXAcademyOpenEditorParams} params - The parameters for this event
 * @property {string} lesson_category - category of the lesson
 * @property {string} lesson_name - name of the lesson
 * @property {string} cta_name - name of the cta
 * @property {string} artist_name - for design feature page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyOpenEditorParams>} LogObject<editorXAcademyOpenEditorParams>
 */
export function editorXAcademyOpenEditor(params) {
    return { evid: 2114, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyOpenDashboard' event (evid: 2115)
 *
 * Event description: Triggered when the user clicks on one of the CTA which redirects him to the dashboard
 *
 * @param {editorXAcademyOpenDashboardParams} params - The parameters for this event
 * @property {string} lesson_category - category of the lesson
 * @property {string} lesson_name - lesson_name
 * @property {string} cta_name - name of the cta
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyOpenDashboardParams>} LogObject<editorXAcademyOpenDashboardParams>
 */
export function editorXAcademyOpenDashboard(params) {
    return { evid: 2115, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademyTryExercise' event (evid: 2116)
 *
 * Event description: Triggered when the user clicks on 'try exercise' at the end of the lesson
 *
 * @param {editorXAcademyTryExerciseParams} params - The parameters for this event
 * @property {string} lesson_category - category of the lesson
 * @property {string} lesson_name - name of the lesson
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademyTryExerciseParams>} LogObject<editorXAcademyTryExerciseParams>
 */
export function editorXAcademyTryExercise(params) {
    return { evid: 2116, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorXAcademySearchBar' event (evid: 2117)
 *
 * Event description: Triggered when the user uses the search bar
 *
 * @param {editorXAcademySearchBarParams} params - The parameters for this event
 * @property {string} searched_text - text entered in the search bar
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<editorXAcademySearchBarParams>} LogObject<editorXAcademySearchBarParams>
 */
export function editorXAcademySearchBar(params) {
    return { evid: 2117, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarPlayVideoClick' event (evid: 2200)
 *
 * Event description: Triggered when a user clicks "play" on one of the videos in the webinar.
 *
 * @param {webinarPlayVideoClickParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarPlayVideoClickParams>} LogObject<webinarPlayVideoClickParams>
 */
export function webinarPlayVideoClick(params) {
    return { evid: 2200, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarVideoViewWatchedFirst3Seconds' event (evid: 2201)
 *
 * Event description: Triggered when a user watches first 3 seconds of the video
 *
 * @param {webinarVideoViewWatchedFirst3SecondsParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarVideoViewWatchedFirst3SecondsParams>} LogObject<webinarVideoViewWatchedFirst3SecondsParams>
 */
export function webinarVideoViewWatchedFirst3Seconds(params) {
    return { evid: 2201, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarVideoViewWatched50OfVideoLength' event (evid: 2202)
 *
 * Event description: Triggered when a user watches 50% of Video Length
 *
 * @param {webinarVideoViewWatched50OfVideoLengthParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarVideoViewWatched50OfVideoLengthParams>} LogObject<webinarVideoViewWatched50OfVideoLengthParams>
 */
export function webinarVideoViewWatched50OfVideoLength(params) {
    return { evid: 2202, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarVideoViewWatched90OfVideoLength' event (evid: 2203)
 *
 * Event description: Triggered when a user watches 90% of Video Length
 *
 * @param {webinarVideoViewWatched90OfVideoLengthParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} sourcePage - the page from which the users clicked on "play" button. examples: homepage, video library, name of lesson page ("Grid", for example).
 * @property {string} videoName - examples: "Grid", "Containers"
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarVideoViewWatched90OfVideoLengthParams>} LogObject<webinarVideoViewWatched90OfVideoLengthParams>
 */
export function webinarVideoViewWatched90OfVideoLength(params) {
    return { evid: 2203, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarFormForLearningTopic' event (evid: 2204)
 *
 * Event description: Triggered when the user submits the form 'What topic would you love to learn about next?"
 *
 * @param {webinarFormForLearningTopicParams} params - The parameters for this event
 * @property {string} topic_name - topic entered in the form
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarFormForLearningTopicParams>} LogObject<webinarFormForLearningTopicParams>
 */
export function webinarFormForLearningTopic(params) {
    return { evid: 2204, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesTabClicked' event (evid: 2400)
 *
 * Event description: Click on one of the tabs in the navigation bar
 *
 * @param {designFeaturesTabClickedParams} params - The parameters for this event
 * @property {string} tab_name - user clicked on one of the tab
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesTabClickedParams>} LogObject<designFeaturesTabClickedParams>
 */
export function designFeaturesTabClicked(params) {
    return { evid: 2400, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesStartCreatingClicked' event (evid: 2401)
 *
 * Event description: Click on the ‘start creating’ button
 *
 * @param {designFeaturesStartCreatingClickedParams} params - The parameters for this event
 * @property {string} tab_name - user clicked on one of the tabs
 * @property {string} cta_loc - grid, top, down
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesStartCreatingClickedParams>} LogObject<designFeaturesStartCreatingClickedParams>
 */
export function designFeaturesStartCreatingClicked(params) {
    return { evid: 2401, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesClickEntryPointsToAcademyx' event (evid: 2402)
 *
 * Event description: Click on one of the entry points to AcademyX.
 * 'Learn more', 'watch video',  'view lesson'..
 *
 * @param {designFeaturesClickEntryPointsToAcademyxParams} params - The parameters for this event
 * @property {string} lesson_category - category of the lesson
 * @property {string} tab_name - name of the current tab
 * @property {string} lesson_name - name of the lesson
 * @property {string} cta_loc - grid, top, down..
 * @property {string} button_name - name of the button
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesClickEntryPointsToAcademyxParams>} LogObject<designFeaturesClickEntryPointsToAcademyxParams>
 */
export function designFeaturesClickEntryPointsToAcademyx(params) {
    return { evid: 2402, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesBannerCliked' event (evid: 2403)
 *
 * Event description: The user clicked on the banner
 *
 * @param {designFeaturesBannerClikedParams} params - The parameters for this event
 * @property {string} tab_name - current tab
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesBannerClikedParams>} LogObject<designFeaturesBannerClikedParams>
 */
export function designFeaturesBannerCliked(params) {
    return { evid: 2403, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesOpenEditor' event (evid: 2404)
 *
 * Event description: User clicks on 'Try it out' from the design features page
 *
 * @param {designFeaturesOpenEditorParams} params - The parameters for this event
 * @property {string} tab_name - current tab
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesOpenEditorParams>} LogObject<designFeaturesOpenEditorParams>
 */
export function designFeaturesOpenEditor(params) {
    return { evid: 2404, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesStartNavigating' event (evid: 2405)
 *
 * Event description: The user started to navigate on the current tab
 *
 * @param {designFeaturesStartNavigatingParams} params - The parameters for this event
 * @property {string} tab_name - current tab
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesStartNavigatingParams>} LogObject<designFeaturesStartNavigatingParams>
 */
export function designFeaturesStartNavigating(params) {
    return { evid: 2405, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designFeaturesFinishNavigating' event (evid: 2406)
 *
 * Event description: The user scrolls down until the end of the page
 *
 * @param {designFeaturesFinishNavigatingParams} params - The parameters for this event
 * @property {string} tab_name - current tab
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designFeaturesFinishNavigatingParams>} LogObject<designFeaturesFinishNavigatingParams>
 */
export function designFeaturesFinishNavigating(params) {
    return { evid: 2406, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationStartCollaborating' event (evid: 2501)
 *
 * Event description: The user clicked on the button 'Start Collaborating'
 *
 * @param {collaborationStartCollaboratingParams} params - The parameters for this event
 * @property {string} cta_loc - location of the button
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationStartCollaboratingParams>} LogObject<collaborationStartCollaboratingParams>
 */
export function collaborationStartCollaborating(params) {
    return { evid: 2501, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationClickOnWatchVideoTutorial' event (evid: 2502)
 *
 * Event description: User clicks on 'watch video tutorial'
 *
 * @param {collaborationClickOnWatchVideoTutorialParams} params - The parameters for this event
 * @property {string} video_name - name of the video
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationClickOnWatchVideoTutorialParams>} LogObject<collaborationClickOnWatchVideoTutorialParams>
 */
export function collaborationClickOnWatchVideoTutorial(params) {
    return { evid: 2502, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationVideoViewWatched50OfVideoLength' event (evid: 2503)
 *
 * Event description: Triggered when a user watches 50% of Video Length
 *
 * @param {collaborationVideoViewWatched50OfVideoLengthParams} params - The parameters for this event
 * @property {string} video_name - video_name
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationVideoViewWatched50OfVideoLengthParams>} LogObject<collaborationVideoViewWatched50OfVideoLengthParams>
 */
export function collaborationVideoViewWatched50OfVideoLength(params) {
    return { evid: 2503, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationVideoViewWatched90OfVideoLength' event (evid: 2504)
 *
 * Event description: Triggered when a user watches 90% of Video Length
 *
 * @param {collaborationVideoViewWatched90OfVideoLengthParams} params - The parameters for this event
 * @property {string} video_name - name of the video
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationVideoViewWatched90OfVideoLengthParams>} LogObject<collaborationVideoViewWatched90OfVideoLengthParams>
 */
export function collaborationVideoViewWatched90OfVideoLength(params) {
    return { evid: 2504, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationCtaClicks' event (evid: 2505)
 *
 * Event description: User clicks on one of the cta
 *
 * @param {collaborationCtaClicksParams} params - The parameters for this event
 * @property {string} cta_name - ex: Get started, Start Creating
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationCtaClicksParams>} LogObject<collaborationCtaClicksParams>
 */
export function collaborationCtaClicks(params) {
    return { evid: 2505, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationStartNavigating' event (evid: 2506)
 *
 * Event description: The user started navigating on the page
 *
 * @param {collaborationStartNavigatingParams} params - The parameters for this event
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationStartNavigatingParams>} LogObject<collaborationStartNavigatingParams>
 */
export function collaborationStartNavigating(params) {
    return { evid: 2506, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationFinishNavigating' event (evid: 2507)
 *
 * Event description: The user scrolls down until the end of the page
 *
 * @param {collaborationFinishNavigatingParams} params - The parameters for this event
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationFinishNavigatingParams>} LogObject<collaborationFinishNavigatingParams>
 */
export function collaborationFinishNavigating(params) {
    return { evid: 2507, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collaborationVideoViewWatched3SecOfVideo' event (evid: 2508)
 *
 * Event description: Triggered when a user watches 3sec of the video
 *
 * @param {collaborationVideoViewWatched3SecOfVideoParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of video in seconds
 * @property {string} video_name - name of the video
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<collaborationVideoViewWatched3SecOfVideoParams>} LogObject<collaborationVideoViewWatched3SecOfVideoParams>
 */
export function collaborationVideoViewWatched3SecOfVideo(params) {
    return { evid: 2508, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designSNewWaveStartCreating' event (evid: 2601)
 *
 * Event description: User clicks on start creating button
 *
 * @param {designSNewWaveStartCreatingParams} params - The parameters for this event
 * @property {string} cta_loc - top, down, banner
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designSNewWaveStartCreatingParams>} LogObject<designSNewWaveStartCreatingParams>
 */
export function designSNewWaveStartCreating(params) {
    return { evid: 2601, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designSNewWaveSubscribe' event (evid: 2602)
 *
 * Event description: User clicks on subscribe button
 *
 * @param {designSNewWaveSubscribeParams} params - The parameters for this event
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designSNewWaveSubscribeParams>} LogObject<designSNewWaveSubscribeParams>
 */
export function designSNewWaveSubscribe(params) {
    return { evid: 2602, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designSNewWaveWatchVideo' event (evid: 2603)
 *
 * Event description: User clicks on 'play video'
 *
 * @param {designSNewWaveWatchVideoParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of the video
 * @property {string} designer_name - name of the designer
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designSNewWaveWatchVideoParams>} LogObject<designSNewWaveWatchVideoParams>
 */
export function designSNewWaveWatchVideo(params) {
    return { evid: 2603, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'designSNewWaveVideoViewWatched50OfVideoLength' event (evid: 2604)
 *
 * Event description: Triggered when a user watches 50% of Video Length
 *
 * @param {designSNewWaveVideoViewWatched50OfVideoLengthParams} params - The parameters for this event
 * @property {number} fullVideoLength - length of the video
 * @property {string} designer_name - name of the designer
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<designSNewWaveVideoViewWatched50OfVideoLengthParams>} LogObject<designSNewWaveVideoViewWatched50OfVideoLengthParams>
 */
export function designSNewWaveVideoViewWatched50OfVideoLength(params) {
    return { evid: 2604, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shapingDesignClickOrangeSticky' event (evid: 2700)
 *
 * Event description: Click on orange sticky from shaping design page.
 *
 * @param {shapingDesignClickOrangeStickyParams} params - The parameters for this event
 * @property {string} article_name - The name of the article from where the user comes
 * @property {Url} origin_url - The origin URL the user comes from
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<shapingDesignClickOrangeStickyParams>} LogObject<shapingDesignClickOrangeStickyParams>
 */
export function shapingDesignClickOrangeSticky(params) {
    return { evid: 2700, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ctaClick' event (evid: 2801)
 *
 * Event description: Triggered when a user clicks on a CTA button on a landing page.
 * To know which button a user clicked check field cta_name.
 *
 * @param {ctaClickParams} params - The parameters for this event
 * @property {string} cta_name - The specific button that was clicked, for example: start_creating, watch_demo
 * @property {Url} app_url - the web page where the button is located
 * @property {string} lp_name - name of the landing page, ex: startcreating, prowebsites, webcreation
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<ctaClickParams>} LogObject<ctaClickParams>
 */
export function ctaClick(params) {
    return { evid: 2801, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoViewWatched10OfVideoLength' event (evid: 2802)
 *
 * Event description: Video View - Watched  X% of Video Length.
 *
 * @param {videoViewWatched10OfVideoLengthParams} params - The parameters for this event
 * @property {number} percent_watched - percent of the video that has been watched, eg watched 90% of video
 * @property {string} video_name - ex: demo_lp
 * @property {Url} app_url - the web page where the video is located
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<videoViewWatched10OfVideoLengthParams>} LogObject<videoViewWatched10OfVideoLengthParams>
 */
export function videoViewWatched10OfVideoLength(params) {
    return { evid: 2802, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scrollDownToTheBottomOfThePage' event (evid: 2803)
 *
 * Event description: event is fired when a user scrolls down to the bottom of the page
 *
 * @param {scrollDownToTheBottomOfThePageParams} params - The parameters for this event
 * @property {string} lp_name - name of the landing page
 * @property {Url} app_url - app_url
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<scrollDownToTheBottomOfThePageParams>} LogObject<scrollDownToTheBottomOfThePageParams>
 */
export function scrollDownToTheBottomOfThePage(params) {
    return { evid: 2803, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signupToWebinar' event (evid: 2900)
 *
 * Event description: The user reaches the success page after registering for the webinar
 *
 * @param {signupToWebinarParams} params - The parameters for this event
 * @property {string} brand - EditorX
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<signupToWebinarParams>} LogObject<signupToWebinarParams>
 */
export function signupToWebinar(params) {
    return { evid: 2900, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarCtaClick' event (evid: 2901)
 *
 * Event description: Triggered when the user clicks on one of the ctas
 *
 * @param {webinarCtaClickParams} params - The parameters for this event
 * @property {string} redirection - url where the user is redirected
 * @property {string} cta_name - name of the cta
 * @property {string} input_text - input content
 * @property {string} cta_section - name of the section
 * @property {string} source_page - source_page
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarCtaClickParams>} LogObject<webinarCtaClickParams>
 */
export function webinarCtaClick(params) {
    return { evid: 2901, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarSuccessfullySignupToWebinar' event (evid: 2902)
 *
 * Event description: the user successfully registered for the webinar
 *
 * @param {webinarSuccessfullySignupToWebinarParams} params - The parameters for this event
 * @property {string} webinar_date - name of the section
 * @property {string} webinar_name - name of the cta
 * @property {string} type - input_text
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarSuccessfullySignupToWebinarParams>} LogObject<webinarSuccessfullySignupToWebinarParams>
 */
export function webinarSuccessfullySignupToWebinar(params) {
    return { evid: 2902, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarCommunityDiscussion' event (evid: 2903)
 *
 * Event description: User clicks on either  'community discussion' or 'general discussions' and selects one value
 *
 * @param {webinarCommunityDiscussionParams} params - The parameters for this event
 * @property {string} cta_loc - cta_loc
 * @property {string} value_selected - value selected
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarCommunityDiscussionParams>} LogObject<webinarCommunityDiscussionParams>
 */
export function webinarCommunityDiscussion(params) {
    return { evid: 2903, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarSearchBar' event (evid: 2904)
 *
 * Event description: The user uses the search bar on the webinar page
 *
 * @param {webinarSearchBarParams} params - The parameters for this event
 * @property {string} searched_text - searched_text
 * @property {string} url - url
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} isSg - site created by site generator
 * @property {string} builderVersion - builder used version
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<webinarSearchBarParams>} LogObject<webinarSearchBarParams>
 */
export function webinarSearchBar(params) {
    return { evid: 2904, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enrollSuccess' event (evid: 3100)
 *
 * Event description: user signup to course success
 *
 * @param {enrollSuccessParams} params - The parameters for this event
 * @property {string} source - the source from where the user comes
 * @property {DateTime} course_date - The date of the given course
 * @property {boolean} for_a_client - True/False
 * @property {string} service_title - service_title
 * @property {number} num_team_members_signup - # of team members signed up
 * @property {string} num_edix_sites_built - Num of Editor X sites built
 * @property {string} team_size - size of the team
 * @property {string} service_id - service_id
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<enrollSuccessParams>} LogObject<enrollSuccessParams>
 */
export function enrollSuccess(params) {
    return { evid: 3100, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'joinClassClick' event (evid: 3101)
 *
 * Event description: when a user clicks "join class" button before zoom
 *
 * @param {joinClassClickParams} params - The parameters for this event
 * @property {string} source - the source from where the user comes
 * @property {DateTime} course_date - The date of the given course
 * @property {boolean} for_a_client - True/False
 * @property {number} session_number - number of the session they joined (there are 2 sessions for each service)
 * @property {string} service_title - service_title
 * @property {number} num_team_members_signup - # of team members signed up
 * @property {string} num_edix_sites_built - Num of Editor X sites built
 * @property {string} team_size - size of the team
 * @property {string} service_id - service_id
 * @property {string} working_mode - This field indicates the working mode in which the user performed an action (desktop/mobile)
 * @property {number} zoom_value - zoom value upon action
 * @property {boolean} isAi
 * @property {string} editor_view_mode - This field indicates the view mode in which the user performed an action (desktop/mobile)
 * @property {boolean} is_custom_template - builder used version
 * @property {boolean} isAiSiteCreation - true - user created site using AI Site Creation flow; false- site was created by templates flow
 * @return {LogObject<joinClassClickParams>} LogObject<joinClassClickParams>
 */
export function joinClassClick(params) {
    return { evid: 3101, src: 110, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixLearnCertificationGenericEvent' event (evid: 281)
 *
 * Event description: The event is fired on each step in the new Wix Studio certifications
 *
 * @param {wixLearnCertificationGenericEventParams} params - The parameters for this event
 * @property {string} action_name - Started / Submitted / Results
 * @property {number} score - The score of the task/test
 * @property {GUID} assignment_id - ID of the assignment, unique per assignment_name
 * @property {boolean} is_user_valid - Is the user valid
 * @property {string} assignment_type - Project / Task / Test
 * @property {string} result_status - Pass/Fail
 * @property {string} assignment_name - Meaningful name of the assignment
 * @property {string} certification_name - Meaningful name of the certification
 * @property {GUID} submitted_msid - id of the submitted site
 * @property {GUID} certification_id - ID of the certification, unique per certification_name
 * @property {number} attempt - The number of attempts of the user at a given stage
 * @property {GUID} applicant_uuid - id of the applicant
 * @return {LogObject<wixLearnCertificationGenericEventParams>} LogObject<wixLearnCertificationGenericEventParams>
 */
export function wixLearnCertificationGenericEvent(params) {
    return { evid: 281, src: 134, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileScreenRotationSrc19Evid2008' event (evid: 2008)
 *
 * Event description: The act of rotating the phone to shift from portrait mode to landscape and vice versa
 *
 * @param {mobileScreenRotationSrc19Evid2008Params} params - The parameters for this event
 * @property {string} rotate_to_mode_name - Landscape, Portrait
 * @property {string} rotate_to_mode_id - Portrait = 1, Landscape = 2
 * @return {LogObject<mobileScreenRotationSrc19Evid2008Params>} LogObject<mobileScreenRotationSrc19Evid2008Params>
 */
export function mobileScreenRotationSrc19Evid2008(params) {
    return { evid: 2008, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileDisplayOrientationOnPageLoadSrc19Evid2009' event (evid: 2009)
 *
 * Event description: Indicates if the phone is used in vertical (Portrait) or horizontal (Landscape) orientation upon page load
 *
 * @param {mobileDisplayOrientationOnPageLoadSrc19Evid2009Params} params - The parameters for this event
 * @property {string} initial_orientation_name - Landscape, Portrait
 * @property {string} initial_orientation_id - Portrait = 1, Landscape = 2
 * @return {LogObject<mobileDisplayOrientationOnPageLoadSrc19Evid2009Params>} LogObject<mobileDisplayOrientationOnPageLoadSrc19Evid2009Params>
 */
export function mobileDisplayOrientationOnPageLoadSrc19Evid2009(params) {
    return { evid: 2009, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackOpenComments' event (evid: 100)
 *
 * Event description: editor feedback -> open comments.
 *
 * @param {editorFeedbackOpenCommentsParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackOpenCommentsParams>} LogObject<editorFeedbackOpenCommentsParams>
 */
export function editorFeedbackOpenComments(params) {
    return { evid: 100, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userOpensTheGetFeedback' event (evid: 1001)
 *
 * Event description: iFrame request for get feedback
 *
 * @param {userOpensTheGetFeedbackParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<userOpensTheGetFeedbackParams>} LogObject<userOpensTheGetFeedbackParams>
 */
export function userOpensTheGetFeedback(params) {
    return { evid: 1001, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorOpensTheAddComments' event (evid: 1002)
 *
 * Event description: Visitor requests the add comments page
 *
 * @param {visitorOpensTheAddCommentsParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} visitorid - {}
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<visitorOpensTheAddCommentsParams>} LogObject<visitorOpensTheAddCommentsParams>
 */
export function visitorOpensTheAddComments(params) {
    return { evid: 1002, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUnreadCommentCount' event (evid: 1004)
 *
 * Event description: get unread comment count
 *
 * @param {getUnreadCommentCountParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {number} unreadCount - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<getUnreadCommentCountParams>} LogObject<getUnreadCommentCountParams>
 */
export function getUnreadCommentCount(params) {
    return { evid: 1004, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUserComments' event (evid: 1005)
 *
 * Event description: get user Comments
 *
 * @param {getUserCommentsParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<getUserCommentsParams>} LogObject<getUserCommentsParams>
 */
export function getUserComments(params) {
    return { evid: 1005, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getVisitorComments' event (evid: 1006)
 *
 * Event description: get visitor Comments
 *
 * @param {getVisitorCommentsParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<getVisitorCommentsParams>} LogObject<getVisitorCommentsParams>
 */
export function getVisitorComments(params) {
    return { evid: 1006, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addVisitorComment' event (evid: 1007)
 *
 * Event description: add visitor comment
 *
 * @param {addVisitorCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} uuid - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<addVisitorCommentParams>} LogObject<addVisitorCommentParams>
 */
export function addVisitorComment(params) {
    return { evid: 1007, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userDeleteComment' event (evid: 1008)
 *
 * Event description: user delete comment
 *
 * @param {userDeleteCommentParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<userDeleteCommentParams>} LogObject<userDeleteCommentParams>
 */
export function userDeleteComment(params) {
    return { evid: 1008, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorDeleteComment' event (evid: 1009)
 *
 * Event description: visitor delete comment
 *
 * @param {visitorDeleteCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} uuid - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<visitorDeleteCommentParams>} LogObject<visitorDeleteCommentParams>
 */
export function visitorDeleteComment(params) {
    return { evid: 1009, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackCloseComments' event (evid: 101)
 *
 * Event description: editor feedback -> close comments.
 *
 * @param {editorFeedbackCloseCommentsParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackCloseCommentsParams>} LogObject<editorFeedbackCloseCommentsParams>
 */
export function editorFeedbackCloseComments(params) {
    return { evid: 101, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorUpdatedComment' event (evid: 1010)
 *
 * Event description: visitor updated comment
 *
 * @param {visitorUpdatedCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} uuid - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<visitorUpdatedCommentParams>} LogObject<visitorUpdatedCommentParams>
 */
export function visitorUpdatedComment(params) {
    return { evid: 1010, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateCommentStatusByUser' event (evid: 1011)
 *
 * Event description: visitor updated comment
 *
 * @param {updateCommentStatusByUserParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<updateCommentStatusByUserParams>} LogObject<updateCommentStatusByUserParams>
 */
export function updateCommentStatusByUser(params) {
    return { evid: 1011, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateFeedbackOnSite' event (evid: 1012)
 *
 * Event description: activate feedback on site
 *
 * @param {activateFeedbackOnSiteParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<activateFeedbackOnSiteParams>} LogObject<activateFeedbackOnSiteParams>
 */
export function activateFeedbackOnSite(params) {
    return { evid: 1012, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackLink' event (evid: 1013)
 *
 * Event description: get feedback link
 *
 * @param {getFeedbackLinkParams} params - The parameters for this event
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<getFeedbackLinkParams>} LogObject<getFeedbackLinkParams>
 */
export function getFeedbackLink(params) {
    return { evid: 1013, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendEmailToSiteOwner' event (evid: 1014)
 *
 * Event description: send email to site owner
 *
 * @param {sendEmailToSiteOwnerParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} uuid - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<sendEmailToSiteOwnerParams>} LogObject<sendEmailToSiteOwnerParams>
 */
export function sendEmailToSiteOwner(params) {
    return { evid: 1014, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userOpenSharePage' event (evid: 1015)
 *
 * Event description: User open share page
 *
 * @param {userOpenSharePageParams} params - The parameters for this event
 * @property {boolean} shared - {true;false}
 * @property {GUID} uuid - {}
 * @property {number} unreadCount - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metaSiteId - {}
 * @return {LogObject<userOpenSharePageParams>} LogObject<userOpenSharePageParams>
 */
export function userOpenSharePage(params) {
    return { evid: 1015, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackShareButton' event (evid: 102)
 *
 * Event description: editor feedback -> share button.
 *
 * @param {editorFeedbackShareButtonParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackShareButtonParams>} LogObject<editorFeedbackShareButtonParams>
 */
export function editorFeedbackShareButton(params) {
    return { evid: 102, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackHideComments' event (evid: 103)
 *
 * Event description: editor feedback -> hide comments.
 *
 * @param {editorFeedbackHideCommentsParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackHideCommentsParams>} LogObject<editorFeedbackHideCommentsParams>
 */
export function editorFeedbackHideComments(params) {
    return { evid: 103, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackOpenComment' event (evid: 104)
 *
 * Event description: editor feedback -> open comment.
 *
 * @param {editorFeedbackOpenCommentParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} c1 - origin
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackOpenCommentParams>} LogObject<editorFeedbackOpenCommentParams>
 */
export function editorFeedbackOpenComment(params) {
    return { evid: 104, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackDeleteComment' event (evid: 105)
 *
 * Event description: editor feedback -> delete comment.
 *
 * @param {editorFeedbackDeleteCommentParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackDeleteCommentParams>} LogObject<editorFeedbackDeleteCommentParams>
 */
export function editorFeedbackDeleteComment(params) {
    return { evid: 105, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackShowHideCombobox' event (evid: 106)
 *
 * Event description: viewer feedback -> show/hide combobox.
 *
 * @param {viewerFeedbackShowHideComboboxParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {boolean} i1 - is_checked
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackShowHideComboboxParams>} LogObject<viewerFeedbackShowHideComboboxParams>
 */
export function viewerFeedbackShowHideCombobox(params) {
    return { evid: 106, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackAddButton' event (evid: 201)
 *
 * Event description: viewer feedback -> add button.
 *
 * @param {viewerFeedbackAddButtonParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackAddButtonParams>} LogObject<viewerFeedbackAddButtonParams>
 */
export function viewerFeedbackAddButton(params) {
    return { evid: 201, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackDeleteComment' event (evid: 202)
 *
 * Event description: viewer feedback -> delete comment.
 *
 * @param {viewerFeedbackDeleteCommentParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackDeleteCommentParams>} LogObject<viewerFeedbackDeleteCommentParams>
 */
export function viewerFeedbackDeleteComment(params) {
    return { evid: 202, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackSubmitButton' event (evid: 203)
 *
 * Event description: viewer feedback -> submit button.
 *
 * @param {viewerFeedbackSubmitButtonParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackSubmitButtonParams>} LogObject<viewerFeedbackSubmitButtonParams>
 */
export function viewerFeedbackSubmitButton(params) {
    return { evid: 203, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackSendFeedback' event (evid: 204)
 *
 * Event description: viewer feedback -> send feedback.
 *
 * @param {viewerFeedbackSendFeedbackParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {number} i1 - cnt_comments
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {number} i2 - got_name
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackSendFeedbackParams>} LogObject<viewerFeedbackSendFeedbackParams>
 */
export function viewerFeedbackSendFeedback(params) {
    return { evid: 204, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewerFeedbackEmotion' event (evid: 205)
 *
 * Event description: viewer feedback -> emotion.
 *
 * @param {viewerFeedbackEmotionParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {boolean} i1 - is_happy
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<viewerFeedbackEmotionParams>} LogObject<viewerFeedbackEmotionParams>
 */
export function viewerFeedbackEmotion(params) {
    return { evid: 205, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackGotItButton' event (evid: 206)
 *
 * Event description: editor feedback -> got it button.
 *
 * @param {editorFeedbackGotItButtonParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} __cookies_prefix__wixClient - ignored_wix_client_container
 * @property {string} __cookies_prefix___wixUIDX - ignore_user_id_container
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackGotItButtonParams>} LogObject<editorFeedbackGotItButtonParams>
 */
export function editorFeedbackGotItButton(params) {
    return { evid: 206, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorFeedbackClickOnWixAds' event (evid: 207)
 *
 * Event description: editor feedback -> click on wix ads.
 *
 * @param {editorFeedbackClickOnWixAdsParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} c1 - origin
 * @property {GUID} uid - uuid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<editorFeedbackClickOnWixAdsParams>} LogObject<editorFeedbackClickOnWixAdsParams>
 */
export function editorFeedbackClickOnWixAds(params) {
    return { evid: 207, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstGetFeedbackDialogLoaded' event (evid: 301)
 *
 * Event description: first feedback dialog loaded
 *
 * @param {firstGetFeedbackDialogLoadedParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {boolean} is_share - {true;false}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<firstGetFeedbackDialogLoadedParams>} LogObject<firstGetFeedbackDialogLoadedParams>
 */
export function firstGetFeedbackDialogLoaded(params) {
    return { evid: 301, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondGetFeedbackDialogLoaded' event (evid: 302)
 *
 * Event description: Second feedback dialog loaded
 *
 * @param {secondGetFeedbackDialogLoadedParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {number} unreadCount - {number of comments unread}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<secondGetFeedbackDialogLoadedParams>} LogObject<secondGetFeedbackDialogLoadedParams>
 */
export function secondGetFeedbackDialogLoaded(params) {
    return { evid: 302, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyLinkFromDialog' event (evid: 303)
 *
 * Event description: pressing 'copy' on share dialog
 *
 * @param {copyLinkFromDialogParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<copyLinkFromDialogParams>} LogObject<copyLinkFromDialogParams>
 */
export function copyLinkFromDialog(params) {
    return { evid: 303, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareOnFaceebook' event (evid: 304)
 *
 * Event description: pressing share facebook
 *
 * @param {shareOnFaceebookParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<shareOnFaceebookParams>} LogObject<shareOnFaceebookParams>
 */
export function shareOnFaceebook(params) {
    return { evid: 304, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendAnEmailButton' event (evid: 305)
 *
 * Event description: pressing send an email
 *
 * @param {sendAnEmailButtonParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<sendAnEmailButtonParams>} LogObject<sendAnEmailButtonParams>
 */
export function sendAnEmailButton(params) {
    return { evid: 305, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendAShoutout' event (evid: 306)
 *
 * Event description: pressing send a shoutout
 *
 * @param {sendAShoutoutParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<sendAShoutoutParams>} LogObject<sendAShoutoutParams>
 */
export function sendAShoutout(params) {
    return { evid: 306, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'maybeLater' event (evid: 307)
 *
 * Event description: pressing maybe later
 *
 * @param {maybeLaterParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog,got feedback}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<maybeLaterParams>} LogObject<maybeLaterParams>
 */
export function maybeLater(params) {
    return { evid: 307, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'readFeedback' event (evid: 308)
 *
 * Event description: pressing read feedback. only from second dialog
 *
 * @param {readFeedbackParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<readFeedbackParams>} LogObject<readFeedbackParams>
 */
export function readFeedback(params) {
    return { evid: 308, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressingHelp' event (evid: 309)
 *
 * Event description: top right question mark button
 *
 * @param {pressingHelpParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog,got feedback}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<pressingHelpParams>} LogObject<pressingHelpParams>
 */
export function pressingHelp(params) {
    return { evid: 309, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closingDialog' event (evid: 310)
 *
 * Event description: top right X mark of dialog
 *
 * @param {closingDialogParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog,got feedback}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<closingDialogParams>} LogObject<closingDialogParams>
 */
export function closingDialog(params) {
    return { evid: 310, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gotFeedbackDialogLoaded' event (evid: 311)
 *
 * Event description: got feedback dialog loaded
 *
 * @param {gotFeedbackDialogLoadedParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<gotFeedbackDialogLoadedParams>} LogObject<gotFeedbackDialogLoadedParams>
 */
export function gotFeedbackDialogLoaded(params) {
    return { evid: 311, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressReadComments' event (evid: 312)
 *
 * Event description: pressing read comments
 *
 * @param {pressReadCommentsParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<pressReadCommentsParams>} LogObject<pressReadCommentsParams>
 */
export function pressReadComments(params) {
    return { evid: 312, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressShareYourSite' event (evid: 313)
 *
 * Event description: pressing share
 *
 * @param {pressShareYourSiteParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<pressShareYourSiteParams>} LogObject<pressShareYourSiteParams>
 */
export function pressShareYourSite(params) {
    return { evid: 313, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'archiveComment' event (evid: 314)
 *
 * Event description: reading feedback page
 *
 * @param {archiveCommentParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<archiveCommentParams>} LogObject<archiveCommentParams>
 */
export function archiveComment(params) {
    return { evid: 314, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'readingFeedbackPageLoaded' event (evid: 315)
 *
 * Event description: reading feedback page
 *
 * @param {readingFeedbackPageLoadedParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<readingFeedbackPageLoadedParams>} LogObject<readingFeedbackPageLoadedParams>
 */
export function readingFeedbackPageLoaded(params) {
    return { evid: 315, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteComment' event (evid: 316)
 *
 * Event description: reading feedback page
 *
 * @param {deleteCommentParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<deleteCommentParams>} LogObject<deleteCommentParams>
 */
export function deleteComment(params) {
    return { evid: 316, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressingCommentsList' event (evid: 317)
 *
 * Event description: reading feedback page
 *
 * @param {pressingCommentsListParams} params - The parameters for this event
 * @property {boolean} isChecked - {Show resolved: true;false}
 * @property {GUID} site_id - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<pressingCommentsListParams>} LogObject<pressingCommentsListParams>
 */
export function pressingCommentsList(params) {
    return { evid: 317, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressingGoToEditor' event (evid: 318)
 *
 * Event description: reading feedback page
 *
 * @param {pressingGoToEditorParams} params - The parameters for this event
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<pressingGoToEditorParams>} LogObject<pressingGoToEditorParams>
 */
export function pressingGoToEditor(params) {
    return { evid: 318, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userOpenHelp' event (evid: 319)
 *
 * Event description: user press the help (top bar)
 *
 * @param {userOpenHelpParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {GUID} metasiteid - metasite identifier of the edited document
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<userOpenHelpParams>} LogObject<userOpenHelpParams>
 */
export function userOpenHelp(params) {
    return { evid: 319, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'introVideoForFeedbackShown' event (evid: 320)
 *
 * Event description: Intro video for feedback shown
 *
 * @param {introVideoForFeedbackShownParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {boolean} is_share - {true;false}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<introVideoForFeedbackShownParams>} LogObject<introVideoForFeedbackShownParams>
 */
export function introVideoForFeedbackShown(params) {
    return { evid: 320, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'introVideoDialogBoxClosed' event (evid: 321)
 *
 * Event description: Intro video dialog box closed
 *
 * @param {introVideoDialogBoxClosedParams} params - The parameters for this event
 * @property {number} duration - {time in milliseconds)
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - (Start_now;click_outside,click_x}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<introVideoDialogBoxClosedParams>} LogObject<introVideoDialogBoxClosedParams>
 */
export function introVideoDialogBoxClosed(params) {
    return { evid: 321, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnRolesAndPermissionLink' event (evid: 322)
 *
 * Event description: on first share panel will appear a link to go to roles and permissions
 *
 * @param {clickOnRolesAndPermissionLinkParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<clickOnRolesAndPermissionLinkParams>} LogObject<clickOnRolesAndPermissionLinkParams>
 */
export function clickOnRolesAndPermissionLink(params) {
    return { evid: 322, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createTokenStart' event (evid: 323)
 *
 * Event description: triggered when a user presses the share (in order to monitor times)
 *
 * @param {createTokenStartParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<createTokenStartParams>} LogObject<createTokenStartParams>
 */
export function createTokenStart(params) {
    return { evid: 323, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createTokenResponse' event (evid: 324)
 *
 * Event description: triggered when a token was made (for monitoring)
 *
 * @param {createTokenResponseParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<createTokenResponseParams>} LogObject<createTokenResponseParams>
 */
export function createTokenResponse(params) {
    return { evid: 324, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getLinkStart' event (evid: 325)
 *
 * Event description: triggered after token created
 *
 * @param {getLinkStartParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<getLinkStartParams>} LogObject<getLinkStartParams>
 */
export function getLinkStart(params) {
    return { evid: 325, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getLinkResponse' event (evid: 326)
 *
 * Event description: triggered after token 'get link start' done; for monitoring reasons
 *
 * @param {getLinkResponseParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<getLinkResponseParams>} LogObject<getLinkResponseParams>
 */
export function getLinkResponse(params) {
    return { evid: 326, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markShareStart' event (evid: 327)
 *
 * Event description: triggered after 'get link response' ; for monitoring reasons
 *
 * @param {markShareStartParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<markShareStartParams>} LogObject<markShareStartParams>
 */
export function markShareStart(params) {
    return { evid: 327, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markShareResponse' event (evid: 328)
 *
 * Event description: triggered after 'mark share response' done ; for monitoring reasons
 *
 * @param {markShareResponseParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} origin - {first dialog, second dialog}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<markShareResponseParams>} LogObject<markShareResponseParams>
 */
export function markShareResponse(params) {
    return { evid: 328, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'innerEditorFrameLoadedForReadingFeedback' event (evid: 329)
 *
 * Event description: for monitoring reasons. after evid315
 *
 * @param {innerEditorFrameLoadedForReadingFeedbackParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<innerEditorFrameLoadedForReadingFeedbackParams>} LogObject<innerEditorFrameLoadedForReadingFeedbackParams>
 */
export function innerEditorFrameLoadedForReadingFeedback(params) {
    return { evid: 329, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsLoadedForReadingFeedback' event (evid: 330)
 *
 * Event description: document services loaded for frame. for monitoring reasons.
 *
 * @param {dsLoadedForReadingFeedbackParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<dsLoadedForReadingFeedbackParams>} LogObject<dsLoadedForReadingFeedbackParams>
 */
export function dsLoadedForReadingFeedback(params) {
    return { evid: 330, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'innerEditorFrameLoadedForVisitorOpenFeedback' event (evid: 331)
 *
 * Event description: for monitoring reasons. this will be fired after evid 403
 *
 * @param {innerEditorFrameLoadedForVisitorOpenFeedbackParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<innerEditorFrameLoadedForVisitorOpenFeedbackParams>} LogObject<innerEditorFrameLoadedForVisitorOpenFeedbackParams>
 */
export function innerEditorFrameLoadedForVisitorOpenFeedback(params) {
    return { evid: 331, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsLoadedForVisitorOpenFeedback' event (evid: 332)
 *
 * Event description: for monitoring reasons. this will be fired after evid 331
 *
 * @param {dsLoadedForVisitorOpenFeedbackParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<dsLoadedForVisitorOpenFeedbackParams>} LogObject<dsLoadedForVisitorOpenFeedbackParams>
 */
export function dsLoadedForVisitorOpenFeedback(params) {
    return { evid: 332, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorPostCommentFinish' event (evid: 333)
 *
 * Event description: for monitoring reasons. time measured after evid 402
 *
 * @param {visitorPostCommentFinishParams} params - The parameters for this event
 * @property {number} duration - time in ms
 * @property {GUID} visitorId - {}dura
 * @property {GUID} site_id - {}
 * @property {string} text - text in comment
 * @property {string} comment_id - {}
 * @property {string} page_id - {homepage/other}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {boolean} drag_comment - {true;false}
 * @property {string} mode - desktop/mobile
 * @property {number} emoji - {0;1;2;3;4;5}
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorPostCommentFinishParams>} LogObject<visitorPostCommentFinishParams>
 */
export function visitorPostCommentFinish(params) {
    return { evid: 333, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getCommentsFromServerStart' event (evid: 334)
 *
 * Event description: for monitoring reasons
 *
 * @param {getCommentsFromServerStartParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<getCommentsFromServerStartParams>} LogObject<getCommentsFromServerStartParams>
 */
export function getCommentsFromServerStart(params) {
    return { evid: 334, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getCommentsFromServerFinish' event (evid: 335)
 *
 * Event description: for monitoring reasons. measuring times between start and finish of showing get comments
 *
 * @param {getCommentsFromServerFinishParams} params - The parameters for this event
 * @property {number} duration - {}
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - {}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<getCommentsFromServerFinishParams>} LogObject<getCommentsFromServerFinishParams>
 */
export function getCommentsFromServerFinish(params) {
    return { evid: 335, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addComment' event (evid: 401)
 *
 * Event description: Visitor presses 'add comment'
 *
 * @param {addCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<addCommentParams>} LogObject<addCommentParams>
 */
export function addComment(params) {
    return { evid: 401, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorPostComment' event (evid: 402)
 *
 * Event description: finishing adding a comment
 *
 * @param {visitorPostCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} text - text in comment
 * @property {string} comment_id - {}
 * @property {string} page_id - {homepage/other}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {boolean} drag_comment - {true;false}
 * @property {string} mode - desktop/mobile
 * @property {number} emoji - {0;1;2;3;4;5}
 * @property {string} type - {feedback,other products}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorPostCommentParams>} LogObject<visitorPostCommentParams>
 */
export function visitorPostComment(params) {
    return { evid: 402, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorOpenedTheAddCommentPage' event (evid: 403)
 *
 * Event description: add comment page loaded
 *
 * @param {visitorOpenedTheAddCommentPageParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorOpenedTheAddCommentPageParams>} LogObject<visitorOpenedTheAddCommentPageParams>
 */
export function visitorOpenedTheAddCommentPage(params) {
    return { evid: 403, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorOpenedOnMobile' event (evid: 404)
 *
 * Event description: Visitor got the 'desktop only' message on his mobile device
 *
 * @param {visitorOpenedOnMobileParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - {}
 * @property {number} height - Height of client device screen
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} msid - metasite identifier of the edited document
 * @property {number} width - Width of client device screen
 * @return {LogObject<visitorOpenedOnMobileParams>} LogObject<visitorOpenedOnMobileParams>
 */
export function visitorOpenedOnMobile(params) {
    return { evid: 404, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorDeletedComment' event (evid: 406)
 *
 * Event description: visitor deleted comment
 *
 * @param {visitorDeletedCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} comment_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorDeletedCommentParams>} LogObject<visitorDeletedCommentParams>
 */
export function visitorDeletedComment(params) {
    return { evid: 406, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorEditComment' event (evid: 407)
 *
 * Event description: finishing adding a comment
 *
 * @param {visitorEditCommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} text - text in comment
 * @property {string} comment_id - {}
 * @property {string} page_id - {homepage/other}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {boolean} drag_comment - {true,false}
 * @property {string} mode - desktop/mobile
 * @property {number} emoji - {0;1;2;3;4;5}
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorEditCommentParams>} LogObject<visitorEditCommentParams>
 */
export function visitorEditComment(params) {
    return { evid: 407, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorOpenHelp' event (evid: 408)
 *
 * Event description: visitor pressed the help (top bar)
 *
 * @param {visitorOpenHelpParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} mode - {desktop/mobile}
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorOpenHelpParams>} LogObject<visitorOpenHelpParams>
 */
export function visitorOpenHelp(params) {
    return { evid: 408, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'visitorPressingCommentList' event (evid: 409)
 *
 * Event description: comment list on right
 *
 * @param {visitorPressingCommentListParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {GUID} site_id - {}
 * @property {string} user_type - indicates the type of user, pro/regular
 * @property {string} type - {feedback,other products}
 * @property {GUID} esi - esi
 * @property {GUID} msid - metasite identifier of the edited document
 * @return {LogObject<visitorPressingCommentListParams>} LogObject<visitorPressingCommentListParams>
 */
export function visitorPressingCommentList(params) {
    return { evid: 409, src: 32, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersEarningAmountSrc70Evid51' event (evid: 51)
 *
 * Event description: Fires out of a quix job to get every users and payout amount each month
 *
 * @param {usersEarningAmountSrc70Evid51Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {DateTime} dateUpdated - event fire date
 * @property {number} payoutAmount - amount paid to user
 * @return {LogObject<usersEarningAmountSrc70Evid51Params>} LogObject<usersEarningAmountSrc70Evid51Params>
 */
export function usersEarningAmountSrc70Evid51(params) {
    return { evid: 51, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersNextEarningAmountRevshareSrc70Evid52' event (evid: 52)
 *
 * Event description: Fires out of a quix job to get every users and next payout amount each month
 *
 * @param {usersNextEarningAmountRevshareSrc70Evid52Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} payoutAmount - amount paid to user
 * @return {LogObject<usersNextEarningAmountRevshareSrc70Evid52Params>} LogObject<usersNextEarningAmountRevshareSrc70Evid52Params>
 */
export function usersNextEarningAmountRevshareSrc70Evid52(params) {
    return { evid: 52, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioSiteSyntheticEventSrc70Evid55' event (evid: 55)
 *
 * Event description: MSIDs for all studio sites created - Synthetic Event
 *
 * @param {studioSiteSyntheticEventSrc70Evid55Params} params - The parameters for this event
 * @return {LogObject<studioSiteSyntheticEventSrc70Evid55Params>} LogObject<studioSiteSyntheticEventSrc70Evid55Params>
 */
export function studioSiteSyntheticEventSrc70Evid55(params) {
    return { evid: 55, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inactivePartnersRevShareSrc70Evid61' event (evid: 61)
 *
 * Event description: Partner program accounts that didn't create (first owner) new premium in the last year and therefore is not eligible for revshare
 *
 * @param {inactivePartnersRevShareSrc70Evid61Params} params - The parameters for this event
 * @property {string} account_id - account_id from the synthetic event job
 * @property {DateTime} date_updated - event fire date
 * @return {LogObject<inactivePartnersRevShareSrc70Evid61Params>} LogObject<inactivePartnersRevShareSrc70Evid61Params>
 */
export function inactivePartnersRevShareSrc70Evid61(params) {
    return { evid: 61, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'exploreResultsPageGenericClick' event (evid: 1001)
 *
 * Event description: user clicks on one of the buttons in the explore partners results page
 *
 * @param {exploreResultsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} data - the data extracted from the click
 * @property {string} clickType - view partners profile/sort ect.
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - users session in the explore
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<exploreResultsPageGenericClickParams>} LogObject<exploreResultsPageGenericClickParams>
 */
export function exploreResultsPageGenericClick(params) {
    return { evid: 1001, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfExploreResultsPageGenericClick' event (evid: 1002)
 *
 * Event description: user clicks on one of the buttons in the explore partners results page
 *
 * @param {copyOfExploreResultsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} data - the data extracted from the click
 * @property {string} clickType - view partners profile/sort ect.
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - session id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<copyOfExploreResultsPageGenericClickParams>} LogObject<copyOfExploreResultsPageGenericClickParams>
 */
export function copyOfExploreResultsPageGenericClick(params) {
    return { evid: 1002, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersProfilePagePageLoaded' event (evid: 1003)
 *
 * Event description: Fires when the a partners profile page is loaded
 *
 * @param {partnersProfilePagePageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} provider_id - the partners guid
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - session id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<partnersProfilePagePageLoadedParams>} LogObject<partnersProfilePagePageLoadedParams>
 */
export function partnersProfilePagePageLoaded(params) {
    return { evid: 1003, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceHeaderClientGenericClick' event (evid: 1005)
 *
 * Event description: Click on MP Header - Client events
 *
 * @param {marketplaceHeaderClientGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted from the click
 * @property {string} clickType - Name of the button clicked
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} pageName - name of page
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceHeaderClientGenericClickParams>} LogObject<marketplaceHeaderClientGenericClickParams>
 */
export function marketplaceHeaderClientGenericClick(params) {
    return { evid: 1005, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardGenericClick' event (evid: 1006)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectsDashboardGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted
 * @property {string} data - data extracted
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardGenericClickParams>} LogObject<marketplaceProjectsDashboardGenericClickParams>
 */
export function marketplaceProjectsDashboardGenericClick(params) {
    return { evid: 1006, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardLoadPage' event (evid: 1007)
 *
 * Event description: load page event for the marketplace projects dashboard
 *
 * @param {marketplaceProjectsDashboardLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform - The platform the user is using (wix.com/Studio)
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardLoadPageParams>} LogObject<marketplaceProjectsDashboardLoadPageParams>
 */
export function marketplaceProjectsDashboardLoadPage(params) {
    return { evid: 1007, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardGenericClickMobile' event (evid: 1009)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectsDashboardGenericClickMobileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - click data
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardGenericClickMobileParams>} LogObject<marketplaceProjectsDashboardGenericClickMobileParams>
 */
export function marketplaceProjectsDashboardGenericClickMobile(params) {
    return { evid: 1009, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardIframeLoaded' event (evid: 101)
 *
 * Event description: dashboard iframe in dashboard page loaded (wix code poc)
 *
 * @param {dashboardIframeLoadedParams} params - The parameters for this event
 * @property {GUID} guid - {the clients uuid}
 * @property {string} label - {version of dashboard presented}
 * @return {LogObject<dashboardIframeLoadedParams>} LogObject<dashboardIframeLoadedParams>
 */
export function dashboardIframeLoaded(params) {
    return { evid: 101, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageLoadPage' event (evid: 1011)
 *
 * Event description: load page event for a marketplace project page
 *
 * @param {marketplaceProjectPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageLoadPageParams>} LogObject<marketplaceProjectPageLoadPageParams>
 */
export function marketplaceProjectPageLoadPage(params) {
    return { evid: 1011, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageGenericClick' event (evid: 1012)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageGenericClickParams>} LogObject<marketplaceProjectPageGenericClickParams>
 */
export function marketplaceProjectPageGenericClick(params) {
    return { evid: 1012, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageMassage' event (evid: 1013)
 *
 * Event description: fires every time a warning is sent in the marketplace projects dashboard
 *
 * @param {marketplaceProjectPageMassageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} message_type - message type that sen
 * @property {string} job_id - project's job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageMassageParams>} LogObject<marketplaceProjectPageMassageParams>
 */
export function marketplaceProjectPageMassage(params) {
    return { evid: 1013, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceClientSMyProjectsPageLoadPage' event (evid: 1014)
 *
 * Event description: load page event for the client project dashboard page
 *
 * @param {marketplaceClientSMyProjectsPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSMyProjectsPageLoadPageParams>} LogObject<marketplaceClientSMyProjectsPageLoadPageParams>
 */
export function marketplaceClientSMyProjectsPageLoadPage(params) {
    return { evid: 1014, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceClientSMyProjectsPageGenericClick' event (evid: 1015)
 *
 * Event description: Generic click in the marketplace projects in client's dashboard
 *
 * @param {marketplaceClientSMyProjectsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSMyProjectsPageGenericClickParams>} LogObject<marketplaceClientSMyProjectsPageGenericClickParams>
 */
export function marketplaceClientSMyProjectsPageGenericClick(params) {
    return { evid: 1015, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceClientSProjectsPageGenericClick' event (evid: 1016)
 *
 * Event description: Generic click in the marketplace in a client's project place
 *
 * @param {marketplaceClientSProjectsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSProjectsPageGenericClickParams>} LogObject<marketplaceClientSProjectsPageGenericClickParams>
 */
export function marketplaceClientSProjectsPageGenericClick(params) {
    return { evid: 1016, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceClientSProjectPageLoadPage' event (evid: 1017)
 *
 * Event description: load page event for the client project dashboard page
 *
 * @param {marketplaceClientSProjectPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSProjectPageLoadPageParams>} LogObject<marketplaceClientSProjectPageLoadPageParams>
 */
export function marketplaceClientSProjectPageLoadPage(params) {
    return { evid: 1017, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reportAProfessionalFormPageLoadSrc80Evid1018' event (evid: 1018)
 *
 * Event description: Fires when the form Report a professional is loaded
 *
 * @param {reportAProfessionalFormPageLoadSrc80Evid1018Params} params - The parameters for this event
 * @property {string} previousScreen - name of screen the form open from
 * @return {LogObject<reportAProfessionalFormPageLoadSrc80Evid1018Params>} LogObject<reportAProfessionalFormPageLoadSrc80Evid1018Params>
 */
export function reportAProfessionalFormPageLoadSrc80Evid1018(params) {
    return { evid: 1018, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioCustomTemplatesPageGenericClick' event (evid: 1019)
 *
 * Event description: Generic click event in the custom templates page
 *
 * @param {wixStudioCustomTemplatesPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} template_id - the ID of the template
 * @return {LogObject<wixStudioCustomTemplatesPageGenericClickParams>} LogObject<wixStudioCustomTemplatesPageGenericClickParams>
 */
export function wixStudioCustomTemplatesPageGenericClick(params) {
    return { evid: 1019, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHpHpLoaded' event (evid: 102)
 *
 * Event description: User HP was uploaded
 *
 * @param {userHpHpLoadedParams} params - The parameters for this event
 * @return {LogObject<userHpHpLoadedParams>} LogObject<userHpHpLoadedParams>
 */
export function userHpHpLoaded(params) {
    return { evid: 102, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reportAProfessionalFormGenericClickSrc80Evid1020' event (evid: 1020)
 *
 * Event description: Generic click in the marketplace projects in the report a professional form
 *
 *
 * @param {reportAProfessionalFormGenericClickSrc80Evid1020Params} params - The parameters for this event
 * @property {string} click_type - The name of action the user clicks
 * @property {string} previousScreen - name of screen the form open from
 * @property {string} form_data - all the data from the form
 * @return {LogObject<reportAProfessionalFormGenericClickSrc80Evid1020Params>} LogObject<reportAProfessionalFormGenericClickSrc80Evid1020Params>
 */
export function reportAProfessionalFormGenericClickSrc80Evid1020(params) {
    return { evid: 1020, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioMyAppsPageLoadPage' event (evid: 1021)
 *
 * Event description: load page event for the my apps page
 *
 * @param {wixStudioMyAppsPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioMyAppsPageLoadPageParams>} LogObject<wixStudioMyAppsPageLoadPageParams>
 */
export function wixStudioMyAppsPageLoadPage(params) {
    return { evid: 1021, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'projectModalGenericClickSrc80Evid1022' event (evid: 1022)
 *
 * Event description: user clicks on one of the buttons in the Project modal
 *
 *
 *
 *
 *
 * @param {projectModalGenericClickSrc80Evid1022Params} params - The parameters for this event
 * @property {string} clickType - click type
 * @property {string} entry - users entry to modal
 * @property {string} data - the data extracted from the click
 * @return {LogObject<projectModalGenericClickSrc80Evid1022Params>} LogObject<projectModalGenericClickSrc80Evid1022Params>
 */
export function projectModalGenericClickSrc80Evid1022(params) {
    return { evid: 1022, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'projectModalPageViewSrc80Evid1023' event (evid: 1023)
 *
 * Event description: Fires when the Project moadal is loaded
 *
 *
 *
 *
 *
 * @param {projectModalPageViewSrc80Evid1023Params} params - The parameters for this event
 * @property {string} clickType - clickType
 * @property {string} data - the data extracted from the click
 *
 * @property {string} entry - users entry to modal
 *
 * @return {LogObject<projectModalPageViewSrc80Evid1023Params>} LogObject<projectModalPageViewSrc80Evid1023Params>
 */
export function projectModalPageViewSrc80Evid1023(params) {
    return { evid: 1023, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageVideoAutoPlay' event (evid: 1024)
 *
 * Event description: new video start with auto-play after the previous ended
 *
 * @param {wixStudioDiscoverPageVideoAutoPlayParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} user_funnel_stage - new/returning/existing
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioDiscoverPageVideoAutoPlayParams>} LogObject<wixStudioDiscoverPageVideoAutoPlayParams>
 */
export function wixStudioDiscoverPageVideoAutoPlay(params) {
    return { evid: 1024, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioMyAppsPageLoadPageSrc80Evid1025' event (evid: 1025)
 *
 * Event description: load page event for the my apps page on Wix studio
 *
 * @param {wixStudioMyAppsPageLoadPageSrc80Evid1025Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioMyAppsPageLoadPageSrc80Evid1025Params>} LogObject<wixStudioMyAppsPageLoadPageSrc80Evid1025Params>
 */
export function wixStudioMyAppsPageLoadPageSrc80Evid1025(params) {
    return { evid: 1025, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOverviewDashboardGenericClick' event (evid: 1027)
 *
 * Event description: Generic click in the marketplace overview in partners dashboard
 *
 * @param {marketplaceOverviewDashboardGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform - The platform the user is using
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceOverviewDashboardGenericClickParams>} LogObject<marketplaceOverviewDashboardGenericClickParams>
 */
export function marketplaceOverviewDashboardGenericClick(params) {
    return { evid: 1027, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceProfileEditClickOnViewMyProfile' event (evid: 1028)
 *
 * Event description: When the partner clicks on 'view my profile' in his profile page
 *
 * @param {marketplaceProfileEditClickOnViewMyProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - click type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProfileEditClickOnViewMyProfileParams>} LogObject<marketplaceProfileEditClickOnViewMyProfileParams>
 */
export function marketplaceProfileEditClickOnViewMyProfile(params) {
    return { evid: 1028, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userProProfileProProfileUploaded' event (evid: 103)
 *
 * Event description: Pro Profile was uploaded for user's request
 *
 * @param {userProProfileProProfileUploadedParams} params - The parameters for this event
 * @property {string} origin - hp, external link - from user home page or from external link that the pro published
 * @return {LogObject<userProProfileProProfileUploadedParams>} LogObject<userProProfileProProfileUploadedParams>
 */
export function userProProfileProProfileUploaded(params) {
    return { evid: 103, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proDesignerRegistrationFormSubmitted' event (evid: 104)
 *
 * Event description: form was submitted to become a pro
 *
 * @param {proDesignerRegistrationFormSubmittedParams} params - The parameters for this event
 * @property {string} typeOfService - deprecated
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - deprecated
 * @property {GUID} sessionId - deprecated
 * @property {boolean} isMultiplePros - deprecated
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<proDesignerRegistrationFormSubmittedParams>} LogObject<proDesignerRegistrationFormSubmittedParams>
 */
export function proDesignerRegistrationFormSubmitted(params) {
    return { evid: 104, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefFormServerRequestToSubmitBrief' event (evid: 105)
 *
 * Event description: Server request to submit brief
 *
 * @param {briefFormServerRequestToSubmitBriefParams} params - The parameters for this event
 * @property {string} typeOfService - new site, existing site, logo
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros - (0,1) - is it for a specific pro or for random multiple pros
 * @property {GUID} briefId - the breif id associated with the session_id
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefFormServerRequestToSubmitBriefParams>} LogObject<briefFormServerRequestToSubmitBriefParams>
 */
export function briefFormServerRequestToSubmitBrief(params) {
    return { evid: 105, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefSentToProS' event (evid: 107)
 *
 * Event description: submitted successfully to 1 pro or to multiple pros.
 * In case of multiple pro - this event will be fired for each pro with its location on the list
 *
 * @param {briefSentToProSParams} params - The parameters for this event
 * @property {GUID} jobRequestId - {guid from server}
 * @property {string} typeOfService - new site, existing site, logo
 * @property {number} proLocation - location on the list, 1 is first
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros - (0,1) - is it for a specific pro or for random multiple pros
 * @property {number} numberProsChecked - number of pros that will receive the brief
 * @property {GUID} briefId - the breif id associated with the session_id
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefSentToProSParams>} LogObject<briefSentToProSParams>
 */
export function briefSentToProS(params) {
    return { evid: 107, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proApprovedAsDesigner' event (evid: 108)
 *
 * Event description: pro user was approved
 *
 * @param {proApprovedAsDesignerParams} params - The parameters for this event
 * @property {GUID} proGuid - {Expert uuid that is approved}
 * @property {boolean} approve - {approve or decline expert}
 * @property {GUID} uuid - uuid
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} approved_by - {uuid that approved this pro}
 * @return {LogObject<proApprovedAsDesignerParams>} LogObject<proApprovedAsDesignerParams>
 */
export function proApprovedAsDesigner(params) {
    return { evid: 108, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proUserIsLiveAfterPressedGoLive' event (evid: 109)
 *
 * Event description: {}
 *
 * @param {proUserIsLiveAfterPressedGoLiveParams} params - The parameters for this event
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @return {LogObject<proUserIsLiveAfterPressedGoLiveParams>} LogObject<proUserIsLiveAfterPressedGoLiveParams>
 */
export function proUserIsLiveAfterPressedGoLive(params) {
    return { evid: 109, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'matchingDone' event (evid: 110)
 *
 * Event description: server did matching between client brief and expert
 *
 * @param {matchingDoneParams} params - The parameters for this event
 * @property {string} location - {used location in match}
 * @property {number} serviceid - {type of inner service: small fix/complete site...}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {boolean} budgetmatch - {used budget in match}
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {string} skill - {used skill in match}
 * @property {string} jsonData - {array of experts in match that brief sent to}
 * @property {number} numberProsChecked - number of pros that answer the match
 * @property {GUID} briefId - the breif id associated with the session_id
 * @return {LogObject<matchingDoneParams>} LogObject<matchingDoneParams>
 */
export function matchingDone(params) {
    return { evid: 110, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackDialogLoaded' event (evid: 1102)
 *
 * Event description: get feedback dialog successfully loaded
 *
 * @param {getFeedbackDialogLoadedParams} params - The parameters for this event
 * @property {string} editorVersion - standard/Editor/ADI/EditorX
 * @property {string} origin - entry point name
 * @property {string} feature_state - the state of the feature when the dialog loaded
 * @property {GUID} msid - msid dialog belongs to
 * @return {LogObject<getFeedbackDialogLoadedParams>} LogObject<getFeedbackDialogLoadedParams>
 */
export function getFeedbackDialogLoaded(params) {
    return { evid: 1102, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackDialogClosed' event (evid: 1103)
 *
 * Event description: clicked on close get feedback dialog
 *
 * @param {getFeedbackDialogClosedParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/standard/adi
 * @property {string} origin - origin
 * @property {string} feature_state - the state of the feature when the modal was closed (if relevant)
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackDialogClosedParams>} LogObject<getFeedbackDialogClosedParams>
 */
export function getFeedbackDialogClosed(params) {
    return { evid: 1103, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickedCopyLink' event (evid: 1104)
 *
 * Event description: clicked on get feedback copy share link from 'origin'
 *
 * @param {getFeedbackClickedCopyLinkParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/standard/adi
 * @property {string} origin - source name
 * @property {string} user_type - owner/contributor
 * @property {string} feature_state - the state of the feature when user clicked copy
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickedCopyLinkParams>} LogObject<getFeedbackClickedCopyLinkParams>
 */
export function getFeedbackClickedCopyLink(params) {
    return { evid: 1104, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackViewCommentsButton' event (evid: 1105)
 *
 * Event description: clicked on get feedback view comments from 'origin'
 *
 * @param {getFeedbackViewCommentsButtonParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/adi/standard
 * @property {string} origin - source name
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackViewCommentsButtonParams>} LogObject<getFeedbackViewCommentsButtonParams>
 */
export function getFeedbackViewCommentsButton(params) {
    return { evid: 1105, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackViewCommentsPageLoaded' event (evid: 1106)
 *
 * Event description: View comments page loaded
 *
 * @param {getFeedbackViewCommentsPageLoadedParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/contributor
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackViewCommentsPageLoadedParams>} LogObject<getFeedbackViewCommentsPageLoadedParams>
 */
export function getFeedbackViewCommentsPageLoaded(params) {
    return { evid: 1106, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackViewComment' event (evid: 1107)
 *
 * Event description: Click to view the comment
 *
 * @param {getFeedbackViewCommentParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {GUID} visitorId - {}
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} origin - page name
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackViewCommentParams>} LogObject<getFeedbackViewCommentParams>
 */
export function getFeedbackViewComment(params) {
    return { evid: 1107, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackAddCommentOrReply' event (evid: 1108)
 *
 * Event description: finish adding comment or reply
 *
 * @param {getFeedbackAddCommentOrReplyParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {GUID} visitorId - {}
 * @property {string} text - text in comment/reply
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} page_id - homepage/other
 * @property {string} origin - page name
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - ContactId (if any)
 * @property {string} mode - desktop/mobile
 * @property {number} response_number - Number of the response in comment
 * @property {GUID} response_id - Response guid for each response
 * @property {boolean} emailInput - user input email?
 * @property {string} type - comment/reply
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackAddCommentOrReplyParams>} LogObject<getFeedbackAddCommentOrReplyParams>
 */
export function getFeedbackAddCommentOrReply(params) {
    return { evid: 1108, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackResolveComment' event (evid: 1109)
 *
 * Event description: Clicked to resolve to a comment
 *
 * @param {getFeedbackResolveCommentParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} origin - page name
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackResolveCommentParams>} LogObject<getFeedbackResolveCommentParams>
 */
export function getFeedbackResolveComment(params) {
    return { evid: 1109, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'looksLikeSpamInExpertDashboard' event (evid: 111)
 *
 * Event description: press 'looks like spam' in expert dashboard
 *
 * @param {looksLikeSpamInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<looksLikeSpamInExpertDashboardParams>} LogObject<looksLikeSpamInExpertDashboardParams>
 */
export function looksLikeSpamInExpertDashboard(params) {
    return { evid: 111, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackEditCommentOrReply' event (evid: 1110)
 *
 * Event description: finish editing a comment or reply
 *
 * @param {getFeedbackEditCommentOrReplyParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {GUID} visitorId - {}
 * @property {string} text - text in comment/reply
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} page_id - homepage/other
 * @property {string} origin - page name
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} mode - desktop/mobile
 * @property {number} response_number - Number of the response in comment
 * @property {GUID} response_id - Response guid for each response
 * @property {string} type - comment/reply
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackEditCommentOrReplyParams>} LogObject<getFeedbackEditCommentOrReplyParams>
 */
export function getFeedbackEditCommentOrReply(params) {
    return { evid: 1110, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackDeleteCommentOrResponse' event (evid: 1111)
 *
 * Event description: Click to delete comment or response
 *
 * @param {getFeedbackDeleteCommentOrResponseParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {GUID} visitorId - {}
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} page_id - page_id
 * @property {string} origin - page name
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - ContactId (if any)
 * @property {GUID} response_id - Response guid for each response
 * @property {string} type - comment/reply
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackDeleteCommentOrResponseParams>} LogObject<getFeedbackDeleteCommentOrResponseParams>
 */
export function getFeedbackDeleteCommentOrResponse(params) {
    return { evid: 1111, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackHideOrShowCommentList' event (evid: 1112)
 *
 * Event description: clicked to hide/show comment list on get feedback view-comments page
 *
 * @param {getFeedbackHideOrShowCommentListParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx
 * @property {string} origin - source name
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @property {string} action - Hide or show comments
 * @return {LogObject<getFeedbackHideOrShowCommentListParams>} LogObject<getFeedbackHideOrShowCommentListParams>
 */
export function getFeedbackHideOrShowCommentList(params) {
    return { evid: 1112, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackOnOffFilterOnCommentList' event (evid: 1113)
 *
 * Event description: clicks on/off on filter in comment list at get feedback view-comments page
 *
 * @param {getFeedbackOnOffFilterOnCommentListParams} params - The parameters for this event
 * @property {string} desktop_filter_state - on/off
 * @property {string} resolved_filter_state - on/off
 * @property {string} mobile_filter_state - on/off
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackOnOffFilterOnCommentListParams>} LogObject<getFeedbackOnOffFilterOnCommentListParams>
 */
export function getFeedbackOnOffFilterOnCommentList(params) {
    return { evid: 1113, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackLightboxAction' event (evid: 1114)
 *
 * Event description: clicked on lightbox
 *
 * @param {getFeedbackLightboxActionParams} params - The parameters for this event
 * @property {GUID} visitorId - visitors guid
 * @property {string} light_box_guid - guid
 * @property {string} editorVersion - editor/editorx
 * @property {string} light_box_name - name
 * @property {string} origin - source name
 * @property {GUID} contactId - contact_id (if any)
 * @property {GUID} msid - msid
 * @property {string} action - got-it/close
 * @return {LogObject<getFeedbackLightboxActionParams>} LogObject<getFeedbackLightboxActionParams>
 */
export function getFeedbackLightboxAction(params) {
    return { evid: 1114, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackAddACommentButton' event (evid: 1115)
 *
 * Event description: clicked on add a comment
 *
 * @param {getFeedbackAddACommentButtonParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {string} editorVersion - editor/editorx
 * @property {string} origin - source name
 * @property {GUID} contactId - Contact_id (if any)
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackAddACommentButtonParams>} LogObject<getFeedbackAddACommentButtonParams>
 */
export function getFeedbackAddACommentButton(params) {
    return { evid: 1115, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackMoveAComment' event (evid: 1116)
 *
 * Event description: Get feedback - move a comment.
 *
 * @param {getFeedbackMoveACommentParams} params - The parameters for this event
 * @property {GUID} visitorId - {}
 * @property {string} editorVersion - editor/editorx
 * @property {string} comment_id - {}
 * @property {string} page_id - homepage/other
 * @property {string} origin - page name
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} mode - desktop/mobile
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackMoveACommentParams>} LogObject<getFeedbackMoveACommentParams>
 */
export function getFeedbackMoveAComment(params) {
    return { evid: 1116, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogLoaded' event (evid: 1117)
 *
 * Event description: get feedback site selector dialog successfully loaded
 *
 * @param {getFeedbackSiteSelectorDialogLoadedParams} params - The parameters for this event
 * @property {string} origin - origin
 * @property {string} feature_state - the state of the feature when the site selector loaded
 * @return {LogObject<getFeedbackSiteSelectorDialogLoadedParams>} LogObject<getFeedbackSiteSelectorDialogLoadedParams>
 */
export function getFeedbackSiteSelectorDialogLoaded(params) {
    return { evid: 1117, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogClosed' event (evid: 1118)
 *
 * Event description: clicked to close site selector get feedback dialog
 *
 * @param {getFeedbackSiteSelectorDialogClosedParams} params - The parameters for this event
 * @return {LogObject<getFeedbackSiteSelectorDialogClosedParams>} LogObject<getFeedbackSiteSelectorDialogClosedParams>
 */
export function getFeedbackSiteSelectorDialogClosed(params) {
    return { evid: 1118, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogSearch' event (evid: 1119)
 *
 * Event description: search site in the site selector dialog
 *
 * @param {getFeedbackSiteSelectorDialogSearchParams} params - The parameters for this event
 * @property {string} text - text searched
 * @return {LogObject<getFeedbackSiteSelectorDialogSearchParams>} LogObject<getFeedbackSiteSelectorDialogSearchParams>
 */
export function getFeedbackSiteSelectorDialogSearch(params) {
    return { evid: 1119, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelProjectInExpertDashboardDialogBox' event (evid: 112)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box
 *
 * @param {cancelProjectInExpertDashboardDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<cancelProjectInExpertDashboardDialogBoxParams>} LogObject<cancelProjectInExpertDashboardDialogBoxParams>
 */
export function cancelProjectInExpertDashboardDialogBox(params) {
    return { evid: 112, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClientSidePageLoaded' event (evid: 1120)
 *
 * Event description: Client-side / leave comments page loaded
 *
 * @param {getFeedbackClientSidePageLoadedParams} params - The parameters for this event
 * @property {GUID} visitor_id - guid
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - commenter/owner
 * @property {GUID} contactId - contact_id (if any)
 * @return {LogObject<getFeedbackClientSidePageLoadedParams>} LogObject<getFeedbackClientSidePageLoadedParams>
 */
export function getFeedbackClientSidePageLoaded(params) {
    return { evid: 1120, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackCopyLinkLinkCouldNotBeGenerated' event (evid: 1121)
 *
 * Event description: clicked on get feedback copy share link from 'origin' and the link could not be generated
 *
 * @param {getFeedbackCopyLinkLinkCouldNotBeGeneratedParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackCopyLinkLinkCouldNotBeGeneratedParams>} LogObject<getFeedbackCopyLinkLinkCouldNotBeGeneratedParams>
 */
export function getFeedbackCopyLinkLinkCouldNotBeGenerated(params) {
    return { evid: 1121, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnSend' event (evid: 1122)
 *
 * Event description: Fires when user sends get feedback notification
 *
 * @param {getFeedbackClickOnSendParams} params - The parameters for this event
 * @property {number} countInvitations - Count of invitations sent
 * @property {number} countInvitationsContacts - count invitations to contacts
 * @property {string} note - notes of the share dialog
 * @property {string} origin - source name
 * @property {string} feature_state - the state of the feature when user clicks on send
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickOnSendParams>} LogObject<getFeedbackClickOnSendParams>
 */
export function getFeedbackClickOnSend(params) {
    return { evid: 1122, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackAddPersonToList' event (evid: 1123)
 *
 * Event description: Fires when user adds someone to the list
 *
 * @param {getFeedbackAddPersonToListParams} params - The parameters for this event
 * @property {boolean} contactOrNot - true if person added is contact
 * @property {string} origin - source name
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackAddPersonToListParams>} LogObject<getFeedbackAddPersonToListParams>
 */
export function getFeedbackAddPersonToList(params) {
    return { evid: 1123, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnDropdownMenu' event (evid: 1125)
 *
 * Event description: Fires when user clicks on the dropdown menu to filter comments
 *
 * @param {getFeedbackClickOnDropdownMenuParams} params - The parameters for this event
 * @property {string} editorVersion - editor/edix
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickOnDropdownMenuParams>} LogObject<getFeedbackClickOnDropdownMenuParams>
 */
export function getFeedbackClickOnDropdownMenu(params) {
    return { evid: 1125, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnOptionDropdownMenu' event (evid: 1126)
 *
 * Event description: Fires when user clicks on an option from the  dropdown menu to filter comments
 *
 * @param {getFeedbackClickOnOptionDropdownMenuParams} params - The parameters for this event
 * @property {string} option - option chosen
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickOnOptionDropdownMenuParams>} LogObject<getFeedbackClickOnOptionDropdownMenuParams>
 */
export function getFeedbackClickOnOptionDropdownMenu(params) {
    return { evid: 1126, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackChooseMode' event (evid: 1128)
 *
 * Event description: Fires when user (client or partner) choose a mode
 *
 * @param {getFeedbackChooseModeParams} params - The parameters for this event
 * @property {string} editorVersion - {editor/editorx]
 * @property {string} user_type - user_type
 * @property {string} mode - {Desktop/Mobile}
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @property {string} device - editorx device
 * @return {LogObject<getFeedbackChooseModeParams>} LogObject<getFeedbackChooseModeParams>
 */
export function getFeedbackChooseMode(params) {
    return { evid: 1128, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientDeclinedInExpertDashboard' event (evid: 113)
 *
 * Event description: press 'Client declined' in expert dashboard
 *
 * @param {clientDeclinedInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientDeclinedInExpertDashboardParams>} LogObject<clientDeclinedInExpertDashboardParams>
 */
export function clientDeclinedInExpertDashboard(params) {
    return { evid: 113, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnHeader' event (evid: 1131)
 *
 * Event description: Fires when user (client or partner) clicks on header
 *
 * @param {getFeedbackClickOnHeaderParams} params - The parameters for this event
 * @property {string} clickType - click type
 * @property {string} editorVersion - editor/editorx
 * @property {string} page_id - page_id
 * @property {string} user_type - owner/commenter
 * @property {GUID} contactId - contact_id (if any)
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickOnHeaderParams>} LogObject<getFeedbackClickOnHeaderParams>
 */
export function getFeedbackClickOnHeader(params) {
    return { evid: 1131, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackClickEditReply' event (evid: 1133)
 *
 * Event description: Tracks click on edit site
 *
 * @param {getFeedbackClickEditReplyParams} params - The parameters for this event
 * @property {string} commentStatus - comment_status
 * @property {GUID} visitorId - visitorid
 * @property {string} click_type - click_type
 * @property {string} editorVersion - version
 * @property {string} user_type - user_type
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickEditReplyParams>} LogObject<getFeedbackClickEditReplyParams>
 */
export function getFeedbackClickEditReply(params) {
    return { evid: 1133, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackGenericClick' event (evid: 1135)
 *
 * Event description: Generic click event for the get feedback feature
 *
 * @param {getFeedbackGenericClickParams} params - The parameters for this event
 * @property {string} click_type - describes the object that has been clicked
 * @property {string} text - text in comment/reply
 * @property {string} feedback_user_type - owner/client
 * @property {GUID} comment_id - identifier for the specific comment
 * @property {boolean} comment_has_email - whether the client put his email
 * @property {string} page_id - page identifier
 * @property {string} editor_version - editor/editorx/studio
 * @property {string} response_id - identifier for the specific response
 * @property {GUID} contact_id - contact id (if any)
 * @property {string} breakpoint - breakpoint
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackGenericClickParams>} LogObject<getFeedbackGenericClickParams>
 */
export function getFeedbackGenericClick(params) {
    return { evid: 1135, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackPageLoaded' event (evid: 1136)
 *
 * Event description: Generic load event for the get feedback feature.
 * fires when a page is loaded.
 *
 * @param {getFeedbackPageLoadedParams} params - The parameters for this event
 * @property {string} feedback_user_type - owner/client
 * @property {string} page_id - page identifier
 * @property {string} editor_version - 'editor'/'editorx'/'studio'
 * @property {GUID} contact_id - contact id (if any)
 * @property {string} breakpoint - breakpoint
 * @return {LogObject<getFeedbackPageLoadedParams>} LogObject<getFeedbackPageLoadedParams>
 */
export function getFeedbackPageLoaded(params) {
    return { evid: 1136, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackPartnerSideGenericClick' event (evid: 1137)
 *
 * Event description: generic click for the partner side get feedback feature
 *
 * @param {getFeedbackPartnerSideGenericClickParams} params - The parameters for this event
 * @property {string} click_type - what the user clicked on
 * @property {GUID} msid_selected - msid related to the click if relevant
 * @property {string} origin - origin
 * @property {string} feature_state - the state of the feature - zero/no_sites/active
 * @property {string} product - to which product/screen the click is related to
 * @return {LogObject<getFeedbackPartnerSideGenericClickParams>} LogObject<getFeedbackPartnerSideGenericClickParams>
 */
export function getFeedbackPartnerSideGenericClick(params) {
    return { evid: 1137, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackPartnerSidePageLoaded' event (evid: 1138)
 *
 * Event description: this event fires when specific pages / modals are loaded
 *
 * @param {getFeedbackPartnerSidePageLoadedParams} params - The parameters for this event
 * @property {GUID} msid_selected - msid related to the click if relevant
 * @property {string} origin - origin
 * @property {string} feature_state - the state of the feature - zero/no_sites/active
 * @property {string} product - to which product/screen the click is related to
 * @return {LogObject<getFeedbackPartnerSidePageLoadedParams>} LogObject<getFeedbackPartnerSidePageLoadedParams>
 */
export function getFeedbackPartnerSidePageLoaded(params) {
    return { evid: 1138, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'approveDialogClientDeclinedInExpertDashboard' event (evid: 114)
 *
 * Event description: press 'cancel project' in expert dashboard (client declined) dialog box
 *
 * @param {approveDialogClientDeclinedInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} dialogType - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<approveDialogClientDeclinedInExpertDashboardParams>} LogObject<approveDialogClientDeclinedInExpertDashboardParams>
 */
export function approveDialogClientDeclinedInExpertDashboard(params) {
    return { evid: 114, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitProjectInExpertDashboard' event (evid: 115)
 *
 * Event description: press 'submit project' in expert dashboard
 *
 * @param {submitProjectInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part,dashboard,non_arena}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitProjectInExpertDashboardParams>} LogObject<submitProjectInExpertDashboardParams>
 */
export function submitProjectInExpertDashboard(params) {
    return { evid: 115, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitProjectInExpertDashboardDialogBox' event (evid: 116)
 *
 * Event description: press 'submit project' in expert dashboard dialog box. actual submit
 *
 * @param {submitProjectInExpertDashboardDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} websiteUrl - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitProjectInExpertDashboardDialogBoxParams>} LogObject<submitProjectInExpertDashboardDialogBoxParams>
 */
export function submitProjectInExpertDashboardDialogBox(params) {
    return { evid: 116, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardLoaded' event (evid: 118)
 *
 * Event description: Expert dashboard loaded
 *
 * @param {dashboardLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} numberOfItems - {number of briefs shown}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<dashboardLoadedParams>} LogObject<dashboardLoadedParams>
 */
export function dashboardLoaded(params) {
    return { evid: 118, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aboutUsButtonClick' event (evid: 12)
 *
 * Event description: how it works header button was clicked
 *
 * @param {aboutUsButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<aboutUsButtonClickParams>} LogObject<aboutUsButtonClickParams>
 */
export function aboutUsButtonClick(params) {
    return { evid: 12, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'missingParameterInExpertDashboardFlow' event (evid: 122)
 *
 * Event description: validation false due to missing value. sent only when show error msg
 *
 * @param {missingParameterInExpertDashboardFlowParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {dialog name}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} value - {the missing parameter  or field}
 * @return {LogObject<missingParameterInExpertDashboardFlowParams>} LogObject<missingParameterInExpertDashboardFlowParams>
 */
export function missingParameterInExpertDashboardFlow(params) {
    return { evid: 122, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressEmailOfClientInExpertDashboard' event (evid: 123)
 *
 * Event description: press email of client in expert dashboard
 *
 * @param {pressEmailOfClientInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressEmailOfClientInExpertDashboardParams>} LogObject<pressEmailOfClientInExpertDashboardParams>
 */
export function pressEmailOfClientInExpertDashboard(params) {
    return { evid: 123, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressPhoneOfClientInExpertDashboard' event (evid: 124)
 *
 * Event description: press phone of client in expert dashboard (mobile only)
 *
 * @param {pressPhoneOfClientInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressPhoneOfClientInExpertDashboardParams>} LogObject<pressPhoneOfClientInExpertDashboardParams>
 */
export function pressPhoneOfClientInExpertDashboard(params) {
    return { evid: 124, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardFilterBriefs' event (evid: 125)
 *
 * Event description: changing the filter showing the briefs
 *
 * @param {expertDashboardFilterBriefsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {filter name: unread,expired..}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - leads tab/projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertDashboardFilterBriefsParams>} LogObject<expertDashboardFilterBriefsParams>
 */
export function expertDashboardFilterBriefs(params) {
    return { evid: 125, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardPressViewDetails' event (evid: 126)
 *
 * Event description: press to see the brief from dashboard
 *
 * @param {expertDashboardPressViewDetailsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {filter name: unread,expired..}
 * @property {string} button_name - {view_details,row}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - leads tab/ projects tab
 * @property {string} status - {status of job}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertDashboardPressViewDetailsParams>} LogObject<expertDashboardPressViewDetailsParams>
 */
export function expertDashboardPressViewDetails(params) {
    return { evid: 126, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'looksLikeSpamDialogBox' event (evid: 127)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box due to spam
 *
 * @param {looksLikeSpamDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<looksLikeSpamDialogBoxParams>} LogObject<looksLikeSpamDialogBoxParams>
 */
export function looksLikeSpamDialogBox(params) {
    return { evid: 127, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientCancelDialogBox' event (evid: 128)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box due to client cancel
 *
 * @param {clientCancelDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientCancelDialogBoxParams>} LogObject<clientCancelDialogBoxParams>
 */
export function clientCancelDialogBox(params) {
    return { evid: 128, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reportReview' event (evid: 129)
 *
 * Event description: expert reports that the review is inappropriate
 *
 * @param {reportReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<reportReviewParams>} LogObject<reportReviewParams>
 */
export function reportReview(params) {
    return { evid: 129, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportButtonClick' event (evid: 13)
 *
 * Event description: Explore portfolios button was clicked (homepage)
 *
 * @param {supportButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<supportButtonClickParams>} LogObject<supportButtonClickParams>
 */
export function supportButtonClick(params) {
    return { evid: 13, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertPressesSubmitThisReview' event (evid: 130)
 *
 * Event description: expert reports that the review is inappropriate with the details
 *
 * @param {expertPressesSubmitThisReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @return {LogObject<expertPressesSubmitThisReviewParams>} LogObject<expertPressesSubmitThisReviewParams>
 */
export function expertPressesSubmitThisReview(params) {
    return { evid: 130, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramCurrentPointsStatus' event (evid: 1301)
 *
 * Event description: Triggered on each points calculation
 *
 * @param {loyaltyProgramCurrentPointsStatusParams} params - The parameters for this event
 * @property {number} currentPoints - current number of points
 * @property {boolean} joinedProgram - true/false
 * @return {LogObject<loyaltyProgramCurrentPointsStatusParams>} LogObject<loyaltyProgramCurrentPointsStatusParams>
 */
export function loyaltyProgramCurrentPointsStatus(params) {
    return { evid: 1301, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramFeaturesAdded' event (evid: 1302)
 *
 * Event description: Triggers on every feature add/remove from the partner dashboard
 *
 * @param {loyaltyProgramFeaturesAddedParams} params - The parameters for this event
 * @property {string} feature - feature the partners is getting/dropping
 * @property {string} featureType - add/remove
 * @return {LogObject<loyaltyProgramFeaturesAddedParams>} LogObject<loyaltyProgramFeaturesAddedParams>
 */
export function loyaltyProgramFeaturesAdded(params) {
    return { evid: 1302, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'provideFeedbackPageLoaded' event (evid: 131)
 *
 * Event description: provide feedback page loaded
 *
 * @param {provideFeedbackPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<provideFeedbackPageLoadedParams>} LogObject<provideFeedbackPageLoadedParams>
 */
export function provideFeedbackPageLoaded(params) {
    return { evid: 131, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'endUserSubmitReview' event (evid: 132)
 *
 * Event description: end user finishes his review to the expert
 *
 * @param {endUserSubmitReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @return {LogObject<endUserSubmitReviewParams>} LogObject<endUserSubmitReviewParams>
 */
export function endUserSubmitReview(params) {
    return { evid: 132, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageForSubmittingReview' event (evid: 133)
 *
 * Event description: Thank you page for submitting review
 *
 * @param {thankYouPageForSubmittingReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<thankYouPageForSubmittingReviewParams>} LogObject<thankYouPageForSubmittingReviewParams>
 */
export function thankYouPageForSubmittingReview(params) {
    return { evid: 133, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverAcceptedTheReview' event (evid: 134)
 *
 * Event description: server accepted the review sent by end user
 *
 * @param {serverAcceptedTheReviewParams} params - The parameters for this event
 * @property {GUID} jobRequestId - job of reviewed
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<serverAcceptedTheReviewParams>} LogObject<serverAcceptedTheReviewParams>
 */
export function serverAcceptedTheReview(params) {
    return { evid: 134, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newBriefLoaded' event (evid: 135)
 *
 * Event description: step 0: what do you need done
 *
 * @param {newBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceid - {1;2; e.g. small fix; new website}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<newBriefLoadedParams>} LogObject<newBriefLoadedParams>
 */
export function newBriefLoaded(params) {
    return { evid: 135, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'stepsInNewBrief' event (evid: 136)
 *
 * Event description: step 1-10 in new brief
 *
 * @param {stepsInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {number} serviceid - {1;2; e.g. small fix; new website}
 * @property {boolean} skip - if user skips screen
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {string} category - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} jsonData - {json data}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {validating mandatory fields}
 * @return {LogObject<stepsInNewBriefParams>} LogObject<stepsInNewBriefParams>
 */
export function stepsInNewBrief(params) {
    return { evid: 136, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressingBackInNewBrief' event (evid: 137)
 *
 * Event description: press back
 *
 * @param {pressingBackInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} nextScreenName - next screen
 * @return {LogObject<pressingBackInNewBriefParams>} LogObject<pressingBackInNewBriefParams>
 */
export function pressingBackInNewBrief(params) {
    return { evid: 137, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressingSkipInNewBrief' event (evid: 138)
 *
 * Event description: press skip
 *
 * @param {pressingSkipInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressingSkipInNewBriefParams>} LogObject<pressingSkipInNewBriefParams>
 */
export function pressingSkipInNewBrief(params) {
    return { evid: 138, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logInButtonClick' event (evid: 14)
 *
 * Event description: Log in button was clicked
 *
 * @param {logInButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<logInButtonClickParams>} LogObject<logInButtonClickParams>
 */
export function logInButtonClick(params) {
    return { evid: 14, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'innerBriefLoaded' event (evid: 140)
 *
 * Event description: Load the inner brief after the user chooses the service requested
 *
 * @param {innerBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - {1;2; e.g. small fix; new website}
 * @property {number} innerType - {1;2}
 * @property {string} entry - e.g, generalMenu, support_banner
 * @property {string} data - {}
 * @property {number} height - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {login}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - {}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<innerBriefLoadedParams>} LogObject<innerBriefLoadedParams>
 */
export function innerBriefLoaded(params) {
    return { evid: 140, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'explorePageZeroState' event (evid: 141)
 *
 * Event description: Fires when explore main page is loaded
 *
 * @param {explorePageZeroStateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} location - not in use
 * @property {string} entry - user's entry point
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} exploreVersion - V1/V2 ect.
 * @property {string} language - not in use
 * @property {string} origin - The traffic source
 * @property {GUID} sessionId - users session id
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageZeroStateParams>} LogObject<explorePageZeroStateParams>
 */
export function explorePageZeroState(params) {
    return { evid: 141, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'explorePageApplyFilter' event (evid: 142)
 *
 * Event description: User applies a filter on the profile page
 *
 * @param {explorePageApplyFilterParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterValue - all the elements in the filter
 * @property {string} filterType - service / price / location ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageApplyFilterParams>} LogObject<explorePageApplyFilterParams>
 */
export function explorePageApplyFilter(params) {
    return { evid: 142, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'explorePageEmptyState' event (evid: 143)
 *
 * Event description: The explore page is loaded as an empty state (no experts were found)
 *
 * @param {explorePageEmptyStateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} location - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - not in use
 * @property {string} origin - Where the click came from
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageEmptyStateParams>} LogObject<explorePageEmptyStateParams>
 */
export function explorePageEmptyState(params) {
    return { evid: 143, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profilePageClickOnShareProfile' event (evid: 145)
 *
 * Event description: User clicks on "share profile" on the expert profile page
 *
 * @param {profilePageClickOnShareProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnShareProfileParams>} LogObject<profilePageClickOnShareProfileParams>
 */
export function profilePageClickOnShareProfile(params) {
    return { evid: 145, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profilePageClickOnShowMoreProjects' event (evid: 147)
 *
 * Event description: User clicks on "show more projects" on the expert profile page
 *
 * @param {profilePageClickOnShowMoreProjectsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnShowMoreProjectsParams>} LogObject<profilePageClickOnShowMoreProjectsParams>
 */
export function profilePageClickOnShowMoreProjects(params) {
    return { evid: 147, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profilePageClickOnReadMore' event (evid: 148)
 *
 * Event description: User clicks on "read more" on the about me section in the expert profile page
 *
 * @param {profilePageClickOnReadMoreParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnReadMoreParams>} LogObject<profilePageClickOnReadMoreParams>
 */
export function profilePageClickOnReadMore(params) {
    return { evid: 148, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'exploreLoadPage' event (evid: 15)
 *
 * Event description: The explore results page is loaded
 *
 * @param {exploreLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} partnerList - json with list of partners in the results page
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {string} lng_dev - language
 * @property {string} entry - users entry point - the page
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} rankerVersion - the version of the ranker
 * @property {string} exploreVersion - V1/V2 ect.
 * @property {string} language - not in use
 * @property {string} origin - users entry point - the click the user clicked on {scroll;button}
 * @property {GUID} sessionId - users session id
 * @property {string} rankerParameters - ranker_parameters
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} rankerType - manual pricing/ data science model / scoring ect.
 * @property {number} numOfResults - the num of results displayed
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<exploreLoadPageParams>} LogObject<exploreLoadPageParams>
 */
export function exploreLoadPage(params) {
    return { evid: 15, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardUserEnablesDisables' event (evid: 1501)
 *
 * Event description: This event fires when a user enables or disables successfully the partner dashboard from the account settings
 *
 * @param {partnerDashboardUserEnablesDisablesParams} params - The parameters for this event
 * @property {string} action - Enable/Disable
 * @return {LogObject<partnerDashboardUserEnablesDisablesParams>} LogObject<partnerDashboardUserEnablesDisablesParams>
 */
export function partnerDashboardUserEnablesDisables(params) {
    return { evid: 1501, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickToChooseAService' event (evid: 151)
 *
 * Event description: User clicks on "services" on the top menu or clicks on "choose a service" to open the services dropdown.
 *
 * @param {homePageClickToChooseAServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} serviceName - connect domain / get website guidance ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickToChooseAServiceParams>} LogObject<homePageClickToChooseAServiceParams>
 */
export function homePageClickToChooseAService(params) {
    return { evid: 151, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnAServiceCategory' event (evid: 152)
 *
 * Event description: User clicks on a service category on the top menu dropdown / service category strip / service button dropdown
 *
 * @param {homePageClickOnAServiceCategoryParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} serviceCategory - category name: web design / small tasks ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button / strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnAServiceCategoryParams>} LogObject<homePageClickOnAServiceCategoryParams>
 */
export function homePageClickOnAServiceCategory(params) {
    return { evid: 152, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnASpecificService' event (evid: 153)
 *
 * Event description: User clicks on a service on the service category strip
 *
 * @param {homePageClickOnASpecificServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - service category number
 * @property {string} serviceCategory - category name: web design / small tasks
 * @property {number} innerType - service type number
 * @property {string} serviceName - migrate website / connect domain
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - service strip / explore
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnASpecificServiceParams>} LogObject<homePageClickOnASpecificServiceParams>
 */
export function homePageClickOnASpecificService(params) {
    return { evid: 153, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnSmallTasks' event (evid: 154)
 *
 * Event description: User clicks on small tasks on the top menu dropdown / small tasks strip / service button dropdown
 *
 * @param {homePageClickOnSmallTasksParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button / strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnSmallTasksParams>} LogObject<homePageClickOnSmallTasksParams>
 */
export function homePageClickOnSmallTasks(params) {
    return { evid: 154, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnASmallTaskService' event (evid: 155)
 *
 * Event description: User clicks on a "Design your own website" on the web design strip
 *
 * @param {homePageClickOnASmallTaskServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - strip / small tasks page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnASmallTaskServiceParams>} LogObject<homePageClickOnASmallTaskServiceParams>
 */
export function homePageClickOnASmallTaskService(params) {
    return { evid: 155, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnBrowseAllExperts' event (evid: 156)
 *
 * Event description: User clicks on "Browse All Experts"
 *
 * @param {homePageClickOnBrowseAllExpertsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnBrowseAllExpertsParams>} LogObject<homePageClickOnBrowseAllExpertsParams>
 */
export function homePageClickOnBrowseAllExperts(params) {
    return { evid: 156, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnFindMeAnExpert' event (evid: 157)
 *
 * Event description: User clicks on "Find Me an Expert"
 *
 * @param {homePageClickOnFindMeAnExpertParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnFindMeAnExpertParams>} LogObject<homePageClickOnFindMeAnExpertParams>
 */
export function homePageClickOnFindMeAnExpert(params) {
    return { evid: 157, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnHowItWorks' event (evid: 158)
 *
 * Event description: User clicks on "How it Works"
 *
 * @param {homePageClickOnHowItWorksParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnHowItWorksParams>} LogObject<homePageClickOnHowItWorksParams>
 */
export function homePageClickOnHowItWorks(params) {
    return { evid: 158, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefQuestionView' event (evid: 159)
 *
 * Event description: user views a question in the brief
 *
 * @param {briefQuestionViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - difm / seo / bm ...
 * @property {string} category - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} jsonData - {json data}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<briefQuestionViewParams>} LogObject<briefQuestionViewParams>
 */
export function briefQuestionView(params) {
    return { evid: 159, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHpAdditionalProfilesLoaded' event (evid: 16)
 *
 * Event description: profiles page was loaded
 *
 * @param {userHpAdditionalProfilesLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} city - user_city
 * @property {GUID} visitorId - visitor_id
 * @property {string} filterValue - filter_value
 * @property {string} state - state
 * @property {string} filterType - filter_type
 * @property {string} sortBy - sort_by
 * @property {string} list_preset - {location of expert on page}
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - country
 * @property {number} numberOfItems - count
 * @property {string} language - language
 * @property {string} sortType - sort_type
 * @property {string} origin - {}
 * @property {string} pageView - page_view
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHpAdditionalProfilesLoadedParams>} LogObject<userHpAdditionalProfilesLoadedParams>
 */
export function userHpAdditionalProfilesLoaded(params) {
    return { evid: 16, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefCreateOnYourOwn' event (evid: 160)
 *
 * Event description: user click on "create on your own"
 *
 * @param {briefCreateOnYourOwnParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} origin - difm / other
 * @property {string} category - question name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<briefCreateOnYourOwnParams>} LogObject<briefCreateOnYourOwnParams>
 */
export function briefCreateOnYourOwn(params) {
    return { evid: 160, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefClickOnViewPortfolio' event (evid: 161)
 *
 * Event description: user click on "view portfolio"
 *
 * @param {briefClickOnViewPortfolioParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} isMatched - true if it's the agency that was matched / false
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - arena user guid
 * @return {LogObject<briefClickOnViewPortfolioParams>} LogObject<briefClickOnViewPortfolioParams>
 */
export function briefClickOnViewPortfolio(params) {
    return { evid: 161, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefClickOnGetInTouch' event (evid: 162)
 *
 * Event description: user click on "Get In Touch"
 *
 * @param {briefClickOnGetInTouchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - json with the brief answers
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - arena user guid
 * @return {LogObject<briefClickOnGetInTouchParams>} LogObject<briefClickOnGetInTouchParams>
 */
export function briefClickOnGetInTouch(params) {
    return { evid: 162, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resultsPageClickOnBack' event (evid: 163)
 *
 * Event description: user click on "back" from the results page
 *
 * @param {resultsPageClickOnBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<resultsPageClickOnBackParams>} LogObject<resultsPageClickOnBackParams>
 */
export function resultsPageClickOnBack(params) {
    return { evid: 163, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefReviewProjectStatus' event (evid: 164)
 *
 * Event description: user click to review project status from the results page
 *
 * @param {briefReviewProjectStatusParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - the brief_id from the arena API
 * @return {LogObject<briefReviewProjectStatusParams>} LogObject<briefReviewProjectStatusParams>
 */
export function briefReviewProjectStatus(params) {
    return { evid: 164, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brief404Error' event (evid: 166)
 *
 * Event description: user views a 404 error page in the brief
 *
 * @param {brief404ErrorParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / seo / bm ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<brief404ErrorParams>} LogObject<brief404ErrorParams>
 */
export function brief404Error(params) {
    return { evid: 166, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'brief404ErrorTryAgain' event (evid: 167)
 *
 * Event description: user clicks on "try again" in the 404 error page in the brief
 *
 * @param {brief404ErrorTryAgainParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / seo / bm ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<brief404ErrorTryAgainParams>} LogObject<brief404ErrorTryAgainParams>
 */
export function brief404ErrorTryAgain(params) {
    return { evid: 167, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnExploreServices' event (evid: 168)
 *
 * Event description: User clicks on "Explore Services" on "browse all services"
 *
 * @param {homePageClickOnExploreServicesParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / home page strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnExploreServicesParams>} LogObject<homePageClickOnExploreServicesParams>
 */
export function homePageClickOnExploreServices(params) {
    return { evid: 168, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceSeeFullReviewClick' event (evid: 169)
 *
 * Event description: Fires when clicks to read the full review from the project details page in the Marketplace Dashboard
 *
 * @param {marketplaceSeeFullReviewClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} msid - review sites id
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceSeeFullReviewClickParams>} LogObject<marketplaceSeeFullReviewClickParams>
 */
export function marketplaceSeeFullReviewClick(params) {
    return { evid: 169, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOpenReplyToReviewClick' event (evid: 170)
 *
 * Event description: Fires, when clicks to open, reply window  to review
 *
 * @param {marketplaceOpenReplyToReviewClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceOpenReplyToReviewClickParams>} LogObject<marketplaceOpenReplyToReviewClickParams>
 */
export function marketplaceOpenReplyToReviewClick(params) {
    return { evid: 170, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePublishReplyToReview' event (evid: 171)
 *
 * Event description: Fires when partners click to publish a response to a review
 *
 * @param {marketplacePublishReplyToReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {string} text - response
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplacePublishReplyToReviewParams>} LogObject<marketplacePublishReplyToReviewParams>
 */
export function marketplacePublishReplyToReview(params) {
    return { evid: 171, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'joinMarketplaceLpClick' event (evid: 172)
 *
 * Event description: When clicking on CTA on join marketplace LP with click type for each CTA
 *
 * @param {joinMarketplaceLpClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} clickType - Which CTA
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<joinMarketplaceLpClickParams>} LogObject<joinMarketplaceLpClickParams>
 */
export function joinMarketplaceLpClick(params) {
    return { evid: 172, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewViewNewLeads' event (evid: 173)
 *
 * Event description: View New Leads in the Overview dashboard
 *
 * @param {overviewViewNewLeadsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewViewNewLeadsParams>} LogObject<overviewViewNewLeadsParams>
 */
export function overviewViewNewLeads(params) {
    return { evid: 173, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewLowCompletionRateWarningView' event (evid: 175)
 *
 * Event description: Overview - warning tooltip view (Low Completion Rate Warning).
 *
 * @param {overviewLowCompletionRateWarningViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60/90
 * @property {string} warning_type - warning_type
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewLowCompletionRateWarningViewParams>} LogObject<overviewLowCompletionRateWarningViewParams>
 */
export function overviewLowCompletionRateWarningView(params) {
    return { evid: 175, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewTableDateRangeSelection' event (evid: 176)
 *
 * Event description: Event fires when the user clicks change leads table date range
 *
 * @param {overviewTableDateRangeSelectionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60/90
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewTableDateRangeSelectionParams>} LogObject<overviewTableDateRangeSelectionParams>
 */
export function overviewTableDateRangeSelection(params) {
    return { evid: 176, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewTableOrderBy' event (evid: 177)
 *
 * Event description: Event fires when the users clicks to reorder the leads table Overview dashboard
 *
 * @param {overviewTableOrderByParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} orderType - service/leads....
 * @property {string} order_method - DESC/ASC
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewTableOrderByParams>} LogObject<overviewTableOrderByParams>
 */
export function overviewTableOrderBy(params) {
    return { evid: 177, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewClickLowCompletionRateWarning' event (evid: 178)
 *
 * Event description: Event fires when a user clicks to remove service form view Low Completion Rate Warningin the Overview dashboard
 *
 * @param {overviewClickLowCompletionRateWarningParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60...
 * @property {string} warning_type - specific service/location
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewClickLowCompletionRateWarningParams>} LogObject<overviewClickLowCompletionRateWarningParams>
 */
export function overviewClickLowCompletionRateWarning(params) {
    return { evid: 178, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewLoaded' event (evid: 179)
 *
 * Event description: Overview dashboard loaded
 *
 * @param {overviewLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewLoadedParams>} LogObject<overviewLoadedParams>
 */
export function overviewLoaded(params) {
    return { evid: 179, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickProFindClick' event (evid: 18)
 *
 * Event description: Quick Pro Find was clicked (go to breif for 6 random pros)
 *
 * @param {quickProFindClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {string} origin - {header/cta}
 * @property {boolean} isUserLoggedIn - is_user_logged_in
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<quickProFindClickParams>} LogObject<quickProFindClickParams>
 */
export function quickProFindClick(params) {
    return { evid: 18, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'overviewDisplayedCompletionRateWarning' event (evid: 180)
 *
 * Event description: Event fires when a user sees Low Completion Rate Warningin the Overview dashboard
 *
 * @param {overviewDisplayedCompletionRateWarningParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} warning_type - specific service/location
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewDisplayedCompletionRateWarningParams>} LogObject<overviewDisplayedCompletionRateWarningParams>
 */
export function overviewDisplayedCompletionRateWarning(params) {
    return { evid: 180, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'error' event (evid: 1801)
 *
 * Event description: Error in GF Serverless
 *
 * @param {errorParams} params - The parameters for this event
 * @property {string} errorType - error type
 * @return {LogObject<errorParams>} LogObject<errorParams>
 */
export function error(params) {
    return { evid: 1801, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getHiredPageLoaded' event (evid: 181)
 *
 * Event description: User vised the Get Hired page in the Marketplace
 *
 * @param {getHiredPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<getHiredPageLoadedParams>} LogObject<getHiredPageLoadedParams>
 */
export function getHiredPageLoaded(params) {
    return { evid: 181, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageAnswersInTheBrief' event (evid: 182)
 *
 * Event description: Fires when clicking next (or skip) and contains a string/JSON with all the questions and answers
 *
 * @param {pageAnswersInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} previousScreenName - previous Screen Name
 * @property {string} wowVersion - wow_version for testing
 * @property {string} sessionId - {}
 * @property {string} answer - Screen Q&A
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} nextScreenName - next screen name
 * @return {LogObject<pageAnswersInTheBriefParams>} LogObject<pageAnswersInTheBriefParams>
 */
export function pageAnswersInTheBrief(params) {
    return { evid: 182, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clicksOnScreenInTheBrief' event (evid: 183)
 *
 * Event description: Fires when clicking/selecting an option
 *
 * @param {clicksOnScreenInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {string} answer - Screen Q&A
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clicksOnScreenInTheBriefParams>} LogObject<clicksOnScreenInTheBriefParams>
 */
export function clicksOnScreenInTheBrief(params) {
    return { evid: 183, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'screenViewInTheBrief' event (evid: 184)
 *
 * Event description: Fires when a page is loaded on a screen
 *
 * @param {screenViewInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} previousScreenName - previous Screen Name
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<screenViewInTheBriefParams>} LogObject<screenViewInTheBriefParams>
 */
export function screenViewInTheBrief(params) {
    return { evid: 184, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leadsProjectsDashboardTableOrderBy' event (evid: 185)
 *
 * Event description: Event fires when the users clicks to reorder the leads table Leads/Projects views
 *
 * @param {leadsProjectsDashboardTableOrderByParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} order_type - Service/Date/Status..
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - Leads tab/Projects tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} order_method - DESC/ASC
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectsDashboardTableOrderByParams>} LogObject<leadsProjectsDashboardTableOrderByParams>
 */
export function leadsProjectsDashboardTableOrderBy(params) {
    return { evid: 185, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leadsProjectsDashboardSearch' event (evid: 186)
 *
 * Event description: Event fires when the users clicks to search
 *
 * @param {leadsProjectsDashboardSearchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} search_term - search what
 * @property {string} origin - Leads tab/Projects tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectsDashboardSearchParams>} LogObject<leadsProjectsDashboardSearchParams>
 */
export function leadsProjectsDashboardSearch(params) {
    return { evid: 186, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessRulesToastLoaded' event (evid: 188)
 *
 * Event description: Triggers on the load of a toast related to biz rules
 *
 * @param {businessRulesToastLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} toast - toast that triggers
 * @return {LogObject<businessRulesToastLoadedParams>} LogObject<businessRulesToastLoadedParams>
 */
export function businessRulesToastLoaded(params) {
    return { evid: 188, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessRulesClickToast' event (evid: 189)
 *
 * Event description: Triggers on the click of a toast related to biz rules
 *
 * @param {businessRulesClickToastParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} clickType - click type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} toast - toast that triggers
 * @return {LogObject<businessRulesClickToastParams>} LogObject<businessRulesClickToastParams>
 */
export function businessRulesClickToast(params) {
    return { evid: 189, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHpFiltering' event (evid: 19)
 *
 * Event description: expert pressed "my profile" (top right)
 *
 * @param {userHpFilteringParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterValue - (the country/lng)
 * @property {string} filterType - lng, country)
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - ranking , num_of_projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHpFilteringParams>} LogObject<userHpFilteringParams>
 */
export function userHpFiltering(params) {
    return { evid: 19, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceLightboxLoaded' event (evid: 190)
 *
 * Event description: triggers when load of a lightbox
 *
 * @param {marketplaceLightboxLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} lightboxType - lightbox type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceLightboxLoadedParams>} LogObject<marketplaceLightboxLoadedParams>
 */
export function marketplaceLightboxLoaded(params) {
    return { evid: 190, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceTabsGenericClick' event (evid: 192)
 *
 * Event description: Generic click in the marketplace Tabs
 *
 * @param {marketplaceTabsGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tab_name - name of the tab
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceTabsGenericClickParams>} LogObject<marketplaceTabsGenericClickParams>
 */
export function marketplaceTabsGenericClick(params) {
    return { evid: 192, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowGenericLoadPage' event (evid: 195)
 *
 * Event description: Generic loading page event
 *
 * @param {marketplacePostBriefFlowGenericLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} otherPartners - partners
 * @property {number} partnerPosition - partner_position
 * @property {boolean} matched - true if partner matched with user
 * @property {number} reviewsScore - review score
 * @property {string} partnerId - partner Id
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} pageName - page name
 * @property {string} matchedPartners - matched partners
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowGenericLoadPageParams>} LogObject<marketplacePostBriefFlowGenericLoadPageParams>
 */
export function marketplacePostBriefFlowGenericLoadPage(params) {
    return { evid: 195, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowGenericClick' event (evid: 196)
 *
 * Event description: Clicks in the post brief flow
 *
 * @param {marketplacePostBriefFlowGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tab - Tab
 * @property {number} partnerPosition - partner position
 * @property {boolean} matched - true if partner matched with user
 * @property {number} reviewsScore - score of reviews
 * @property {string} clickType - click_type
 * @property {string} partnerId - partner ID
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @property {string} product - product
 * @return {LogObject<marketplacePostBriefFlowGenericClickParams>} LogObject<marketplacePostBriefFlowGenericClickParams>
 */
export function marketplacePostBriefFlowGenericClick(params) {
    return { evid: 196, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowSendRequest' event (evid: 197)
 *
 * Event description: Fires when user sends request to partner
 *
 * @param {marketplacePostBriefFlowSendRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} partnerPosition - partner position
 * @property {number} reviewsScore - score of reviews
 * @property {string} partnerId - partner ID
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {string} jobId - job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowSendRequestParams>} LogObject<marketplacePostBriefFlowSendRequestParams>
 */
export function marketplacePostBriefFlowSendRequest(params) {
    return { evid: 197, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFunnelTooltipView' event (evid: 198)
 *
 * Event description: fires when user sees tooltip
 *
 * @param {marketplacePostBriefFunnelTooltipViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tooltipName - tooltip name
 * @property {string} partnerId - partner id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFunnelTooltipViewParams>} LogObject<marketplacePostBriefFunnelTooltipViewParams>
 */
export function marketplacePostBriefFunnelTooltipView(params) {
    return { evid: 198, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'timeRangeChosen' event (evid: 199)
 *
 * Event description: Fires when user changes the time range
 *
 * @param {timeRangeChosenParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeRange - 7,30,60,90
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<timeRangeChosenParams>} LogObject<timeRangeChosenParams>
 */
export function timeRangeChosen(params) {
    return { evid: 199, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'missingParametersErrorEvent' event (evid: 20)
 *
 * Event description: fired when can't fire another event due to missing params
 *
 * @param {missingParametersErrorEventParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterType - lng, country)
 * @property {string} param - {missing param}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - ranking , num_of_projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} event_id - {evid with missing param}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<missingParametersErrorEventParams>} LogObject<missingParametersErrorEventParams>
 */
export function missingParametersErrorEvent(params) {
    return { evid: 20, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceEmailMessageFromPartners' event (evid: 2001)
 *
 * Event description: Fires when partner sends a message to a lead from his email
 *
 * @param {marketplaceEmailMessageFromPartnersParams} params - The parameters for this event
 * @property {string} provider_id - provider_id
 * @property {string} contact_id - contact_id
 * @return {LogObject<marketplaceEmailMessageFromPartnersParams>} LogObject<marketplaceEmailMessageFromPartnersParams>
 */
export function marketplaceEmailMessageFromPartners(params) {
    return { evid: 2001, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceEmailMessageFromMarketplaceClientToProxyEmail' event (evid: 2002)
 *
 * Event description: Fires when marketplace client sends a message to a partner's proxy email
 *
 * @param {marketplaceEmailMessageFromMarketplaceClientToProxyEmailParams} params - The parameters for this event
 * @property {string} contact_id - contact_id
 * @return {LogObject<marketplaceEmailMessageFromMarketplaceClientToProxyEmailParams>} LogObject<marketplaceEmailMessageFromMarketplaceClientToProxyEmailParams>
 */
export function marketplaceEmailMessageFromMarketplaceClientToProxyEmail(params) {
    return { evid: 2002, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceEmailMessageFromUnknownClientToProxyEmail' event (evid: 2003)
 *
 * Event description: Fires when unknown client sends a message to a partner's proxy email
 *
 * @param {marketplaceEmailMessageFromUnknownClientToProxyEmailParams} params - The parameters for this event
 * @property {string} partnerId - partnerid
 * @property {string} contact_id - contact_id
 * @return {LogObject<marketplaceEmailMessageFromUnknownClientToProxyEmailParams>} LogObject<marketplaceEmailMessageFromUnknownClientToProxyEmailParams>
 */
export function marketplaceEmailMessageFromUnknownClientToProxyEmail(params) {
    return { evid: 2003, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasJoinProgram' event (evid: 201)
 *
 * Event description: Expert dashboard -> Product Betas -> Join program
 *
 * @param {expertDashboardProductBetasJoinProgramParams} params - The parameters for this event
 * @property {string} origin - which join was clicked? button / text
 * @return {LogObject<expertDashboardProductBetasJoinProgramParams>} LogObject<expertDashboardProductBetasJoinProgramParams>
 */
export function expertDashboardProductBetasJoinProgram(params) {
    return { evid: 201, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasClickGetStartedInPopUp' event (evid: 202)
 *
 * Event description: Expert dashboard -> Product Betas -> click get started in pop up
 *
 * @param {expertDashboardProductBetasClickGetStartedInPopUpParams} params - The parameters for this event
 * @return {LogObject<expertDashboardProductBetasClickGetStartedInPopUpParams>} LogObject<expertDashboardProductBetasClickGetStartedInPopUpParams>
 */
export function expertDashboardProductBetasClickGetStartedInPopUp(params) {
    return { evid: 202, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasClickCloseInPopUp' event (evid: 203)
 *
 * Event description: Expert dashboard -> Product Betas -> click 'close' in pop up
 *
 * @param {expertDashboardProductBetasClickCloseInPopUpParams} params - The parameters for this event
 * @property {string} origin - which close button was clicked? button / window
 * @return {LogObject<expertDashboardProductBetasClickCloseInPopUpParams>} LogObject<expertDashboardProductBetasClickCloseInPopUpParams>
 */
export function expertDashboardProductBetasClickCloseInPopUp(params) {
    return { evid: 203, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasViewBeta' event (evid: 204)
 *
 * Event description: User clicks "View Details" on a product beta
 *
 * @param {expertDashboardProductBetasViewBetaParams} params - The parameters for this event
 * @property {string} id - which product beta was clicked
 * @return {LogObject<expertDashboardProductBetasViewBetaParams>} LogObject<expertDashboardProductBetasViewBetaParams>
 */
export function expertDashboardProductBetasViewBeta(params) {
    return { evid: 204, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasClickSettings' event (evid: 205)
 *
 * Event description: Expert dashboard -> Product Betas -> Click Settings
 *
 * @param {expertDashboardProductBetasClickSettingsParams} params - The parameters for this event
 * @return {LogObject<expertDashboardProductBetasClickSettingsParams>} LogObject<expertDashboardProductBetasClickSettingsParams>
 */
export function expertDashboardProductBetasClickSettings(params) {
    return { evid: 205, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasChangeStatus' event (evid: 206)
 *
 * Event description: user decided to stay or leave the program
 *
 * @param {expertDashboardProductBetasChangeStatusParams} params - The parameters for this event
 * @return {LogObject<expertDashboardProductBetasChangeStatusParams>} LogObject<expertDashboardProductBetasChangeStatusParams>
 */
export function expertDashboardProductBetasChangeStatus(params) {
    return { evid: 206, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasSaveNewStatus' event (evid: 207)
 *
 * Event description: user decided to stay or leave the program
 *
 * @param {expertDashboardProductBetasSaveNewStatusParams} params - The parameters for this event
 * @property {boolean} isEnrolled - true / false
 * @return {LogObject<expertDashboardProductBetasSaveNewStatusParams>} LogObject<expertDashboardProductBetasSaveNewStatusParams>
 */
export function expertDashboardProductBetasSaveNewStatus(params) {
    return { evid: 207, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardLoaded' event (evid: 208)
 *
 * Event description: Expert dashboard - click on sidebar tab
 *
 * @param {expertDashboardLoadedParams} params - The parameters for this event
 * @property {string} tabName - News & Resources / Product Betas ...
 * @return {LogObject<expertDashboardLoadedParams>} LogObject<expertDashboardLoadedParams>
 */
export function expertDashboardLoaded(params) {
    return { evid: 208, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertForumClickOnPost' event (evid: 209)
 *
 * Event description: user clicks on a specific forum post from the forum component
 *
 * @param {expertForumClickOnPostParams} params - The parameters for this event
 * @property {string} app_site_id - The forum app_site_id
 * @return {LogObject<expertForumClickOnPostParams>} LogObject<expertForumClickOnPostParams>
 */
export function expertForumClickOnPost(params) {
    return { evid: 209, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHpHoverOverProProfile' event (evid: 21)
 *
 * Event description: user hovered over pro profile
 *
 * @param {userHpHoverOverProProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} proCardLocationId - pro_card_location_id
 * @property {GUID} visitorId - {visitor_guid if user no signed in}
 * @property {string} filterValue - filter_value
 * @property {string} filterType - filter_type
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - sort_type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<userHpHoverOverProProfileParams>} LogObject<userHpHoverOverProProfileParams>
 */
export function userHpHoverOverProProfile(params) {
    return { evid: 21, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardWatchVideo' event (evid: 210)
 *
 * Event description: user watches a video on News & Resources
 *
 * @param {expertDashboardWatchVideoParams} params - The parameters for this event
 * @return {LogObject<expertDashboardWatchVideoParams>} LogObject<expertDashboardWatchVideoParams>
 */
export function expertDashboardWatchVideo(params) {
    return { evid: 210, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newsResourcesChangeSorting' event (evid: 211)
 *
 * Event description: user changes the sorting method on News & Resources
 *
 * @param {newsResourcesChangeSortingParams} params - The parameters for this event
 * @property {string} sort_by - Featured / Recent
 * @return {LogObject<newsResourcesChangeSortingParams>} LogObject<newsResourcesChangeSortingParams>
 */
export function newsResourcesChangeSorting(params) {
    return { evid: 211, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newsResourcesChangeFilter' event (evid: 212)
 *
 * Event description: user changes the filter on News & Resources
 *
 * @param {newsResourcesChangeFilterParams} params - The parameters for this event
 * @property {string} filter_by - Trending, New Features, Marketing ...
 * @return {LogObject<newsResourcesChangeFilterParams>} LogObject<newsResourcesChangeFilterParams>
 */
export function newsResourcesChangeFilter(params) {
    return { evid: 212, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscribeForUpdatesAndReleases' event (evid: 213)
 *
 * Event description: user clicks on subscribe for updates and releases from banner in the expert dashboard
 *
 * @param {subscribeForUpdatesAndReleasesParams} params - The parameters for this event
 * @return {LogObject<subscribeForUpdatesAndReleasesParams>} LogObject<subscribeForUpdatesAndReleasesParams>
 */
export function subscribeForUpdatesAndReleases(params) {
    return { evid: 213, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardFinishLoad' event (evid: 214)
 *
 * Event description: Expert dashboard - finish load
 *
 * @param {expertDashboardFinishLoadParams} params - The parameters for this event
 * @property {string} origin - Dashboard / my-sites (referralAdditionalInfo)
 * @return {LogObject<expertDashboardFinishLoadParams>} LogObject<expertDashboardFinishLoadParams>
 */
export function expertDashboardFinishLoad(params) {
    return { evid: 214, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixExpertsAcademyClickOnTopbarTab' event (evid: 215)
 *
 * Event description: Wix Experts Academy - click on topbar tab
 *
 * @param {wixExpertsAcademyClickOnTopbarTabParams} params - The parameters for this event
 * @property {string} tabName - My Info / Courses Catalog ...
 * @return {LogObject<wixExpertsAcademyClickOnTopbarTabParams>} LogObject<wixExpertsAcademyClickOnTopbarTabParams>
 */
export function wixExpertsAcademyClickOnTopbarTab(params) {
    return { evid: 215, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'productBetasLeaveFeedback' event (evid: 216)
 *
 * Event description: User clicks "Leave Feedback" on a product beta
 *
 * @param {productBetasLeaveFeedbackParams} params - The parameters for this event
 * @property {string} id - which product beta was clicked
 * @return {LogObject<productBetasLeaveFeedbackParams>} LogObject<productBetasLeaveFeedbackParams>
 */
export function productBetasLeaveFeedback(params) {
    return { evid: 216, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialExpertDashboardHoverOnLockedTab' event (evid: 217)
 *
 * Event description: user hovers on a locked tab and displays with the "Unlock tab" message.
 *
 * @param {potentialExpertDashboardHoverOnLockedTabParams} params - The parameters for this event
 * @property {string} tabName - Forum / Homepage / Product Betas ...
 * @return {LogObject<potentialExpertDashboardHoverOnLockedTabParams>} LogObject<potentialExpertDashboardHoverOnLockedTabParams>
 */
export function potentialExpertDashboardHoverOnLockedTab(params) {
    return { evid: 217, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialExpertDashboardClickOnCheckStatus' event (evid: 218)
 *
 * Event description: user clicks on the "Check Status" button when he tries to open one of the tabs that are available only for experts
 *
 * @param {potentialExpertDashboardClickOnCheckStatusParams} params - The parameters for this event
 * @property {string} tabName - Forum / Homepage / Product Betas ...
 * @return {LogObject<potentialExpertDashboardClickOnCheckStatusParams>} LogObject<potentialExpertDashboardClickOnCheckStatusParams>
 */
export function potentialExpertDashboardClickOnCheckStatus(params) {
    return { evid: 218, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webinarsClickOnRegister' event (evid: 219)
 *
 * Event description: user clicks on the "Register" button on the top banner at the expert dashboard.
 *
 * @param {webinarsClickOnRegisterParams} params - The parameters for this event
 * @property {string} title - the webinar title
 * @return {LogObject<webinarsClickOnRegisterParams>} LogObject<webinarsClickOnRegisterParams>
 */
export function webinarsClickOnRegister(params) {
    return { evid: 219, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userProProfileProProfileClick' event (evid: 22)
 *
 * Event description: User clicks on an expert profile
 *
 * @param {userProProfileProProfileClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {number} proCardLocationId - not in use
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - Json with all the filters
 * @property {number} innerType - not in use
 * @property {string} filterType - not in use
 * @property {string} term - not in use
 * @property {string} expertTotalScore - ETS
 * @property {number} reviewsScore - total reviews score
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} thumbnailId - not in use
 * @property {string} language - not in use
 * @property {string} sortType - not in use
 * @property {string} origin - {homepage / summary / search}
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<userProProfileProProfileClickParams>} LogObject<userProProfileProProfileClickParams>
 */
export function userProProfileProProfileClick(params) {
    return { evid: 22, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasAddBeta' event (evid: 220)
 *
 * Event description: product add new beta
 *
 * @param {expertDashboardProductBetasAddBetaParams} params - The parameters for this event
 * @property {string} origin - which join was clicked? button / text
 * @property {string} id - beta guid
 * @return {LogObject<expertDashboardProductBetasAddBetaParams>} LogObject<expertDashboardProductBetasAddBetaParams>
 */
export function expertDashboardProductBetasAddBeta(params) {
    return { evid: 220, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessRulesRuleTriggered' event (evid: 2201)
 *
 * Event description: Triggers on every rule
 *
 * @param {businessRulesRuleTriggeredParams} params - The parameters for this event
 * @property {string} effect - effect
 * @property {string} cause - cause
 * @return {LogObject<businessRulesRuleTriggeredParams>} LogObject<businessRulesRuleTriggeredParams>
 */
export function businessRulesRuleTriggered(params) {
    return { evid: 2201, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasSaveBeta' event (evid: 221)
 *
 * Event description: product saved beta
 *
 * @param {expertDashboardProductBetasSaveBetaParams} params - The parameters for this event
 * @property {string} id - Beta_guid
 * @return {LogObject<expertDashboardProductBetasSaveBetaParams>} LogObject<expertDashboardProductBetasSaveBetaParams>
 */
export function expertDashboardProductBetasSaveBeta(params) {
    return { evid: 221, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardProductBetasPublishBeta' event (evid: 222)
 *
 * Event description: product published beta
 *
 * @param {expertDashboardProductBetasPublishBetaParams} params - The parameters for this event
 * @property {string} id - beta guid
 * @property {string} publish_type - Publish/unpublished
 * @return {LogObject<expertDashboardProductBetasPublishBetaParams>} LogObject<expertDashboardProductBetasPublishBetaParams>
 */
export function expertDashboardProductBetasPublishBeta(params) {
    return { evid: 222, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDealsContactUs' event (evid: 223)
 *
 * Event description: user clicks on "contact us" button in the partner deals
 *
 * @param {partnersDealsContactUsParams} params - The parameters for this event
 * @return {LogObject<partnersDealsContactUsParams>} LogObject<partnersDealsContactUsParams>
 */
export function partnersDealsContactUs(params) {
    return { evid: 223, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDealsViewPlanDetails' event (evid: 224)
 *
 * Event description: user clicks on "view plan details" button in the partner deals
 *
 * @param {partnersDealsViewPlanDetailsParams} params - The parameters for this event
 * @property {number} totalCouponsAvailable - number of available coupons
 * @property {number} totalCouponsPurchased - number of coupons in the deal
 * @property {string} productName - the plan name from premium (business unlimited/combo...)
 * @return {LogObject<partnersDealsViewPlanDetailsParams>} LogObject<partnersDealsViewPlanDetailsParams>
 */
export function partnersDealsViewPlanDetails(params) {
    return { evid: 224, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDealsApplyACoupon' event (evid: 225)
 *
 * Event description: user clicks on "apply a coupon" button in the partner deals
 *
 * @param {partnersDealsApplyACouponParams} params - The parameters for this event
 * @property {number} totalCouponsAvailable - number of available coupons
 * @property {number} totalCouponsPurchased - number of coupons in the deal
 * @property {string} productName - the plan name from premium (business unlimited/combo...)
 * @return {LogObject<partnersDealsApplyACouponParams>} LogObject<partnersDealsApplyACouponParams>
 */
export function partnersDealsApplyACoupon(params) {
    return { evid: 225, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardOpenForum' event (evid: 226)
 *
 * Event description: user clicks on a button in the partner dashboard to open the forum
 *
 * @param {partnerDashboardOpenForumParams} params - The parameters for this event
 * @property {string} origin - from which page he clicked - partner resources/news & resources
 * @return {LogObject<partnerDashboardOpenForumParams>} LogObject<partnerDashboardOpenForumParams>
 */
export function partnerDashboardOpenForum(params) {
    return { evid: 226, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardOpenBlog' event (evid: 227)
 *
 * Event description: user clicks on a button in the partner dashboard to open the blog
 *
 * @param {partnerDashboardOpenBlogParams} params - The parameters for this event
 * @property {string} origin - from which page he clicked - partner resources/news & resources
 * @return {LogObject<partnerDashboardOpenBlogParams>} LogObject<partnerDashboardOpenBlogParams>
 */
export function partnerDashboardOpenBlog(params) {
    return { evid: 227, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardOpenFeatures' event (evid: 228)
 *
 * Event description: user clicks on a button in the partner dashboard to see all features
 *
 * @param {partnerDashboardOpenFeaturesParams} params - The parameters for this event
 * @property {string} origin - from which page he clicked - partner resources/news & resources
 * @return {LogObject<partnerDashboardOpenFeaturesParams>} LogObject<partnerDashboardOpenFeaturesParams>
 */
export function partnerDashboardOpenFeatures(params) {
    return { evid: 228, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardOpenReleaseNotes' event (evid: 229)
 *
 * Event description: user clicks on a button in the partner dashboard to see all release notes
 *
 * @param {partnerDashboardOpenReleaseNotesParams} params - The parameters for this event
 * @property {string} origin - from which page he clicked - partner resources/news & resources
 * @return {LogObject<partnerDashboardOpenReleaseNotesParams>} LogObject<partnerDashboardOpenReleaseNotesParams>
 */
export function partnerDashboardOpenReleaseNotes(params) {
    return { evid: 229, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHpBrowseProThumbnails' event (evid: 23)
 *
 * Event description: user browses in pro/project thumbnail
 *
 * @param {userHpBrowseProThumbnailsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} proCardLocationId - pro_card_location_id
 * @property {GUID} visitorId - {}
 * @property {string} filterValue - filter_value
 * @property {string} filterType - filter_type
 * @property {GUID} projectId - project_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} thumbnailId - thumbnail_id
 * @property {string} sortType - sort_type
 * @property {string} origin - {homepage / summary}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<userHpBrowseProThumbnailsParams>} LogObject<userHpBrowseProThumbnailsParams>
 */
export function userHpBrowseProThumbnails(params) {
    return { evid: 23, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardClickOnSupportCard' event (evid: 230)
 *
 * Event description: user clicks on request a callback or a priority ticket from the support card
 *
 * @param {partnerDashboardClickOnSupportCardParams} params - The parameters for this event
 * @property {string} supportType - call-back/priority-ticket
 * @property {string} origin - from which page he clicked - partner resources/news & resources
 * @return {LogObject<partnerDashboardClickOnSupportCardParams>} LogObject<partnerDashboardClickOnSupportCardParams>
 */
export function partnerDashboardClickOnSupportCard(params) {
    return { evid: 230, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceWidgetClick' event (evid: 231)
 *
 * Event description: Clicked on Marketplace widget
 *
 * @param {marketplaceWidgetClickParams} params - The parameters for this event
 * @property {string} click_type - Name of the button clicked
 * @property {string} widget_state - mode of widget displayed
 * @return {LogObject<marketplaceWidgetClickParams>} LogObject<marketplaceWidgetClickParams>
 */
export function marketplaceWidgetClick(params) {
    return { evid: 231, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackWidgetLoaded' event (evid: 232)
 *
 * Event description: get feedback widget loaded ( in a specific state)
 *
 * @param {getFeedbackWidgetLoadedParams} params - The parameters for this event
 * @property {string} widget_state - mode of widget displayed
 * @return {LogObject<getFeedbackWidgetLoadedParams>} LogObject<getFeedbackWidgetLoadedParams>
 */
export function getFeedbackWidgetLoaded(params) {
    return { evid: 232, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFeedbackWidgetClick' event (evid: 233)
 *
 * Event description: clicked get feedback widget
 *
 * @param {getFeedbackWidgetClickParams} params - The parameters for this event
 * @property {string} click_type - Name of the button clicked
 * @property {string} widget_state - mode of widget displayed
 * @property {GUID} msid - guid
 * @return {LogObject<getFeedbackWidgetClickParams>} LogObject<getFeedbackWidgetClickParams>
 */
export function getFeedbackWidgetClick(params) {
    return { evid: 233, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceWidgetLoaded' event (evid: 234)
 *
 * Event description: Marketplace widget loaded (in a specific state)
 *
 * @param {marketplaceWidgetLoadedParams} params - The parameters for this event
 * @property {number} new_leads - Displayed counter of new leads
 * @property {number} leads_in_progress - Displayed counter of leads in progress
 * @property {number} projects_completed - Displayed projects completed
 * @property {number} completion_rate - Displayed completion rate
 * @property {string} widget_state - mode of widget displayed
 * @return {LogObject<marketplaceWidgetLoadedParams>} LogObject<marketplaceWidgetLoadedParams>
 */
export function marketplaceWidgetLoaded(params) {
    return { evid: 234, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixNewsWidgetSeeAllClick' event (evid: 235)
 *
 * Event description: Clicks to see all posts on Wix news widget
 *
 * @param {wixNewsWidgetSeeAllClickParams} params - The parameters for this event
 * @return {LogObject<wixNewsWidgetSeeAllClickParams>} LogObject<wixNewsWidgetSeeAllClickParams>
 */
export function wixNewsWidgetSeeAllClick(params) {
    return { evid: 235, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixNewsWidgetReadPostClick' event (evid: 236)
 *
 * Event description: Clicks to on post on Wix news widget
 *
 * @param {wixNewsWidgetReadPostClickParams} params - The parameters for this event
 * @property {string} post_id - guid of post
 * @property {string} post_type - Type of post in feed
 * @return {LogObject<wixNewsWidgetReadPostClickParams>} LogObject<wixNewsWidgetReadPostClickParams>
 */
export function wixNewsWidgetReadPostClick(params) {
    return { evid: 236, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingScreenView' event (evid: 237)
 *
 * Event description: Event fires when a screen from the onboarding flow is loaded (including the empty state)
 *
 * @param {partnersOnboardingScreenViewParams} params - The parameters for this event
 * @property {string} source - onboarding lp / dashboard
 * @property {string} screenName - empty state / business type
 * @property {string} origin - where user came from (referral)
 * @property {string} platform - Studio in case the user joined the program from studio
 * @property {string} version - the version of the flow
 * @return {LogObject<partnersOnboardingScreenViewParams>} LogObject<partnersOnboardingScreenViewParams>
 */
export function partnersOnboardingScreenView(params) {
    return { evid: 237, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingJoinNow' event (evid: 238)
 *
 * Event description: Event fires when user clicks on “join now” to start the partner program onboarding.
 *
 * @param {partnersOnboardingJoinNowParams} params - The parameters for this event
 * @property {string} source - onboarding lp / dashboard
 * @property {string} origin - where user came from (referral)
 * @return {LogObject<partnersOnboardingJoinNowParams>} LogObject<partnersOnboardingJoinNowParams>
 */
export function partnersOnboardingJoinNow(params) {
    return { evid: 238, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingLearnMore' event (evid: 239)
 *
 * Event description: Event fires when a user clicks on “learn more” in the partner program home tab.
 *
 * @param {partnersOnboardingLearnMoreParams} params - The parameters for this event
 * @property {string} source - onboarding lp / dashboard
 * @return {LogObject<partnersOnboardingLearnMoreParams>} LogObject<partnersOnboardingLearnMoreParams>
 */
export function partnersOnboardingLearnMore(params) {
    return { evid: 239, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefFormEditingInfo' event (evid: 24)
 *
 * Event description: filter field was clicked (either lang or location); In mobile this is triggered by clicking the "location" or "language"
 *
 * @param {briefFormEditingInfoParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} session_id - depreciated
 * @property {boolean} isMandatory - depreciated
 * @property {number} briefPageNum - depreciated
 * @property {string} field_type - depreciated
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} fieldLength - depreciated
 * @property {string} fieldName - {Languages ; location}
 * @property {boolean} isAboveFold - depreciated
 * @property {boolean} isMultiplePros - depreciated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - depreciated
 * @property {GUID} proGuid - depreciated
 * @return {LogObject<briefFormEditingInfoParams>} LogObject<briefFormEditingInfoParams>
 */
export function briefFormEditingInfo(params) {
    return { evid: 24, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingClickBack' event (evid: 240)
 *
 * Event description: Event fires when user clicks on the “back” button on the screen.
 *
 * @param {partnersOnboardingClickBackParams} params - The parameters for this event
 * @property {string} screenName - business type / business info / contact info
 * @return {LogObject<partnersOnboardingClickBackParams>} LogObject<partnersOnboardingClickBackParams>
 */
export function partnersOnboardingClickBack(params) {
    return { evid: 240, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramOfficialPartnerStatusChange' event (evid: 2401)
 *
 * Event description: Event Fires when a user changes his partner program status
 *
 * @param {partnerProgramOfficialPartnerStatusChangeParams} params - The parameters for this event
 * @property {DateTime} onboardedDate - onboarded_date
 * @property {GUID} accountId - uuid
 * @property {boolean} isOfficalPartner - bool
 * @return {LogObject<partnerProgramOfficialPartnerStatusChangeParams>} LogObject<partnerProgramOfficialPartnerStatusChangeParams>
 */
export function partnerProgramOfficialPartnerStatusChange(params) {
    return { evid: 2401, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingClickNextSubmit' event (evid: 241)
 *
 * Event description: Event fires when user clicks on the “next” button to move to the next question or on "submit" to submit the request to join the partner program.
 *
 * @param {partnersOnboardingClickNextSubmitParams} params - The parameters for this event
 * @property {boolean} isValid - true / false if the request is valid
 * @property {string} screenName - business type / business info / contact info
 * @property {string} invalidFields - json with invalid mandatory questions
 * @return {LogObject<partnersOnboardingClickNextSubmitParams>} LogObject<partnersOnboardingClickNextSubmitParams>
 */
export function partnersOnboardingClickNextSubmit(params) {
    return { evid: 241, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingClickAnAnswer' event (evid: 242)
 *
 * Event description: Event fires when user clicks on an answer on the screen.
 *
 * @param {partnersOnboardingClickAnAnswerParams} params - The parameters for this event
 * @property {string} questionName - agency size / job title / services
 * @property {string} screenName - business type / business info / contact info
 * @property {string} answer - design / seo / owner ...
 * @return {LogObject<partnersOnboardingClickAnAnswerParams>} LogObject<partnersOnboardingClickAnAnswerParams>
 */
export function partnersOnboardingClickAnAnswer(params) {
    return { evid: 242, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingFinish' event (evid: 243)
 *
 * Event description: Event fires when user finishes the onboarding. (click on the submit + all the answers are valid)
 *
 * @param {partnersOnboardingFinishParams} params - The parameters for this event
 * @property {string} agencySize - not in use
 * @property {boolean} phoneFilled - true if phone is filled
 * @property {boolean} checkFullService - true / false
 * @property {string} businessType - agency / freelancer / other
 * @property {string} businessWebsite - website answer
 * @property {boolean} checkWebDevelopment - true / false
 * @property {boolean} checkBranding - true / false
 * @property {boolean} checkMarketing - true / false
 * @property {string} otherBusiness - not in use
 * @property {string} onboardingVersion - V1/V2..
 * @property {string} typeOfBusiness - other business answer
 * @property {string} numberOfEmployees - 1-4 / 5-15 / 16+
 * @property {string} origin - where user came from (referral)
 * @property {string} businessName - business name answer
 * @property {string} jobTitle - owner / designer ...
 * @property {boolean} checkSEO - true / false
 * @property {boolean} checkDesign - true / false
 * @return {LogObject<partnersOnboardingFinishParams>} LogObject<partnersOnboardingFinishParams>
 */
export function partnersOnboardingFinish(params) {
    return { evid: 243, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyWidgetHoverOnBadgeTooltip' event (evid: 244)
 *
 * Event description: Partner hovered on badge tooltip to get more details about their level
 *
 * @param {loyaltyWidgetHoverOnBadgeTooltipParams} params - The parameters for this event
 * @property {number} points - how many points they have
 * @property {string} partner_level - name of level
 * @return {LogObject<loyaltyWidgetHoverOnBadgeTooltipParams>} LogObject<loyaltyWidgetHoverOnBadgeTooltipParams>
 */
export function loyaltyWidgetHoverOnBadgeTooltip(params) {
    return { evid: 244, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyWidgetClickedViewDetails' event (evid: 245)
 *
 * Event description: Clicked on view details link on loyalty widget - will lead them to the partner program home
 *
 * @param {loyaltyWidgetClickedViewDetailsParams} params - The parameters for this event
 * @property {number} points - how many points they have
 * @property {string} partner_level - name of level
 * @return {LogObject<loyaltyWidgetClickedViewDetailsParams>} LogObject<loyaltyWidgetClickedViewDetailsParams>
 */
export function loyaltyWidgetClickedViewDetails(params) {
    return { evid: 245, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceTabApplyToJoinPageLoaded' event (evid: 246)
 *
 * Event description: fires when in the Partner Dashboard click on the left tab 'marketplace' and page loaded on all states prior to being Marketplace partner
 *
 * @param {marketplaceTabApplyToJoinPageLoadedParams} params - The parameters for this event
 * @property {string} pageState - 'allegeable to apply'/'approve'/'not allegeable'...
 * @property {string} platform - The platform the user is using
 * @return {LogObject<marketplaceTabApplyToJoinPageLoadedParams>} LogObject<marketplaceTabApplyToJoinPageLoadedParams>
 */
export function marketplaceTabApplyToJoinPageLoaded(params) {
    return { evid: 246, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceTabApplyToJoinPageClicks' event (evid: 247)
 *
 * Event description: fires, when a partner clicks on a button at the Partner Dashboard marketplace tab, on all states prior to being Marketplace partner
 *
 * @param {marketplaceTabApplyToJoinPageClicksParams} params - The parameters for this event
 * @property {string} clickType - click name on each state of the page
 * @property {string} pageState - 'allegeable to join'  and all other states
 * @property {string} platform - The platform the user is using - Wix.com / Wix studio
 * @return {LogObject<marketplaceTabApplyToJoinPageClicksParams>} LogObject<marketplaceTabApplyToJoinPageClicksParams>
 */
export function marketplaceTabApplyToJoinPageClicks(params) {
    return { evid: 247, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramCreateNewSiteButtonClick' event (evid: 249)
 *
 * Event description: Clicked on "Create New Site" button in the Partner Program Home
 *
 * @param {partnerProgramCreateNewSiteButtonClickParams} params - The parameters for this event
 * @return {LogObject<partnerProgramCreateNewSiteButtonClickParams>} LogObject<partnerProgramCreateNewSiteButtonClickParams>
 */
export function partnerProgramCreateNewSiteButtonClick(params) {
    return { evid: 249, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefFormNavigationClick' event (evid: 25)
 *
 * Event description: client click on "See more experts" when reading the brief he sent
 *
 * @param {briefFormNavigationClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - ow long the user was in the page time_in_page (mlsec)
 * @property {GUID} jobRequestId - {}
 * @property {string} typeOfService - new site, existing site, logo
 * @property {string} navButtonLocation - depreciated
 * @property {boolean} isError - depreciated
 * @property {number} destBriefPage - depreciated
 * @property {string} navDirection - depreciated
 * @property {string} errorDesc - depreciated
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} filledFields - depreciated
 * @property {number} srcBriefPage - depreciated
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros -  (0,1) - is it for a specific pro or for random multiple pros
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefFormNavigationClickParams>} LogObject<briefFormNavigationClickParams>
 */
export function briefFormNavigationClick(params) {
    return { evid: 25, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramPageLoaded' event (evid: 250)
 *
 * Event description: Partner Program - finish loading. On each page in every tab
 *
 * @param {partnerProgramPageLoadedParams} params - The parameters for this event
 * @property {string} partner_level - The level of the user in partner program
 * @property {string} sub_tab - sub tab name in tab
 * @property {string} state - state
 * @property {string} tab_name - tab in dashboard
 * @property {string} origin - where the user came from
 * @property {GUID} contactId - contact_id
 * @property {string} platform - The platform the user is using
 * @property {string} dashboard_msid - The msid of the partners dashboard
 * @return {LogObject<partnerProgramPageLoadedParams>} LogObject<partnerProgramPageLoadedParams>
 */
export function partnerProgramPageLoaded(params) {
    return { evid: 250, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramDashboardAppNotProvisionedDashboardDidnTLoad' event (evid: 251)
 *
 * Event description: app not provisioned - the dashboard app didn't load
 *
 * @param {partnerProgramDashboardAppNotProvisionedDashboardDidnTLoadParams} params - The parameters for this event
 * @return {LogObject<partnerProgramDashboardAppNotProvisionedDashboardDidnTLoadParams>} LogObject<partnerProgramDashboardAppNotProvisionedDashboardDidnTLoadParams>
 */
export function partnerProgramDashboardAppNotProvisionedDashboardDidnTLoad(params) {
    return { evid: 251, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramOnboardingNotComplete' event (evid: 252)
 *
 * Event description: Flags when Partner Program home can't load because the onboarding doesn't finish
 *
 * @param {partnerProgramOnboardingNotCompleteParams} params - The parameters for this event
 * @return {LogObject<partnerProgramOnboardingNotCompleteParams>} LogObject<partnerProgramOnboardingNotCompleteParams>
 */
export function partnerProgramOnboardingNotComplete(params) {
    return { evid: 252, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramTeamsWidgetSetUpTeamClick' event (evid: 253)
 *
 * Event description: Clicked on "set up Team" button in Team management widget (Partner Home Dashboard)
 *
 * @param {partnerProgramTeamsWidgetSetUpTeamClickParams} params - The parameters for this event
 * @return {LogObject<partnerProgramTeamsWidgetSetUpTeamClickParams>} LogObject<partnerProgramTeamsWidgetSetUpTeamClickParams>
 */
export function partnerProgramTeamsWidgetSetUpTeamClick(params) {
    return { evid: 253, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingOnboardingPreSetupClicks' event (evid: 254)
 *
 * Event description: clicks on buttons in the onboarding pre setup
 *
 * BI presentation
 * :https://docs.google.com/presentation/d/1ex_1xi4AqseVSmdedOvSlp08PBBxBYCDsp_Zwk9LTUc/edit?usp=sharing
 *
 * @param {coBrandingOnboardingPreSetupClicksParams} params - The parameters for this event
 * @property {string} button_name - contact us/ send request for call back / set up now
 * @property {GUID} uuid - user id
 * @return {LogObject<coBrandingOnboardingPreSetupClicksParams>} LogObject<coBrandingOnboardingPreSetupClicksParams>
 */
export function coBrandingOnboardingPreSetupClicks(params) {
    return { evid: 254, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingOnboardingInSetupClicks' event (evid: 255)
 *
 * Event description: Co-Branding - Onboarding - In Setup clicks.
 *
 * @param {coBrandingOnboardingInSetupClicksParams} params - The parameters for this event
 * @property {string} step_name - step_name
 * @property {GUID} uuid - uuid
 * @property {string} button_name - done
 * @return {LogObject<coBrandingOnboardingInSetupClicksParams>} LogObject<coBrandingOnboardingInSetupClicksParams>
 */
export function coBrandingOnboardingInSetupClicks(params) {
    return { evid: 255, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingOnboardingImageUploaded' event (evid: 256)
 *
 * Event description: User uploaded image in the onboarding setup
 *
 * BI presentation
 * :https://docs.google.com/presentation/d/1ex_1xi4AqseVSmdedOvSlp08PBBxBYCDsp_Zwk9LTUc/edit?usp=sharing
 *
 * @param {coBrandingOnboardingImageUploadedParams} params - The parameters for this event
 * @property {string} step_name - logo / icon / banner / header
 * @property {GUID} uuid - user id
 * @return {LogObject<coBrandingOnboardingImageUploadedParams>} LogObject<coBrandingOnboardingImageUploadedParams>
 */
export function coBrandingOnboardingImageUploaded(params) {
    return { evid: 256, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingOnboardingAllSetupSectionsComplete' event (evid: 257)
 *
 * Event description: User finished all the setup sections
 *
 * BI presentation
 * :https://docs.google.com/presentation/d/1ex_1xi4AqseVSmdedOvSlp08PBBxBYCDsp_Zwk9LTUc/edit?usp=sharing
 *
 * @param {coBrandingOnboardingAllSetupSectionsCompleteParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @return {LogObject<coBrandingOnboardingAllSetupSectionsCompleteParams>} LogObject<coBrandingOnboardingAllSetupSectionsCompleteParams>
 */
export function coBrandingOnboardingAllSetupSectionsComplete(params) {
    return { evid: 257, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountManagementWidgetCta' event (evid: 258)
 *
 * Event description: Clicked on account management widget in the Partner Home
 *
 * @param {accountManagementWidgetCtaParams} params - The parameters for this event
 * @property {string} platform - The platform the user is using
 * @return {LogObject<accountManagementWidgetCtaParams>} LogObject<accountManagementWidgetCtaParams>
 */
export function accountManagementWidgetCta(params) {
    return { evid: 258, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountManagementWidgetCallRequested' event (evid: 259)
 *
 * Event description: Requested a call form the account management widget in the Partner Home
 *
 * @param {accountManagementWidgetCallRequestedParams} params - The parameters for this event
 * @property {string} subject - what the call is about
 * @return {LogObject<accountManagementWidgetCallRequestedParams>} LogObject<accountManagementWidgetCallRequestedParams>
 */
export function accountManagementWidgetCallRequested(params) {
    return { evid: 259, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyWidgetClickedGetMorePoints' event (evid: 260)
 *
 * Event description: Fires when the user clicks on "Get More Points"
 *
 * @param {loyaltyWidgetClickedGetMorePointsParams} params - The parameters for this event
 * @property {number} points - Partner's current Points
 * @property {string} origin - Origin of the click
 * @property {string} level - Partner's current level
 * @return {LogObject<loyaltyWidgetClickedGetMorePointsParams>} LogObject<loyaltyWidgetClickedGetMorePointsParams>
 */
export function loyaltyWidgetClickedGetMorePoints(params) {
    return { evid: 260, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceMatchingPartnersToClient' event (evid: 2601)
 *
 * Event description: Fires every time there is a match between a client and a partner
 *
 * @param {marketplaceMatchingPartnersToClientParams} params - The parameters for this event
 * @property {GUID} briefId - brief id
 * @property {string} matches - a json with: provider_id, engine, project, order_num
 * @return {LogObject<marketplaceMatchingPartnersToClientParams>} LogObject<marketplaceMatchingPartnersToClientParams>
 */
export function marketplaceMatchingPartnersToClient(params) {
    return { evid: 2601, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revShareInvoiceWasCreatedInTipalti' event (evid: 2602)
 *
 * Event description: Rev share Invoice was created in Tipalti
 *
 * @param {revShareInvoiceWasCreatedInTipaltiParams} params - The parameters for this event
 * @property {string} payout_id_list - list of payouts id's paid in this invoice
 * @property {number} invoice_amount - Total amount paid in the invoice
 * @property {string} invoice_ref_code - Id of the invoice created
 * @property {string} tipalti_id - tipalti id of the partner the invoice belong
 * @property {string} invoice_amount_string - Total amount paid in the invoice - string type to allow digits after the point for decimal number
 * @return {LogObject<revShareInvoiceWasCreatedInTipaltiParams>} LogObject<revShareInvoiceWasCreatedInTipaltiParams>
 */
export function revShareInvoiceWasCreatedInTipalti(params) {
    return { evid: 2602, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failedToCreateTipaltiInvoiceForThisPayoutId' event (evid: 2603)
 *
 * Event description: Failed to create invoice for this rev share payout id in tipalti
 *
 * @param {failedToCreateTipaltiInvoiceForThisPayoutIdParams} params - The parameters for this event
 * @property {string} payout_id - id of the payout we tried to create invoice for
 * @property {string} rev_share_type - GPV or Plan
 * @property {string} error - Error received from tipalti when failed to create invoice
 * @return {LogObject<failedToCreateTipaltiInvoiceForThisPayoutIdParams>} LogObject<failedToCreateTipaltiInvoiceForThisPayoutIdParams>
 */
export function failedToCreateTipaltiInvoiceForThisPayoutId(params) {
    return { evid: 2603, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earnPointsClick' event (evid: 261)
 *
 * Event description: Fires on generic clicks in the "Earn Points" Tab
 *
 * @param {earnPointsClickParams} params - The parameters for this event
 * @property {string} clickType - Depending on where the user clicked
 * @property {number} points - Partner's Points
 * @property {string} level - Partner's Level
 * @return {LogObject<earnPointsClickParams>} LogObject<earnPointsClickParams>
 */
export function earnPointsClick(params) {
    return { evid: 261, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leadsProjectDetailGenericClick' event (evid: 265)
 *
 * Event description: Fires on any click on the leads/Project detail page
 *
 * @param {leadsProjectDetailGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - Job's ID
 * @property {string} jobStatus - job_status
 * @property {string} clickType - button pressed by user
 * @property {string} origin - origin: leads/project tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectDetailGenericClickParams>} LogObject<leadsProjectDetailGenericClickParams>
 */
export function leadsProjectDetailGenericClick(params) {
    return { evid: 265, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersSettingsClick' event (evid: 266)
 *
 * Event description: Fires when user clicks on save in Partners Settings
 *
 * @param {partnersSettingsClickParams} params - The parameters for this event
 * @property {string} clickType - where the user clicked
 * @property {string} fieldsUpdated - csv of all fields updated
 * @return {LogObject<partnersSettingsClickParams>} LogObject<partnersSettingsClickParams>
 */
export function partnersSettingsClick(params) {
    return { evid: 266, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerSettingsLeaveWithoutSaving' event (evid: 267)
 *
 * Event description: Fires when the user tries to leave the settings without saving.
 *
 * @param {partnerSettingsLeaveWithoutSavingParams} params - The parameters for this event
 * @return {LogObject<partnerSettingsLeaveWithoutSavingParams>} LogObject<partnerSettingsLeaveWithoutSavingParams>
 */
export function partnerSettingsLeaveWithoutSaving(params) {
    return { evid: 267, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDashboardGenericClick' event (evid: 268)
 *
 * Event description: Fires on clicks in the partner Dashboard.
 *
 * @param {partnersDashboardGenericClickParams} params - The parameters for this event
 * @property {string} partner_level - the level of the partner in the partners program
 * @property {string} tab - The tab where the click happens
 * @property {string} option - option
 * @property {string} widget_type - the type of widget shown, depends on the user level and platform
 * @property {string} clickType - Type of click
 * @property {string} origin - origin
 * @property {string} platform - the platform the user is using while clicking
 * @property {GUID} dashboard_msid - The msid of the partner dashboard - unique per account
 * @property {GUID} msid - msid - relevant for clicks on sites
 * @property {string} product - The product this click apply to
 * @return {LogObject<partnersDashboardGenericClickParams>} LogObject<partnersDashboardGenericClickParams>
 */
export function partnersDashboardGenericClick(params) {
    return { evid: 268, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefFormSubmitWasClicked' event (evid: 27)
 *
 * Event description: client scrolls down when reading his submitted brief. "see more experts" button is shown
 *
 * @param {briefFormSubmitWasClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - ow long the user was in the page time_in_page (mlsec)
 * @property {GUID} jobRequestId - {}
 * @property {string} typeOfService - new site, existing site, logo
 * @property {boolean} isError - depreciated
 * @property {string} errorDesc - depreciated
 * @property {number} typeid - {}
 * @property {string} filledFields - depreciated
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros -  (0,1) - is it for a specific pro or for random multiple pros
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefFormSubmitWasClickedParams>} LogObject<briefFormSubmitWasClickedParams>
 */
export function briefFormSubmitWasClicked(params) {
    return { evid: 27, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardGenericHovering' event (evid: 270)
 *
 * Event description: Fires when the user hovers
 *
 * @param {partnerDashboardGenericHoveringParams} params - The parameters for this event
 * @property {string} tab - Tab
 * @property {string} hoverType - Which tooltip
 * @property {string} product - Which product does apply
 * @property {number} seconds_opened - Seconds that the hover lasted
 * @return {LogObject<partnerDashboardGenericHoveringParams>} LogObject<partnerDashboardGenericHoveringParams>
 */
export function partnerDashboardGenericHovering(params) {
    return { evid: 270, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revShareEligibilityFunnelEventSrc80Evid2700' event (evid: 2700)
 *
 * Event description: An event that will document the funnel an account goes through until the decision is made on whether it is eligible for rev share or not and why.
 *
 * @param {revShareEligibilityFunnelEventSrc80Evid2700Params} params - The parameters for this event
 * @property {string} metaSiteId - msid
 * @property {string} accountId - account id
 * @property {string} invoiceLineItemId - line item id
 * @property {string} productTypeId - product type id
 * @property {string} productId - product id
 * @property {string} billingCycleDuration - billing cycle duration
 * @property {string} premiumId - premium id
 * @property {string} couponId - coupon id
 * @property {string} inapplicableReason - inapplicable reason
 * @property {string} revshareRate - revshareRate
 * @return {LogObject<revShareEligibilityFunnelEventSrc80Evid2700Params>} LogObject<revShareEligibilityFunnelEventSrc80Evid2700Params>
 */
export function revShareEligibilityFunnelEventSrc80Evid2700(params) {
    return { evid: 2700, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientBillingWidgetSelectCurrency' event (evid: 271)
 *
 * Event description: Fires when user select a currency
 *
 * @param {clientBillingWidgetSelectCurrencyParams} params - The parameters for this event
 * @property {string} currency - currency selected
 * @return {LogObject<clientBillingWidgetSelectCurrencyParams>} LogObject<clientBillingWidgetSelectCurrencyParams>
 */
export function clientBillingWidgetSelectCurrency(params) {
    return { evid: 271, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientBillingWidgetLoaded' event (evid: 272)
 *
 * Event description: Fires when the client billing widget loads
 *
 * @param {clientBillingWidgetLoadedParams} params - The parameters for this event
 * @property {string} widget_state - Sate of the widget
 * @return {LogObject<clientBillingWidgetLoadedParams>} LogObject<clientBillingWidgetLoadedParams>
 */
export function clientBillingWidgetLoaded(params) {
    return { evid: 272, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingClickMaybeLater' event (evid: 273)
 *
 * Event description: Fires when partner clicks on "Maybe Later" in the partners onboarding
 *
 * @param {partnersOnboardingClickMaybeLaterParams} params - The parameters for this event
 * @property {string} source - onboarding lp
 * @return {LogObject<partnersOnboardingClickMaybeLaterParams>} LogObject<partnersOnboardingClickMaybeLaterParams>
 */
export function partnersOnboardingClickMaybeLater(params) {
    return { evid: 273, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitesWidgetLoaded' event (evid: 274)
 *
 * Event description: Fires when the sites widget loads
 *
 * @param {sitesWidgetLoadedParams} params - The parameters for this event
 * @property {string} numberOfSites - Number of sites in widget
 * @property {string} widget_state - Sate of the widget
 * @return {LogObject<sitesWidgetLoadedParams>} LogObject<sitesWidgetLoadedParams>
 */
export function sitesWidgetLoaded(params) {
    return { evid: 274, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteWidgetDialogSearch' event (evid: 275)
 *
 * Event description: Search site in the site widget
 *
 * @param {siteWidgetDialogSearchParams} params - The parameters for this event
 * @property {string} text - text searched
 * @return {LogObject<siteWidgetDialogSearchParams>} LogObject<siteWidgetDialogSearchParams>
 */
export function siteWidgetDialogSearch(params) {
    return { evid: 275, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactWebsitesWidgetLoaded' event (evid: 276)
 *
 * Event description: Fires when loads client websites widget in the contact view
 *
 * @param {contactWebsitesWidgetLoadedParams} params - The parameters for this event
 * @property {number} numberSites - number of sites in the widget
 * @property {string} widgetState - empty/regular
 * @property {GUID} contactId - contact_id
 * @property {GUID} msid - partner dashboard msid
 * @return {LogObject<contactWebsitesWidgetLoadedParams>} LogObject<contactWebsitesWidgetLoadedParams>
 */
export function contactWebsitesWidgetLoaded(params) {
    return { evid: 276, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactWebsitesSiteSelectorLoaded' event (evid: 277)
 *
 * Event description: Fires when the site selector loads
 *
 * @param {contactWebsitesSiteSelectorLoadedParams} params - The parameters for this event
 * @property {number} numberSites - number of sites in the widget
 * @property {string} origin - origin
 * @property {GUID} contactId - contact_id
 * @property {GUID} msid - partner dashboard msid
 * @return {LogObject<contactWebsitesSiteSelectorLoadedParams>} LogObject<contactWebsitesSiteSelectorLoadedParams>
 */
export function contactWebsitesSiteSelectorLoaded(params) {
    return { evid: 277, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactWebsitesSiteSelectorSearch' event (evid: 278)
 *
 * Event description: Search site in the site widget
 *
 * @param {contactWebsitesSiteSelectorSearchParams} params - The parameters for this event
 * @property {string} text - text searched
 * @property {string} origin - origin
 * @property {GUID} contactId - contact_id
 * @property {GUID} msid - msid
 * @return {LogObject<contactWebsitesSiteSelectorSearchParams>} LogObject<contactWebsitesSiteSelectorSearchParams>
 */
export function contactWebsitesSiteSelectorSearch(params) {
    return { evid: 278, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactWebsitesWebsitesAddedRemoved' event (evid: 279)
 *
 * Event description: Fires when website is added to contact
 *
 * @param {contactWebsitesWebsitesAddedRemovedParams} params - The parameters for this event
 * @property {string} connectedMsid - connected_msid
 * @property {string} origin - widget/menu
 * @property {GUID} contactId - contact_id
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @return {LogObject<contactWebsitesWebsitesAddedRemovedParams>} LogObject<contactWebsitesWebsitesAddedRemovedParams>
 */
export function contactWebsitesWebsitesAddedRemoved(params) {
    return { evid: 279, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profilePageChangeTab' event (evid: 28)
 *
 * Event description: users clicks on a tab in the nav bar of an expert's profile page
 *
 * @param {profilePageChangeTabParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} visitorId - not in use
 * @property {GUID} visitorid - not in use
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origTabName - orig_tab_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} newTabName - new_tab_name
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<profilePageChangeTabParams>} LogObject<profilePageChangeTabParams>
 */
export function profilePageChangeTab(params) {
    return { evid: 28, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectSiteAndClientError' event (evid: 280)
 *
 * Event description: FIres when error in the feature
 *
 * @param {connectSiteAndClientErrorParams} params - The parameters for this event
 * @property {string} contact_id - contact_id
 * @return {LogObject<connectSiteAndClientErrorParams>} LogObject<connectSiteAndClientErrorParams>
 */
export function connectSiteAndClientError(params) {
    return { evid: 280, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchBackToWixDashboardClick' event (evid: 2801)
 *
 * Event description: Clicking to switch back from Wix studio to Wix dashboard
 *
 * @param {switchBackToWixDashboardClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - The name of the specific modal that the click was on
 * @property {string} click_type - Type of click
 * @property {string} tell_us_more - Free text the user added in the switching back modal
 * @property {string} main_reason - main reason the user selected for switching back to Wix dashboard
 * @property {boolean} leave_contacts_details - True if the user agreed to be contacted for additional feedback
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchBackToWixDashboardClickParams>} LogObject<switchBackToWixDashboardClickParams>
 */
export function switchBackToWixDashboardClick(params) {
    return { evid: 2801, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioCustomTemplatesPageGenericClickSrc80Evid2802' event (evid: 2802)
 *
 * Event description: Generic click event in the Templates - Custom templates pages
 *
 * @param {wixStudioCustomTemplatesPageGenericClickSrc80Evid2802Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} entry - entry point to the custom template page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} template_metasite_id - the metasite id of the template - Use this
 * @property {string} site_msid - msid of the site that was created from the template
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} template_id - the ID of the template
 * @property {GUID} origin_msid - The msid of the origin site the template was created from
 * @property {boolean} is_my_sites_page - True if click is on my sites page
 * @return {LogObject<wixStudioCustomTemplatesPageGenericClickSrc80Evid2802Params>} LogObject<wixStudioCustomTemplatesPageGenericClickSrc80Evid2802Params>
 */
export function wixStudioCustomTemplatesPageGenericClickSrc80Evid2802(params) {
    return { evid: 2802, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioCustomTemplatesPageLoadPage' event (evid: 2803)
 *
 * Event description: load page event for the custom templates page
 *
 * @param {wixStudioCustomTemplatesPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - The name of the screen. if null then it's the main templates page
 * @property {string} entry - entry point to the custom template page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioCustomTemplatesPageLoadPageParams>} LogObject<wixStudioCustomTemplatesPageLoadPageParams>
 */
export function wixStudioCustomTemplatesPageLoadPage(params) {
    return { evid: 2803, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customTemplateWasCreated' event (evid: 2804)
 *
 * Event description: Event is fired every time a new custom template is created
 *
 * @param {customTemplateWasCreatedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - entry point to the custom template page
 * @property {string} origin_template_metasite_id - The template_metasite_id of the origin template the template was created from
 * @property {string} created_from_template_or_site - Returns site if the template was created from a site, and template if the template is duplication of another template
 * @property {string} template_metasite_id - The metasite id of the template - Use this
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} template_id - The ID of the template
 * @property {string} origin_msid - The msid of the origin site the template was created from
 * @return {LogObject<customTemplateWasCreatedParams>} LogObject<customTemplateWasCreatedParams>
 */
export function customTemplateWasCreated(params) {
    return { evid: 2804, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioMyAppsPageGenericClick' event (evid: 2805)
 *
 * Event description: Generic click event in the My Apps page on Wix Studio
 *
 * @param {wixStudioMyAppsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} device_type_dev - user's device type
 * @property {string} app_id - the ID of the app
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioMyAppsPageGenericClickParams>} LogObject<wixStudioMyAppsPageGenericClickParams>
 */
export function wixStudioMyAppsPageGenericClick(params) {
    return { evid: 2805, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioSideBarClick' event (evid: 2806)
 *
 * Event description: Clicking on the wix studio side bar
 *
 * @param {wixStudioSideBarClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - What the user clicked on
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioSideBarClickParams>} LogObject<wixStudioSideBarClickParams>
 */
export function wixStudioSideBarClick(params) {
    return { evid: 2806, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchToStudioPagePageView' event (evid: 2809)
 *
 * Event description: Event is fired whenever a user get to the page where he can switch to Wix Studio
 *
 * @param {switchToStudioPagePageViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - The entry point the user came from to this page
 * @property {string} campaign_name - The campaign name of the campaign that led the user to this page (email marketing / dealer campaign)
 * @property {string} placement - The placement of the dealer ad that led to the page
 * @property {string} offer_id - The offer_id of the dealer ad that led to the page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchToStudioPagePageViewParams>} LogObject<switchToStudioPagePageViewParams>
 */
export function switchToStudioPagePageView(params) {
    return { evid: 2809, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchToStudioPageClick' event (evid: 2810)
 *
 * Event description: Event is fired whenever a user clicks on the page where he can switch to Wix Studio
 *
 * @param {switchToStudioPageClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - The click the user clicked on
 * @property {string} entry - The entry point the user came from to the switch page
 * @property {string} campaign_name - The campaign name of the campaign that led the user to the switch page (email marketing / dealer campaign)
 * @property {string} placement - The placement of the dealer ad that led to the switch page
 * @property {string} offer_id - The offer_id of the dealer ad that led to the switch page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchToStudioPageClickParams>} LogObject<switchToStudioPageClickParams>
 */
export function switchToStudioPageClick(params) {
    return { evid: 2810, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageLoadPage' event (evid: 2811)
 *
 * Event description: load page event for the discover page
 *
 * @param {wixStudioDiscoverPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {string} origin - Studio App or null if from web
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioDiscoverPageLoadPageParams>} LogObject<wixStudioDiscoverPageLoadPageParams>
 */
export function wixStudioDiscoverPageLoadPage(params) {
    return { evid: 2811, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageGenericClick' event (evid: 2812)
 *
 * Event description: Generic click event in the discover page
 *
 * @param {wixStudioDiscoverPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} user_funnel_stage - new/returning/existing
 * @property {string} device_type_dev - user's device type
 * @property {string} origin - Studio App or null if from web
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioDiscoverPageGenericClickParams>} LogObject<wixStudioDiscoverPageGenericClickParams>
 */
export function wixStudioDiscoverPageGenericClick(params) {
    return { evid: 2812, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageVideoAutoPlaySrc80Evid2813' event (evid: 2813)
 *
 * Event description: new video start with auto-play after the previous ended
 *
 * @param {wixStudioDiscoverPageVideoAutoPlaySrc80Evid2813Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} user_funnel_stage - new/returning/existing
 * @property {string} device_type_dev - user's device type
 * @property {string} video_id_started - The id of the new video that started playing
 * @property {string} origin - Studio App or null if from web
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} video_id_finished - The id of the video that finished playing - this video was fully viewed by the user
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} video_type - Tutorial / Community
 * @return {LogObject<wixStudioDiscoverPageVideoAutoPlaySrc80Evid2813Params>} LogObject<wixStudioDiscoverPageVideoAutoPlaySrc80Evid2813Params>
 */
export function wixStudioDiscoverPageVideoAutoPlaySrc80Evid2813(params) {
    return { evid: 2813, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchToStudioPageVideoView' event (evid: 2814)
 *
 * Event description: Event is fired whenever a user viewed the video on the switch page to Wix Studio
 *
 * @param {switchToStudioPageVideoViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} full_video_length - the full length of the video in seconds
 * @property {string} entry - The entry point the user came from to the switch page
 * @property {string} campaign_name - The campaign name of the campaign that led the user to the switch page (email marketing / dealer campaign)
 * @property {string} video_name - The name of the video
 * @property {string} placement - The placement of the dealer ad that led to the switch page
 * @property {number} percentage_viewed - 50 when the user reached 50% of the video / 100 when the user reached 100% of the video
 * @property {string} offer_id - The offer_id of the dealer ad that led to the switch page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchToStudioPageVideoViewParams>} LogObject<switchToStudioPageVideoViewParams>
 */
export function switchToStudioPageVideoView(params) {
    return { evid: 2814, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitWidgetBusinessManagerHomeView' event (evid: 2815)
 *
 * Event description: Event is fired whenever there is a page view of the client kit widget in the business manager home page
 *
 * @param {clientKitWidgetBusinessManagerHomeViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} watch_user_type - The type of user watching the widget - a partner with edit permissions or a client with view permissions
 * @property {string} state - The state of the widget - 'Empty' in case there is no kit added, 'Full' in case a Kit was added
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} msid - The msid of the site this Kit belong to
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitWidgetBusinessManagerHomeViewParams>} LogObject<clientKitWidgetBusinessManagerHomeViewParams>
 */
export function clientKitWidgetBusinessManagerHomeView(params) {
    return { evid: 2815, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitWidgetBusinessManagerHomeClick' event (evid: 2816)
 *
 * Event description: Event is fired whenever there is a click on the client kit widget in the business manager home page
 *
 * @param {clientKitWidgetBusinessManagerHomeClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} watch_user_type - The type of user watching the widget - a partner with edit permissions or a client with view permissions
 * @property {string} resource_name - The id of the resource
 * @property {string} state - The state of the widget - 'Empty' in case there is no kit added, 'Full' in case a Kit was added
 * @property {string} click_type - What the user clicked on
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} msid - The msid of the site this Kit belong to
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitWidgetBusinessManagerHomeClickParams>} LogObject<clientKitWidgetBusinessManagerHomeClickParams>
 */
export function clientKitWidgetBusinessManagerHomeClick(params) {
    return { evid: 2816, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitSetupPageClick' event (evid: 2817)
 *
 * Event description: Event is fired whenever there is a click on the client kit setup page
 *
 * @param {clientKitSetupPageClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - added data to the click
 * @property {string} resource_name - The id of the resource
 * @property {string} click_type - What the user clicked on
 * @property {string} msid_selected - The msid of the site this Kit belong to
 * @property {string} section - The section on the setup page where we can find the click
 * @property {string} entry_point - The entry point where the user came from to the client kit setup page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitSetupPageClickParams>} LogObject<clientKitSetupPageClickParams>
 */
export function clientKitSetupPageClick(params) {
    return { evid: 2817, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfClientKitSetupPageClick' event (evid: 2818)
 *
 * Event description: Event is fired whenever there is a page view of the client kit setup page
 *
 * @param {copyOfClientKitSetupPageClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} msid_selected - The msid of the site this Kit belong to
 * @property {string} entry_point - The entry point where the user came from to the client kit setup page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<copyOfClientKitSetupPageClickParams>} LogObject<copyOfClientKitSetupPageClickParams>
 */
export function copyOfClientKitSetupPageClick(params) {
    return { evid: 2818, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitAccountLevelView' event (evid: 2819)
 *
 * Event description: Event is fired whenever there is a page view of the client kit account level page on wix studio
 *
 * @param {clientKitAccountLevelViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} state - The state of the page - 'empty' if user has no Kits, 'Kit list' in case the user have client kits already
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitAccountLevelViewParams>} LogObject<clientKitAccountLevelViewParams>
 */
export function clientKitAccountLevelView(params) {
    return { evid: 2819, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramZeroStateFormCompletion' event (evid: 282)
 *
 * Event description: Partner Program - Fires when user completes the step in the onboarding flow for new partners.
 *
 * @param {partnerProgramZeroStateFormCompletionParams} params - The parameters for this event
 * @property {string} fieldName - field
 * @return {LogObject<partnerProgramZeroStateFormCompletionParams>} LogObject<partnerProgramZeroStateFormCompletionParams>
 */
export function partnerProgramZeroStateFormCompletion(params) {
    return { evid: 282, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitAccountLevelClick' event (evid: 2820)
 *
 * Event description: Event is fired whenever there is a click on the client kit account level page
 *
 * @param {clientKitAccountLevelClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} kit_id - The id of the client kit
 * @property {string} state - The state of the page - 'empty' if user has no Kits, 'Kit list' in case the user have client kits already
 * @property {string} click_type - What the user clicked on
 * @property {string} msid_selected - The msid of the site this Kit belong to
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitAccountLevelClickParams>} LogObject<clientKitAccountLevelClickParams>
 */
export function clientKitAccountLevelClick(params) {
    return { evid: 2820, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitVideoView' event (evid: 2821)
 *
 * Event description: Event is fired whenever there is a video view of a video resource in a client kit
 *
 * @param {clientKitVideoViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} video_length_sec - The length of the the video in seconds
 * @property {string} watch_user_type - The type of user watching the widget - a partner with edit permissions or a client with view permissions
 * @property {string} resource_name - The id of the resource
 * @property {number} video_seconds_played - Seconds the user viewed
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} msid - The msid of the site this Kit belong to
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitVideoViewParams>} LogObject<clientKitVideoViewParams>
 */
export function clientKitVideoView(params) {
    return { evid: 2821, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageViewed50OfVideo' event (evid: 2822)
 *
 * Event description: Event is sent whenever a user viewed 50% of a video in the discover page
 *
 * @param {wixStudioDiscoverPageViewed50OfVideoParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} video_id - The video id
 * @property {string} user_funnel_stage - new/returning/existing
 * @property {string} device_type_dev - user's device type
 * @property {string} video_name - The name of the video
 * @property {string} offer_id - The offer_id of the video (from dealer)
 * @property {string} origin - Studio App or null if from web
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} video_type - Tutorial / Community
 * @return {LogObject<wixStudioDiscoverPageViewed50OfVideoParams>} LogObject<wixStudioDiscoverPageViewed50OfVideoParams>
 */
export function wixStudioDiscoverPageViewed50OfVideo(params) {
    return { evid: 2822, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchToStudioAndBackTeamMemberPageView' event (evid: 2823)
 *
 * Event description: Event is fired whenever a team member get to the page where he see the account changed from Studio platform to wix.com or back.
 *
 * @param {switchToStudioAndBackTeamMemberPageViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform_user_landed - The platfrom the user landed on (Studio / Wix.com
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchToStudioAndBackTeamMemberPageViewParams>} LogObject<switchToStudioAndBackTeamMemberPageViewParams>
 */
export function switchToStudioAndBackTeamMemberPageView(params) {
    return { evid: 2823, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchToStudioAndBackTeamMemberClick' event (evid: 2824)
 *
 * Event description: Event is fired whenever a team member clicks on the page where he see the account changed from Studio platform to wix.com or back.
 *
 * @param {switchToStudioAndBackTeamMemberClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - What the user clicked on
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform_user_landed - The platfrom the user landed on (Studio / Wix.com
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchToStudioAndBackTeamMemberClickParams>} LogObject<switchToStudioAndBackTeamMemberClickParams>
 */
export function switchToStudioAndBackTeamMemberClick(params) {
    return { evid: 2824, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchBackToWixDashboardModalView' event (evid: 2825)
 *
 * Event description: Page view of the switch back from Wix studio modal
 *
 * @param {switchBackToWixDashboardModalViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - the name of the specific modal that loaded
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<switchBackToWixDashboardModalViewParams>} LogObject<switchBackToWixDashboardModalViewParams>
 */
export function switchBackToWixDashboardModalView(params) {
    return { evid: 2825, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientKitWasSaved' event (evid: 2826)
 *
 * Event description: Event is fired whenever the user is saving the client kit or delete it. If the resources_count=0 it means the client kit was deleted
 *
 * @param {clientKitWasSavedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} resources_count - The number of resources in the client kit
 * @property {number} unknown_files_count - Numbers of files with unknown type
 * @property {boolean} is_deleted_from_account_level - True is the client kit was deleted from account level workspace
 * @property {string} msid_selected - The msid of the site this Kit belong to
 * @property {number} video_files_count - Numbers of files with video type
 * @property {number} documnet_files_count - Numbers of files with document type
 * @property {string} entry_point - The entry point where the user came from to the client kit setup page
 * @property {number} image_files_count - Numbers of files with image type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientKitWasSavedParams>} LogObject<clientKitWasSavedParams>
 */
export function clientKitWasSaved(params) {
    return { evid: 2826, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnStudioAppEntryPoint' event (evid: 2827)
 *
 * Event description: Event is fired every time the user is clicking on one of the entry points to the studio app from the studio workspace
 *
 * @param {clickOnStudioAppEntryPointParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - click type
 * @property {string} origin - the name of the page where the entry point is
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clickOnStudioAppEntryPointParams>} LogObject<clickOnStudioAppEntryPointParams>
 */
export function clickOnStudioAppEntryPoint(params) {
    return { evid: 2827, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementStudioEntryPointView' event (evid: 2828)
 *
 * Event description: Event is fired when user viewed the team management entry point to Wix Studio
 *
 * @param {teamManagementStudioEntryPointViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - team management page where the entry point is shown
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<teamManagementStudioEntryPointViewParams>} LogObject<teamManagementStudioEntryPointViewParams>
 */
export function teamManagementStudioEntryPointView(params) {
    return { evid: 2828, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementStudioEntryPointClick' event (evid: 2829)
 *
 * Event description: Event is fired when user clicked 'Check it out' on the team management entry point to Wix Studio
 *
 * @param {teamManagementStudioEntryPointClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - team management page where the entry point is shown
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<teamManagementStudioEntryPointClickParams>} LogObject<teamManagementStudioEntryPointClickParams>
 */
export function teamManagementStudioEntryPointClick(params) {
    return { evid: 2829, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramZeroStateFormCompletionBusinessTypeQuestion' event (evid: 283)
 *
 * Event description: Partner Program - Fires when user clicks in the business type question
 *
 * @param {partnerProgramZeroStateFormCompletionBusinessTypeQuestionParams} params - The parameters for this event
 * @property {string} answer - answer
 * @return {LogObject<partnerProgramZeroStateFormCompletionBusinessTypeQuestionParams>} LogObject<partnerProgramZeroStateFormCompletionBusinessTypeQuestionParams>
 */
export function partnerProgramZeroStateFormCompletionBusinessTypeQuestion(params) {
    return { evid: 283, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'afterDeprecationWelcomeToStudioModalModalLoaded' event (evid: 2830)
 *
 * Event description: The welcome to studio modal, after the partner dashboard deprecation and switching to Wix Studio, loaded
 *
 * @param {afterDeprecationWelcomeToStudioModalModalLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<afterDeprecationWelcomeToStudioModalModalLoadedParams>} LogObject<afterDeprecationWelcomeToStudioModalModalLoadedParams>
 */
export function afterDeprecationWelcomeToStudioModalModalLoaded(params) {
    return { evid: 2830, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'afterDeprecationWelcomeToStudioModalClick' event (evid: 2831)
 *
 * Event description: Click on the welcome to studio modal, after the partner dashboard deprecation and switching to Wix Studio
 *
 * @param {afterDeprecationWelcomeToStudioModalClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - What the user clicked on
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<afterDeprecationWelcomeToStudioModalClickParams>} LogObject<afterDeprecationWelcomeToStudioModalClickParams>
 */
export function afterDeprecationWelcomeToStudioModalClick(params) {
    return { evid: 2831, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitTemplatesFormMarketingPage' event (evid: 2832)
 *
 * Event description: User successfully submitted the templates form to join the templates marketplace
 *
 * @param {submitTemplatesFormMarketingPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} form_name - name of the form
 * @property {Url} url - url of the page
 * @property {string} page_name - name of the page with the form
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitTemplatesFormMarketingPageParams>} LogObject<submitTemplatesFormMarketingPageParams>
 */
export function submitTemplatesFormMarketingPage(params) {
    return { evid: 2832, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioStudioTemplatesPageGenericClickCopySrc80Evid2833' event (evid: 2833)
 *
 * Event description: Generic click event in the Templates page in the Studio Workspace
 *
 * @param {wixStudioStudioTemplatesPageGenericClickCopySrc80Evid2833Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} entry - entry point to the studio templates page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} template_metasite_id - the metasite id of the template - Use this
 * @property {string} site_msid - msid of the site that was created from the template
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} template_id - the ID of the template
 * @property {GUID} origin_msid - The msid of the origin site the template was created from
 * @property {string} screen_name - The name of the screen (studio / community). if null then it's the main templates page
 * @property {boolean} is_my_sites_page - True if click is on my sites page
 * @return {LogObject<wixStudioStudioTemplatesPageGenericClickCopySrc80Evid2833Params>} LogObject<wixStudioStudioTemplatesPageGenericClickCopySrc80Evid2833Params>
 */
export function wixStudioStudioTemplatesPageGenericClickCopySrc80Evid2833(params) {
    return { evid: 2833, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioCommunityTemplatesPageGenericClickSrc80Evid2834' event (evid: 2834)
 *
 * Event description: Generic click event in the Templates - Community templates page
 *
 * @param {wixStudioCommunityTemplatesPageGenericClickSrc80Evid2834Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} entry - entry point to the community templates page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} template_metasite_id - the metasite id of the template - Use this
 * @property {string} site_msid - msid of the site that was created from the template
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} template_id - the ID of the template
 * @property {GUID} origin_msid - The msid of the origin site the template was created from
 * @property {boolean} is_my_sites_page - True if click is on my sites page
 * @return {LogObject<wixStudioCommunityTemplatesPageGenericClickSrc80Evid2834Params>} LogObject<wixStudioCommunityTemplatesPageGenericClickSrc80Evid2834Params>
 */
export function wixStudioCommunityTemplatesPageGenericClickSrc80Evid2834(params) {
    return { evid: 2834, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioStudioTemplatesPageLoadPageSrc80Evid2835' event (evid: 2835)
 *
 * Event description: load page event for the templates page in the Studio Workspace
 *
 * @param {wixStudioStudioTemplatesPageLoadPageSrc80Evid2835Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - The name of the screen (studio / community). if null then it's the main templates page
 * @property {string} entry - entry point to the studio templates page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioStudioTemplatesPageLoadPageSrc80Evid2835Params>} LogObject<wixStudioStudioTemplatesPageLoadPageSrc80Evid2835Params>
 */
export function wixStudioStudioTemplatesPageLoadPageSrc80Evid2835(params) {
    return { evid: 2835, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioCommunityTemplatesPageLoadPageSrc80Evid2836' event (evid: 2836)
 *
 * Event description: load page event for the Templates - Community templates page
 *
 * @param {wixStudioCommunityTemplatesPageLoadPageSrc80Evid2836Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - The name of the screen. if null then it's the main templates page
 * @property {string} entry - entry point to the community templates page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioCommunityTemplatesPageLoadPageSrc80Evid2836Params>} LogObject<wixStudioCommunityTemplatesPageLoadPageSrc80Evid2836Params>
 */
export function wixStudioCommunityTemplatesPageLoadPageSrc80Evid2836(params) {
    return { evid: 2836, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramZeroStateFormCompletionTerms' event (evid: 284)
 *
 * Event description: Partner Program - Fires when user clicks in the terms checkbox
 *
 * @param {partnerProgramZeroStateFormCompletionTermsParams} params - The parameters for this event
 * @property {boolean} checkbox - true/false
 * @return {LogObject<partnerProgramZeroStateFormCompletionTermsParams>} LogObject<partnerProgramZeroStateFormCompletionTermsParams>
 */
export function partnerProgramZeroStateFormCompletionTerms(params) {
    return { evid: 284, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seeCompletionRateInCategory' event (evid: 285)
 *
 * Event description: See Completion Rate In Category.
 *
 * @param {seeCompletionRateInCategoryParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} category - marketplace category
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<seeCompletionRateInCategoryParams>} LogObject<seeCompletionRateInCategoryParams>
 */
export function seeCompletionRateInCategory(params) {
    return { evid: 285, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowChatLoaded' event (evid: 286)
 *
 * Event description: Clicks in the post brief flow
 *
 * @param {marketplacePostBriefFlowChatLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} partnerId - partner ID
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowChatLoadedParams>} LogObject<marketplacePostBriefFlowChatLoadedParams>
 */
export function marketplacePostBriefFlowChatLoaded(params) {
    return { evid: 286, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramZeroStateFormCompletionCarousel' event (evid: 287)
 *
 * Event description: Partner Program - Fires when user sees an image in the carousel
 *
 * @param {partnerProgramZeroStateFormCompletionCarouselParams} params - The parameters for this event
 * @property {number} position - position
 * @return {LogObject<partnerProgramZeroStateFormCompletionCarouselParams>} LogObject<partnerProgramZeroStateFormCompletionCarouselParams>
 */
export function partnerProgramZeroStateFormCompletionCarousel(params) {
    return { evid: 287, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramClientBillingOverviewGenericClick' event (evid: 288)
 *
 * Event description: Fires on any click
 *
 * @param {partnerProgramClientBillingOverviewGenericClickParams} params - The parameters for this event
 * @property {string} click_type - click type
 * @property {string} option - option
 * @property {number} timeRange - time_range
 * @property {string} origin - origin
 * @return {LogObject<partnerProgramClientBillingOverviewGenericClickParams>} LogObject<partnerProgramClientBillingOverviewGenericClickParams>
 */
export function partnerProgramClientBillingOverviewGenericClick(params) {
    return { evid: 288, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramClientBillingOverviewGenericHover' event (evid: 289)
 *
 * Event description: Fires on any hover
 *
 * @param {partnerProgramClientBillingOverviewGenericHoverParams} params - The parameters for this event
 * @property {string} option - option
 * @property {string} hover_type - Hover
 * @property {string} origin - origin
 * @return {LogObject<partnerProgramClientBillingOverviewGenericHoverParams>} LogObject<partnerProgramClientBillingOverviewGenericHoverParams>
 */
export function partnerProgramClientBillingOverviewGenericHover(params) {
    return { evid: 289, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnExpertProject' event (evid: 29)
 *
 * Event description: user clicks on an expert project from the profile or the explore page
 *
 * @param {clickOnExpertProjectParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - not in use
 * @property {string} url - the url of the site clicked
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - explore page / expert profile
 * @property {number} siteLocationId - the location of the site in the profile
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} siteGuid - the msid of the site clicked
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<clickOnExpertProjectParams>} LogObject<clickOnExpertProjectParams>
 */
export function clickOnExpertProject(params) {
    return { evid: 29, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramClientBillingOverviewWidgetLoaded' event (evid: 290)
 *
 * Event description: Fires when any widget is loaded
 *
 * @param {partnerProgramClientBillingOverviewWidgetLoadedParams} params - The parameters for this event
 * @property {string} widgetType - widget type
 * @property {string} widgetState - widget state
 * @property {string} origin - origin
 * @return {LogObject<partnerProgramClientBillingOverviewWidgetLoadedParams>} LogObject<partnerProgramClientBillingOverviewWidgetLoadedParams>
 */
export function partnerProgramClientBillingOverviewWidgetLoaded(params) {
    return { evid: 290, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportWidgetLoaded' event (evid: 291)
 *
 * Event description: get feedback widget loaded ( in a specific state)
 *
 * @param {supportWidgetLoadedParams} params - The parameters for this event
 * @property {string} widgetMode - widget Mode
 * @return {LogObject<supportWidgetLoadedParams>} LogObject<supportWidgetLoadedParams>
 */
export function supportWidgetLoaded(params) {
    return { evid: 291, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDashboardContributorsAccessEntryClick' event (evid: 292)
 *
 * Event description: Fires when user clicks on entry point to the contributors access tool
 *
 * @param {partnersDashboardContributorsAccessEntryClickParams} params - The parameters for this event
 * @property {string} clickType - Type of click
 * @property {string} origin - origin
 * @property {GUID} contactId - contact id
 * @return {LogObject<partnersDashboardContributorsAccessEntryClickParams>} LogObject<partnersDashboardContributorsAccessEntryClickParams>
 */
export function partnersDashboardContributorsAccessEntryClick(params) {
    return { evid: 292, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDashboardContributorsAccessDialogLoaded' event (evid: 293)
 *
 * Event description: Fires when user loads the dialog
 *
 * @param {partnersDashboardContributorsAccessDialogLoadedParams} params - The parameters for this event
 * @property {boolean} clientEmail - true/false
 * @property {string} origin - origin
 * @property {GUID} contactId - contact id
 * @return {LogObject<partnersDashboardContributorsAccessDialogLoadedParams>} LogObject<partnersDashboardContributorsAccessDialogLoadedParams>
 */
export function partnersDashboardContributorsAccessDialogLoaded(params) {
    return { evid: 293, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramTeamsWidgetLoadWidget' event (evid: 294)
 *
 * Event description: User loads the team's widget
 *
 * @param {partnerProgramTeamsWidgetLoadWidgetParams} params - The parameters for this event
 * @property {number} teamMembers - team size
 * @return {LogObject<partnerProgramTeamsWidgetLoadWidgetParams>} LogObject<partnerProgramTeamsWidgetLoadWidgetParams>
 */
export function partnerProgramTeamsWidgetLoadWidget(params) {
    return { evid: 294, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramTeamsWidgetClick' event (evid: 295)
 *
 * Event description: User clicks in widget
 *
 * @param {partnerProgramTeamsWidgetClickParams} params - The parameters for this event
 * @property {string} clickType - click type
 * @property {number} teamMembers - team size
 * @return {LogObject<partnerProgramTeamsWidgetClickParams>} LogObject<partnerProgramTeamsWidgetClickParams>
 */
export function partnerProgramTeamsWidgetClick(params) {
    return { evid: 295, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramTeamsWidgetHover' event (evid: 296)
 *
 * Event description: User hovers in widget
 *
 * @param {partnerProgramTeamsWidgetHoverParams} params - The parameters for this event
 * @property {number} teamMembers - team size
 * @return {LogObject<partnerProgramTeamsWidgetHoverParams>} LogObject<partnerProgramTeamsWidgetHoverParams>
 */
export function partnerProgramTeamsWidgetHover(params) {
    return { evid: 296, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersDashboardContributorsAccessAction' event (evid: 297)
 *
 * Event description: Fires when user clicks in the dialog
 *
 * @param {partnersDashboardContributorsAccessActionParams} params - The parameters for this event
 * @property {string} role - role
 * @property {boolean} clientEmail - true/false
 * @property {string} origin - origin
 * @property {GUID} contactId - contact id
 * @property {string} action - action
 * @return {LogObject<partnersDashboardContributorsAccessActionParams>} LogObject<partnersDashboardContributorsAccessActionParams>
 */
export function partnersDashboardContributorsAccessAction(params) {
    return { evid: 297, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramMarketplaceLightboxLoaded' event (evid: 298)
 *
 * Event description: Fires when lightbox is loaded
 *
 * @param {partnerProgramMarketplaceLightboxLoadedParams} params - The parameters for this event
 * @property {string} lightboxType - lightboxType
 * @return {LogObject<partnerProgramMarketplaceLightboxLoadedParams>} LogObject<partnerProgramMarketplaceLightboxLoadedParams>
 */
export function partnerProgramMarketplaceLightboxLoaded(params) {
    return { evid: 298, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramMarketplaceLightboxLoadedSrc80Evid299' event (evid: 299)
 *
 * Event description: Fires when lightbox is loaded
 *
 * @param {partnerProgramMarketplaceLightboxLoadedSrc80Evid299Params} params - The parameters for this event
 * @property {string} clickType - clickType
 * @property {string} lightboxType - lightboxType
 * @return {LogObject<partnerProgramMarketplaceLightboxLoadedSrc80Evid299Params>} LogObject<partnerProgramMarketplaceLightboxLoadedSrc80Evid299Params>
 */
export function partnerProgramMarketplaceLightboxLoadedSrc80Evid299(params) {
    return { evid: 299, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profilePageClickOnExpertLinkedAccount' event (evid: 30)
 *
 * Event description: User clicks on expert linked account (portfolio erbsite/fb/Twitter/linkedin...) in the profile side bar
 *
 * @param {profilePageClickOnExpertLinkedAccountParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} communicationOption - facebook/linkedin/website
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} visitorid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - experts guid
 * @return {LogObject<profilePageClickOnExpertLinkedAccountParams>} LogObject<profilePageClickOnExpertLinkedAccountParams>
 */
export function profilePageClickOnExpertLinkedAccount(params) {
    return { evid: 30, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardNewsResourcesFeedLoadMore' event (evid: 300)
 *
 * Event description: Expert dashboard -> News & Resources -> a user press on "load more" in the feed.
 *
 * @param {expertDashboardNewsResourcesFeedLoadMoreParams} params - The parameters for this event
 * @property {number} offset - offset
 * @return {LogObject<expertDashboardNewsResourcesFeedLoadMoreParams>} LogObject<expertDashboardNewsResourcesFeedLoadMoreParams>
 */
export function expertDashboardNewsResourcesFeedLoadMore(params) {
    return { evid: 300, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardNewsResourcesViewFeed' event (evid: 301)
 *
 * Event description: Expert dashboard -> News & Resources -> user viewed feed (news & resources  or blog)
 * view = all the text was shown to the user.
 *
 * @param {expertDashboardNewsResourcesViewFeedParams} params - The parameters for this event
 * @property {GUID} feedId - The id of the feed, unique per feedType
 * @property {DateTime} postTime - when the post was posted
 * @property {string} feedType - who posted the feed: experts blog, experts tip etc
 * @property {string} feedTitle - title of the feed
 * @property {string} listType - expert forum or news & resources post
 * @property {boolean} aboveTheFold - was the feed shown to the user above or below the fold?
 * @return {LogObject<expertDashboardNewsResourcesViewFeedParams>} LogObject<expertDashboardNewsResourcesViewFeedParams>
 */
export function expertDashboardNewsResourcesViewFeed(params) {
    return { evid: 301, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardNewsResourcesClickFeed' event (evid: 302)
 *
 * Event description: Expert dashboard -> News & Resources -> user clicked expend/ CTA/ light box in feed (news & resources  or blog)
 *
 * @param {expertDashboardNewsResourcesClickFeedParams} params - The parameters for this event
 * @property {string} feedId - The id of the feed, unique per feedType
 * @property {DateTime} postTime - when the post was posted
 * @property {string} feedType - who posted the feed: experts blog, experts tip etc
 * @return {LogObject<expertDashboardNewsResourcesClickFeedParams>} LogObject<expertDashboardNewsResourcesClickFeedParams>
 */
export function expertDashboardNewsResourcesClickFeed(params) {
    return { evid: 302, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardNewsResourcesUpdateForumFeed' event (evid: 303)
 *
 * Event description: Expert dashboard -> News & Resources -> user updates forum feed
 *
 * @param {expertDashboardNewsResourcesUpdateForumFeedParams} params - The parameters for this event
 * @property {string} app_site_id - the forum app_site_id
 * @return {LogObject<expertDashboardNewsResourcesUpdateForumFeedParams>} LogObject<expertDashboardNewsResourcesUpdateForumFeedParams>
 */
export function expertDashboardNewsResourcesUpdateForumFeed(params) {
    return { evid: 303, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertDashboardNewsResourcesScrollDown' event (evid: 304)
 *
 * Event description: user clicks on the forum component button "See All Posts"
 *
 * @param {expertDashboardNewsResourcesScrollDownParams} params - The parameters for this event
 * @property {string} app_site_id - The forum app_site_id
 * @return {LogObject<expertDashboardNewsResourcesScrollDownParams>} LogObject<expertDashboardNewsResourcesScrollDownParams>
 */
export function expertDashboardNewsResourcesScrollDown(params) {
    return { evid: 304, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramMarketplaceWidgetWidgetLoaded' event (evid: 305)
 *
 * Event description: Fires when marketplace widget is loaded
 *
 * @param {partnerProgramMarketplaceWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {string} state - state
 * @return {LogObject<partnerProgramMarketplaceWidgetWidgetLoadedParams>} LogObject<partnerProgramMarketplaceWidgetWidgetLoadedParams>
 */
export function partnerProgramMarketplaceWidgetWidgetLoaded(params) {
    return { evid: 305, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramMarketplaceWidgetWidgetClick' event (evid: 306)
 *
 * Event description: Fires when user clicks in widget
 *
 * @param {partnerProgramMarketplaceWidgetWidgetClickParams} params - The parameters for this event
 * @property {string} state - state
 * @property {string} clickType - click_type
 * @property {string} platform - The platform the user is using
 * @return {LogObject<partnerProgramMarketplaceWidgetWidgetClickParams>} LogObject<partnerProgramMarketplaceWidgetWidgetClickParams>
 */
export function partnerProgramMarketplaceWidgetWidgetClick(params) {
    return { evid: 306, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userProProfileClickedOnContactMe' event (evid: 31)
 *
 * Event description: User clicks on the experts CTA (and opens a direct brief) from the expert profile page or from the explore
 *
 * @param {userProProfileClickedOnContactMeParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {string} expertTotalScore - ETS
 * @property {number} reviewsScore - total reviews score
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - not in use
 * @property {string} origin - explore page / expert profile
 * @property {number} budget - not in use
 * @property {boolean} isUserLoggedIn - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} originLocation - project details / services & rates ...
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<userProProfileClickedOnContactMeParams>} LogObject<userProProfileClickedOnContactMeParams>
 */
export function userProProfileClickedOnContactMe(params) {
    return { evid: 31, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceBriefClickPhoneFeature' event (evid: 310)
 *
 * Event description: Fires on clicks in the phone feature
 *
 * @param {marketplaceBriefClickPhoneFeatureParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} phoneCountryCode - country code
 * @property {string} clickType - click_type
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} serviceId - {1;2; e.g. small fix; new website}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceBriefClickPhoneFeatureParams>} LogObject<marketplaceBriefClickPhoneFeatureParams>
 */
export function marketplaceBriefClickPhoneFeature(params) {
    return { evid: 310, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramPartnerAccountManagerWidgetWidgetWidgetLoaded' event (evid: 311)
 *
 * Event description: Fires when account manager contact widget is loaded
 *
 * @param {partnerProgramPartnerAccountManagerWidgetWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {string} accountManagerName - name of am
 * @property {string} state - state
 * @return {LogObject<partnerProgramPartnerAccountManagerWidgetWidgetWidgetLoadedParams>} LogObject<partnerProgramPartnerAccountManagerWidgetWidgetWidgetLoadedParams>
 */
export function partnerProgramPartnerAccountManagerWidgetWidgetWidgetLoaded(params) {
    return { evid: 311, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOnboardingScreenView' event (evid: 312)
 *
 * Event description: Fires when a screen of the partner marketplace opens
 *
 * @param {marketplaceOnboardingScreenViewParams} params - The parameters for this event
 * @property {string} screenName - Info /Preferences / Portfolio / Services
 * @property {string} onboardingVersion - onboarding_version
 * @property {string} platform - The platform the user is using - wix.com/ wix studio
 * @return {LogObject<marketplaceOnboardingScreenViewParams>} LogObject<marketplaceOnboardingScreenViewParams>
 */
export function marketplaceOnboardingScreenView(params) {
    return { evid: 312, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOnboardingGenericClick' event (evid: 313)
 *
 * Event description: Fires when a partner clicks on button in the onboarding process (next/back/remove/add_site/cancel)
 *
 * @param {marketplaceOnboardingGenericClickParams} params - The parameters for this event
 * @property {string} screenName - Info /Preferences / Portfolio / Services
 * @property {string} clickType - next/back/remove/add_site/cancel
 * @property {string} onboardingVersion - V1/V2 ect.
 * @property {string} platform - The platforn the user is using - Wix.com / Wix studio
 * @return {LogObject<marketplaceOnboardingGenericClickParams>} LogObject<marketplaceOnboardingGenericClickParams>
 */
export function marketplaceOnboardingGenericClick(params) {
    return { evid: 313, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOnboardingFinish' event (evid: 314)
 *
 * Event description: Fires when partner finishes application and clicks "Apply" at the end
 *
 * @param {marketplaceOnboardingFinishParams} params - The parameters for this event
 * @property {string} applicationData - json data of filled fields
 * @property {string} onboardingVersion - V1/V2 ect.
 * @property {string} platform - The platform the user is using - wix.com / wix studio
 * @return {LogObject<marketplaceOnboardingFinishParams>} LogObject<marketplaceOnboardingFinishParams>
 */
export function marketplaceOnboardingFinish(params) {
    return { evid: 314, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramProposalsGenericClick' event (evid: 315)
 *
 * Event description: Fires on any click
 *
 * @param {partnerProgramProposalsGenericClickParams} params - The parameters for this event
 * @property {GUID} proposal_id - proposal ID
 * @property {string} screenName - {'create New' / 'dashboard'/ Choose a Template'}
 * @property {string} click_type - click type
 * @property {string} data - data
 * @property {string} option - option
 * @property {string} proposalsVersion - version of proposals : v1, 2 ect
 * @return {LogObject<partnerProgramProposalsGenericClickParams>} LogObject<partnerProgramProposalsGenericClickParams>
 */
export function partnerProgramProposalsGenericClick(params) {
    return { evid: 315, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramProposalsScreenView' event (evid: 317)
 *
 * Event description: Fires when a screen of the partner proposals opens
 *
 * @param {partnerProgramProposalsScreenViewParams} params - The parameters for this event
 * @property {GUID} proposal_id - Proposal ID
 * @property {string} screenName - overview/ templates /create new/ editor
 * @property {string} proposalsVersion - version of product: v1, v2 ect
 * @return {LogObject<partnerProgramProposalsScreenViewParams>} LogObject<partnerProgramProposalsScreenViewParams>
 */
export function partnerProgramProposalsScreenView(params) {
    return { evid: 317, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefPageViewLastStep' event (evid: 318)
 *
 * Event description: Fires when a user enters the last step of the brief (contact info)
 *
 * @param {briefPageViewLastStepParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} briefType - {friendlier V1, Unified, ect}
 * @property {string} origin - {SEO, Logo ect.}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} previousStep - name of the previous step
 * @return {LogObject<briefPageViewLastStepParams>} LogObject<briefPageViewLastStepParams>
 */
export function briefPageViewLastStep(params) {
    return { evid: 318, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDahsboardGenericClick' event (evid: 319)
 *
 * Event description: Fires on any click in the partners dashboard
 *
 * @param {partnerDahsboardGenericClickParams} params - The parameters for this event
 * @property {string} click_type - click type
 * @property {string} option - option
 * @property {string} origin - origin
 * @return {LogObject<partnerDahsboardGenericClickParams>} LogObject<partnerDahsboardGenericClickParams>
 */
export function partnerDahsboardGenericClick(params) {
    return { evid: 319, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'becomeAProPageLoaded' event (evid: 32)
 *
 * Event description: Pro Intro page was loaded
 *
 * @param {becomeAProPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - depreciated. uuid is implicit
 * @return {LogObject<becomeAProPageLoadedParams>} LogObject<becomeAProPageLoadedParams>
 */
export function becomeAProPageLoaded(params) {
    return { evid: 32, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDashboardPremiumCountWidgetLoaded' event (evid: 320)
 *
 * Event description: Fires when Premium Count widget is loaded on partners dashboard
 *
 * @param {partnerDashboardPremiumCountWidgetLoadedParams} params - The parameters for this event
 * @property {string} origin - origin
 * @property {string} widgetState - premier partner/ 1-19 premiums / 0 premiums
 * @return {LogObject<partnerDashboardPremiumCountWidgetLoadedParams>} LogObject<partnerDashboardPremiumCountWidgetLoadedParams>
 */
export function partnerDashboardPremiumCountWidgetLoaded(params) {
    return { evid: 320, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoViewOnAcademyHub' event (evid: 3201)
 *
 * Event description: View of video on Academy Hub Page
 *
 * @param {videoViewOnAcademyHubParams} params - The parameters for this event
 * @property {number} percentWatched - Percent of watched video
 * @property {string} courseId - Id of the course
 * @property {string} videoId - Id of the video
 * @property {Url} appUrl - Url of the page
 * @property {string} type - Video type
 * @property {string} videoName - Name of the video
 * @property {string} courseName - Name of the course
 * @return {LogObject<videoViewOnAcademyHubParams>} LogObject<videoViewOnAcademyHubParams>
 */
export function videoViewOnAcademyHub(params) {
    return { evid: 3201, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumWebsitesScrollWebsites' event (evid: 321)
 *
 * Event description: Fires when partner scrolls down in his list of premiums
 *
 * @param {premiumWebsitesScrollWebsitesParams} params - The parameters for this event
 * @return {LogObject<premiumWebsitesScrollWebsitesParams>} LogObject<premiumWebsitesScrollWebsitesParams>
 */
export function premiumWebsitesScrollWebsites(params) {
    return { evid: 321, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceBriefGeneralAction' event (evid: 322)
 *
 * Event description: fires every time a user makes an action (click/keyboard fill) in MP brief
 *
 * @param {marketplaceBriefGeneralActionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} step_name - name of step
 * @property {number} step_id - step id
 * @property {string} entry - entry point to brief
 * @property {string} data - data extracted from action
 * @property {string} briefType - Friendlier V1 / Friendlier V2 / Unified
 * @property {string} origin - {existing brief}
 * @property {string} sessionId - {}
 * @property {boolean} added_budget - True if the user added budget, false if the user chose that he is not sure what's his budget id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action_type - action_type
 * @return {LogObject<marketplaceBriefGeneralActionParams>} LogObject<marketplaceBriefGeneralActionParams>
 */
export function marketplaceBriefGeneralAction(params) {
    return { evid: 322, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramRevenueShareGenericClick' event (evid: 323)
 *
 * Event description: Fires on any click in rev share
 *
 * @param {partnerProgramRevenueShareGenericClickParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} subScreen - sub screen name
 * @property {string} screen_name - screen name
 * @property {string} click_type - click type
 * @property {string} data - data extracted from action
 * @property {string} option - sub action
 * @property {string} sub_screen_name - sub screen name
 * @property {string} platform - The platform the user is using
 * @return {LogObject<partnerProgramRevenueShareGenericClickParams>} LogObject<partnerProgramRevenueShareGenericClickParams>
 */
export function partnerProgramRevenueShareGenericClick(params) {
    return { evid: 323, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramRevenueShareScreenView' event (evid: 324)
 *
 * Event description: Fires when a screen of the revenue share opens
 *
 * @param {partnerProgramRevenueShareScreenViewParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} subScreen - sub screen name
 * @property {string} screen_name - screen name
 * @property {string} sub_screen_name - sub screen name
 * @property {string} platform - The platform the user is using
 * @property {string} entry - entry point where the user came from
 * @property {string} origin - URL where the user came from
 * @return {LogObject<partnerProgramRevenueShareScreenViewParams>} LogObject<partnerProgramRevenueShareScreenViewParams>
 */
export function partnerProgramRevenueShareScreenView(params) {
    return { evid: 324, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceOnboardingSaveChanges' event (evid: 325)
 *
 * Event description: Fires when partner saves the application and clicks "Save Changes" at any point in the onboarding
 *
 * @param {marketplaceOnboardingSaveChangesParams} params - The parameters for this event
 * @property {string} applicationData - json data of filled fields
 * @property {string} screenName - step in onboarding
 * @property {string} onboardingVersion - onboarding_version
 * @property {string} platform - The platform the user is using - wix.com / wix studio
 * @return {LogObject<marketplaceOnboardingSaveChangesParams>} LogObject<marketplaceOnboardingSaveChangesParams>
 */
export function marketplaceOnboardingSaveChanges(params) {
    return { evid: 325, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'exploreSortingRequestNew' event (evid: 329)
 *
 * Event description: fires every time a sorting request is called to sort the Partners in the Explore page (replaced  80:328)
 *
 * @param {exploreSortingRequestNewParams} params - The parameters for this event
 * @property {string} services - array of the services the user is searching for
 * @property {number} budgetFilter - the user's budget that he inserted in filter
 * @property {string} country - user's country
 * @property {string} locationFilter - the location the user entered to the filterers
 * @property {string} rankerVersion - the version of the mechanism
 * @property {string} language - user's language
 * @property {string} sessionId - the session of the user
 * @property {string} rankerParameters - json of the perameters
 * @property {string} rankerType - the mechanism that sorts the partner (ds/price/BI score/random)
 * @property {string} partnersList - json with all the partners presented to the user (after filters) with the score each partner got
 * @return {LogObject<exploreSortingRequestNewParams>} LogObject<exploreSortingRequestNewParams>
 */
export function exploreSortingRequestNew(params) {
    return { evid: 329, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressAddPremiumSite' event (evid: 33)
 *
 * Event description: add premium
 *
 * @param {pressAddPremiumSiteParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} buttonType - add new / add premium
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - depreciated
 * @return {LogObject<pressAddPremiumSiteParams>} LogObject<pressAddPremiumSiteParams>
 */
export function pressAddPremiumSite(params) {
    return { evid: 33, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerViewClickOfferIdSrc80Evid330' event (evid: 330)
 *
 * Event description: this event created for banners celebrations.  will fire when user sees / clicks on dealer offer id
 *
 * @param {dealerViewClickOfferIdSrc80Evid330Params} params - The parameters for this event
 * @property {string} dealer_offer_id - dealer offer id the user sees
 * @property {DateTime} date - date user see/clicked on offer
 * @property {string} click_type - click/view
 * @property {string} account_id - account_id
 * @property {string} placement_id -  placement id
 * @return {LogObject<dealerViewClickOfferIdSrc80Evid330Params>} LogObject<dealerViewClickOfferIdSrc80Evid330Params>
 */
export function dealerViewClickOfferIdSrc80Evid330(params) {
    return { evid: 330, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agencyProfileBriefGeneralActionSrc80Evid332' event (evid: 332)
 *
 * Event description: fires every time a user makes an action (click/keyboard fill) in Agency Profile  brief
 *
 * @param {agencyProfileBriefGeneralActionSrc80Evid332Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} step_name - name of step
 * @property {number} step_id - step id
 * @property {string} entry - entry point to brief
 * @property {string} data - data extracted from action
 * @property {string} briefType - Friendlier V1 / Friendlier V2 / Unified
 * @property {string} origin - {existing brief}
 * @property {string} sessionId - {}
 * @property {boolean} added_budget - True if the user added budget, false if the user chose that he is not sure what's his budget id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action_type - action_type
 * @return {LogObject<agencyProfileBriefGeneralActionSrc80Evid332Params>} LogObject<agencyProfileBriefGeneralActionSrc80Evid332Params>
 */
export function agencyProfileBriefGeneralActionSrc80Evid332(params) {
    return { evid: 332, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agencyProfileSettingPageLoadedSrc80Evid333' event (evid: 333)
 *
 * Event description: Fires when the a Agency Profile Setting Page is loaded
 *
 * @param {agencyProfileSettingPageLoadedSrc80Evid333Params} params - The parameters for this event
 * @property {string} screenName - The name of the screen
 * @property {boolean} is_in_partner_program - true if the logged_account_id is in partner program
 * @property {boolean} isPublished - true if agency profile is published
 * @property {string} entryPoint -  Entry point from which the user entered the Agency Profile Setting (e.g: sidebar)
 * @return {LogObject<agencyProfileSettingPageLoadedSrc80Evid333Params>} LogObject<agencyProfileSettingPageLoadedSrc80Evid333Params>
 */
export function agencyProfileSettingPageLoadedSrc80Evid333(params) {
    return { evid: 333, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agencyProfileSettingGenericClickSrc80Evid334' event (evid: 334)
 *
 * Event description: User clicks on one of the buttons in the agency profile setting page
 *
 * @param {agencyProfileSettingGenericClickSrc80Evid334Params} params - The parameters for this event
 * @property {string} clickName - The name of the button the user clicked on
 * @property {string} clickLocation - Location of the bottom at the page
 * @property {string} screenName - The name of the screen
 * @property {boolean} isPublished - true if the agency profile is published
 * @return {LogObject<agencyProfileSettingGenericClickSrc80Evid334Params>} LogObject<agencyProfileSettingGenericClickSrc80Evid334Params>
 */
export function agencyProfileSettingGenericClickSrc80Evid334(params) {
    return { evid: 334, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agencyProfileBriefLoadedSrc80Evid335' event (evid: 335)
 *
 * Event description: Agency Profile  brief load
 *
 * @param {agencyProfileBriefLoadedSrc80Evid335Params} params - The parameters for this event
 * @property {GUID} target_account_id - target_account_id
 * @property {string} entry - entry point to brief
 * @property {string} data - data extracted from action
 * @property {string} action_type - action_type
 * @property {boolean} inMarketplace - true if agency is in marketplace
 * @return {LogObject<agencyProfileBriefLoadedSrc80Evid335Params>} LogObject<agencyProfileBriefLoadedSrc80Evid335Params>
 */
export function agencyProfileBriefLoadedSrc80Evid335(params) {
    return { evid: 335, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agencyProfileSubmitBriefSrc80Evid336' event (evid: 336)
 *
 * Event description: User press on submit in the new brief
 *
 * @param {agencyProfileSubmitBriefSrc80Evid336Params} params - The parameters for this event
 * @property {string} entry - entry point to brief
 * @property {string} data - data extracted from action
 * @property {string} action_type - action_type
 * @property {boolean} inMarketplace - true if agency is in marketplace
 * @property {string} partnersAccountId - The account_id of the partners profile
 * @return {LogObject<agencyProfileSubmitBriefSrc80Evid336Params>} LogObject<agencyProfileSubmitBriefSrc80Evid336Params>
 */
export function agencyProfileSubmitBriefSrc80Evid336(params) {
    return { evid: 336, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressNextOnSubmitAPro' event (evid: 34)
 *
 * Event description: pressing next in pro brief
 *
 * @param {pressNextOnSubmitAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {since previous step}
 * @property {number} step - {step_number}
 * @property {string} buttonType - button_type
 * @property {string} data - {json data}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - deprecated
 * @property {boolean} validation - {}
 * @return {LogObject<pressNextOnSubmitAProParams>} LogObject<pressNextOnSubmitAProParams>
 */
export function pressNextOnSubmitAPro(params) {
    return { evid: 34, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersGpvMonthlyCalculationForRevShare' event (evid: 3401)
 *
 * Event description: This event fires on every rev share gpv calculation. at least one event for each account in each month showing all the gpv the user should get rev share on.
 * in case there was a calculation update for a user, another event will be sent with the same id and a new revision
 *
 * @param {partnersGpvMonthlyCalculationForRevShareParams} params - The parameters for this event
 * @property {number} revision - The version of the calculation for a specific account in a specific month (for the latest calculation need to take the maximum)
 * @property {GUID} id - The id from production. unique per account per a month
 * @property {string} sitesGpv - Json with data on all sites with gpv for the account in this month
 * @return {LogObject<partnersGpvMonthlyCalculationForRevShareParams>} LogObject<partnersGpvMonthlyCalculationForRevShareParams>
 */
export function partnersGpvMonthlyCalculationForRevShare(params) {
    return { evid: 3401, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'specificTemplateDetailsPageInTemplatesMarketplacePageView' event (evid: 3402)
 *
 * Event description: Page view of page details of Specific Template in Templates Marketplace
 *
 * @param {specificTemplateDetailsPageInTemplatesMarketplacePageViewParams} params - The parameters for this event
 * @property {string} origin - origin url the user came from to the page
 * @property {string} entry - entry point  where the user came from to the template page
 * @property {string} template_id - template_id of the template
 * @property {string} template_owner_account_id - account_id of the template owner
 * @property {string} editor_type - editor type of the template - Studio / Wix
 * @property {boolean} is_mobile - True if this is the mobile version of the page
 * @return {LogObject<specificTemplateDetailsPageInTemplatesMarketplacePageViewParams>} LogObject<specificTemplateDetailsPageInTemplatesMarketplacePageViewParams>
 */
export function specificTemplateDetailsPageInTemplatesMarketplacePageView(params) {
    return { evid: 3402, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'specificTemplateDetailsPageInTemplatesMarketplaceGenericClick' event (evid: 3403)
 *
 * Event description: Page click on the page details of Specific Template in Templates Marketplace
 *
 * @param {specificTemplateDetailsPageInTemplatesMarketplaceGenericClickParams} params - The parameters for this event
 * @property {string} origin - origin url the user came from to the page
 * @property {string} entry - entry point  where the user came from to the template page
 * @property {string} template_id - template_id of the template
 * @property {string} template_owner_account_id - account_id of the template owner
 * @property {string} editor_type - editor type of the template - Studio / Wix
 * @property {string} click_type - click type
 * @property {string} click_data - data on the click
 * @property {boolean} is_mobile - True if the is the mobile version of the page
 * @property {string} review_rating - rating of the template review
 * @property {string} reviewer_account_id - account_id of the user added a review
 * @property {string} review_content - the review the user added
 * @property {string} reply_content - the reply the owner added to the review
 * @property {string} review_id - id for the review
 * @return {LogObject<specificTemplateDetailsPageInTemplatesMarketplaceGenericClickParams>} LogObject<specificTemplateDetailsPageInTemplatesMarketplaceGenericClickParams>
 */
export function specificTemplateDetailsPageInTemplatesMarketplaceGenericClick(params) {
    return { evid: 3403, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesMarketplaceGalleryPagePageView' event (evid: 3404)
 *
 * Event description: Event is fired for each page view of the gallery page in the templates marketplace
 *
 * @param {templatesMarketplaceGalleryPagePageViewParams} params - The parameters for this event
 * @property {string} origin - page url where the user got from
 * @property {string} entry - entry point user got from
 * @property {boolean} is_mobile - True if the user use Mobile
 * @property {string} message_text - null if regular page view
 * else message text
 * @return {LogObject<templatesMarketplaceGalleryPagePageViewParams>} LogObject<templatesMarketplaceGalleryPagePageViewParams>
 */
export function templatesMarketplaceGalleryPagePageView(params) {
    return { evid: 3404, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesMarketplaceGalleryPageGenericClick' event (evid: 3405)
 *
 * Event description: Event is fired whenever user clicks on the templates marketplace gallery page
 *
 * @param {templatesMarketplaceGalleryPageGenericClickParams} params - The parameters for this event
 * @property {string} origin - page url where the user got from
 * @property {string} entry - entry point user got from
 * @property {string} click_type - click type
 * @property {string} click_data - click data
 * @property {boolean} is_mobile - True if the user use Mobile
 * @return {LogObject<templatesMarketplaceGalleryPageGenericClickParams>} LogObject<templatesMarketplaceGalleryPageGenericClickParams>
 */
export function templatesMarketplaceGalleryPageGenericClick(params) {
    return { evid: 3405, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSatellitesBuyerLandingPagePageView' event (evid: 3406)
 *
 * Event description: Templates satellites - page view of the Buyer landing page after using the link he gets from the seller
 *
 * @param {templatesSatellitesBuyerLandingPagePageViewParams} params - The parameters for this event
 * @property {string} template_id - id of the template used
 * @property {string} template_platform - wix.com/studio
 * @return {LogObject<templatesSatellitesBuyerLandingPagePageViewParams>} LogObject<templatesSatellitesBuyerLandingPagePageViewParams>
 */
export function templatesSatellitesBuyerLandingPagePageView(params) {
    return { evid: 3406, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSatellitesBuyerLandingPageGenericClick' event (evid: 3407)
 *
 * Event description: Templates satellites -click on the Buyer landing page after using the link he gets from the seller
 *
 * @param {templatesSatellitesBuyerLandingPageGenericClickParams} params - The parameters for this event
 * @property {string} template_platform - wix.com/studio
 * @property {string} template_id - id of the template used
 * @property {string} click_type - click_type
 * @property {string} workspace - The account id of the workspace the user chose
 * @return {LogObject<templatesSatellitesBuyerLandingPageGenericClickParams>} LogObject<templatesSatellitesBuyerLandingPageGenericClickParams>
 */
export function templatesSatellitesBuyerLandingPageGenericClick(params) {
    return { evid: 3407, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesMarketplaceCheckoutFlowPageView' event (evid: 3408)
 *
 * Event description: Page view of one of the pages of the templates marketplace checkout flow
 *
 * @param {templatesMarketplaceCheckoutFlowPageViewParams} params - The parameters for this event
 * @property {string} page_name - name of the page in the checkout flow
 * @property {string} template_id - id of the template that was bought
 * @property {string} origin - URL where the user came from
 * @property {string} entry - entry point
 * @property {boolean} is_end_of_funnel - True if after this page the site with the new template was added to the account. False if it's not the end of funnel and the account still need to choose the specific workspace
 * @return {LogObject<templatesMarketplaceCheckoutFlowPageViewParams>} LogObject<templatesMarketplaceCheckoutFlowPageViewParams>
 */
export function templatesMarketplaceCheckoutFlowPageView(params) {
    return { evid: 3408, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesMarketplaceCheckoutFlowGenericClick' event (evid: 3409)
 *
 * Event description: click on one of the pages of the templates marketplace checkout flow
 *
 * @param {templatesMarketplaceCheckoutFlowGenericClickParams} params - The parameters for this event
 * @property {string} page_name - name of the page in the checkout flow
 * @property {string} template_id - id of the template that was bought
 * @property {string} click_type - click type
 * @property {string} origin - url where the user came from
 * @property {string} entry - entry point
 * @property {string} click_data - click data
 * @property {boolean} is_end_of_funnel - True if after this page the site with the new template was added to the account. False if it's not the end of funnel and the account still need to choose the specific workspace
 * @return {LogObject<templatesMarketplaceCheckoutFlowGenericClickParams>} LogObject<templatesMarketplaceCheckoutFlowGenericClickParams>
 */
export function templatesMarketplaceCheckoutFlowGenericClick(params) {
    return { evid: 3409, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressAddSiteAfterAddingUrl' event (evid: 35)
 *
 * Event description: adding and validating the url as wix premium
 *
 * @param {pressAddSiteAfterAddingUrlParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} proStatus - pro_status
 * @property {string} source - source
 * @property {string} url - url
 * @property {boolean} isFirstComplete - is_first_complete
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - origin
 * @property {GUID} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true/false}
 * @return {LogObject<pressAddSiteAfterAddingUrlParams>} LogObject<pressAddSiteAfterAddingUrlParams>
 */
export function pressAddSiteAfterAddingUrl(params) {
    return { evid: 35, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerSiteSrc80Evid360' event (evid: 360)
 *
 * Event description: partner site events
 *
 * @param {partnerSiteSrc80Evid360Params} params - The parameters for this event
 * @property {GUID} accountId - the account of the event
 * @property {string} metaSite - the msid of the event
 * @property {string} info - events information
 * @return {LogObject<partnerSiteSrc80Evid360Params>} LogObject<partnerSiteSrc80Evid360Params>
 */
export function partnerSiteSrc80Evid360(params) {
    return { evid: 360, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proSubmitFormAsCandidate' event (evid: 38)
 *
 * Event description: pro form submitted
 *
 * @param {proSubmitFormAsCandidateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {MS since brief loaded}
 * @property {number} briefPageNum - deprecated
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} fieldLength - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} fieldType - deprecated
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - deprecated
 * @property {boolean} validation - {}
 * @return {LogObject<proSubmitFormAsCandidateParams>} LogObject<proSubmitFormAsCandidateParams>
 */
export function proSubmitFormAsCandidate(params) {
    return { evid: 38, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hireAnExpertFinishLoad' event (evid: 401)
 *
 * Event description: "Hire an Expert" page is loaded
 *
 * @param {hireAnExpertFinishLoadParams} params - The parameters for this event
 * @property {string} origin - Dashboard / my-sites ...
 * @return {LogObject<hireAnExpertFinishLoadParams>} LogObject<hireAnExpertFinishLoadParams>
 */
export function hireAnExpertFinishLoad(params) {
    return { evid: 401, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createNewProject' event (evid: 402)
 *
 * Event description: click on New Project from the "Hire an Expert" page
 *
 * @param {createNewProjectParams} params - The parameters for this event
 * @property {string} origin - button / text
 * @return {LogObject<createNewProjectParams>} LogObject<createNewProjectParams>
 */
export function createNewProject(params) {
    return { evid: 402, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateProjectStatus' event (evid: 403)
 *
 * Event description: click on the project status to change the current status
 *
 * @param {updateProjectStatusParams} params - The parameters for this event
 * @property {string} status - in progress / complete / canceled
 * @return {LogObject<updateProjectStatusParams>} LogObject<updateProjectStatusParams>
 */
export function updateProjectStatus(params) {
    return { evid: 403, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateStatusToInProgress' event (evid: 404)
 *
 * Event description: change the status of the project to "In Progress"
 *
 * @param {updateStatusToInProgressParams} params - The parameters for this event
 * @property {GUID} jobRequestId - job request id
 * @property {GUID} briefId - the brief id
 * @property {GUID} proGuid - the experts guid
 * @return {LogObject<updateStatusToInProgressParams>} LogObject<updateStatusToInProgressParams>
 */
export function updateStatusToInProgress(params) {
    return { evid: 404, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateStatusToCompleted' event (evid: 405)
 *
 * Event description: change the status of the project to "Completed"
 *
 * @param {updateStatusToCompletedParams} params - The parameters for this event
 * @property {GUID} jobRequestId - job request id
 * @property {GUID} briefId - the brief id
 * @property {GUID} proGuid - the experts guid
 * @return {LogObject<updateStatusToCompletedParams>} LogObject<updateStatusToCompletedParams>
 */
export function updateStatusToCompleted(params) {
    return { evid: 405, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateStatusToCanceled' event (evid: 406)
 *
 * Event description: change the status of the project to "Canceled"
 *
 * @param {updateStatusToCanceledParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @property {string} reason - I hired someone else / it's too expensive ...
 * @return {LogObject<updateStatusToCanceledParams>} LogObject<updateStatusToCanceledParams>
 */
export function updateStatusToCanceled(params) {
    return { evid: 406, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noMatchesAvailableLb' event (evid: 407)
 *
 * Event description: the "no matched available" lightbox pop up
 *
 * @param {noMatchesAvailableLbParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @return {LogObject<noMatchesAvailableLbParams>} LogObject<noMatchesAvailableLbParams>
 */
export function noMatchesAvailableLb(params) {
    return { evid: 407, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGetMoreMatches' event (evid: 408)
 *
 * Event description: user clicks on "Get more matches"
 *
 * @param {clickOnGetMoreMatchesParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @return {LogObject<clickOnGetMoreMatchesParams>} LogObject<clickOnGetMoreMatchesParams>
 */
export function clickOnGetMoreMatches(params) {
    return { evid: 408, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getMoreMatches' event (evid: 409)
 *
 * Event description: user clicks on submit in the  "Get more matches" LB
 *
 * @param {getMoreMatchesParams} params - The parameters for this event
 * @property {string} reason - no wix experts responded...
 * @property {GUID} briefId - brief_id
 * @return {LogObject<getMoreMatchesParams>} LogObject<getMoreMatchesParams>
 */
export function getMoreMatches(params) {
    return { evid: 409, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getMoreMatchesClosePopup' event (evid: 410)
 *
 * Event description: user clicks on cancel or X in the "Get more matches" LB
 *
 * @param {getMoreMatchesClosePopupParams} params - The parameters for this event
 * @return {LogObject<getMoreMatchesClosePopupParams>} LogObject<getMoreMatchesClosePopupParams>
 */
export function getMoreMatchesClosePopup(params) {
    return { evid: 410, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnSomeoneElseIsWorkingOnMyProject' event (evid: 411)
 *
 * Event description: user clicks on "Someone else is working on my project" in the "Get more matches" LB
 *
 * @param {clickOnSomeoneElseIsWorkingOnMyProjectParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @return {LogObject<clickOnSomeoneElseIsWorkingOnMyProjectParams>} LogObject<clickOnSomeoneElseIsWorkingOnMyProjectParams>
 */
export function clickOnSomeoneElseIsWorkingOnMyProject(params) {
    return { evid: 411, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateProjectStatusClosePopup' event (evid: 412)
 *
 * Event description: user clicks on cancel or X in the update project status LB
 *
 * @param {updateProjectStatusClosePopupParams} params - The parameters for this event
 * @return {LogObject<updateProjectStatusClosePopupParams>} LogObject<updateProjectStatusClosePopupParams>
 */
export function updateProjectStatusClosePopup(params) {
    return { evid: 412, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hireAnExpertClickOnSite' event (evid: 413)
 *
 * Event description: user clicks on a specific site in the "Hire an Expert" page
 *
 * @param {hireAnExpertClickOnSiteParams} params - The parameters for this event
 * @return {LogObject<hireAnExpertClickOnSiteParams>} LogObject<hireAnExpertClickOnSiteParams>
 */
export function hireAnExpertClickOnSite(params) {
    return { evid: 413, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hireAnExpertClickOnContactUs' event (evid: 414)
 *
 * Event description: user clicks on "contact us" in the "Hire an Expert" page
 *
 * @param {hireAnExpertClickOnContactUsParams} params - The parameters for this event
 * @return {LogObject<hireAnExpertClickOnContactUsParams>} LogObject<hireAnExpertClickOnContactUsParams>
 */
export function hireAnExpertClickOnContactUs(params) {
    return { evid: 414, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openProjectDetails' event (evid: 415)
 *
 * Event description: user clicks on a specific project in the "Hire an Expert" page to view the details
 *
 * @param {openProjectDetailsParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @return {LogObject<openProjectDetailsParams>} LogObject<openProjectDetailsParams>
 */
export function openProjectDetails(params) {
    return { evid: 415, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewExpertDetails' event (evid: 416)
 *
 * Event description: user clicks on an Expert to view the profile details
 *
 * @param {viewExpertDetailsParams} params - The parameters for this event
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<viewExpertDetailsParams>} LogObject<viewExpertDetailsParams>
 */
export function viewExpertDetails(params) {
    return { evid: 416, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'projectSeeMoreDetails' event (evid: 417)
 *
 * Event description: user clicks on "see more" in the project page
 *
 * @param {projectSeeMoreDetailsParams} params - The parameters for this event
 * @property {GUID} briefId - brief_id
 * @return {LogObject<projectSeeMoreDetailsParams>} LogObject<projectSeeMoreDetailsParams>
 */
export function projectSeeMoreDetails(params) {
    return { evid: 417, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewExpertArenaProfile' event (evid: 418)
 *
 * Event description: user clicks "view profile" on the expert details page
 *
 * @param {viewExpertArenaProfileParams} params - The parameters for this event
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<viewExpertArenaProfileParams>} LogObject<viewExpertArenaProfileParams>
 */
export function viewExpertArenaProfile(params) {
    return { evid: 418, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markExpertAsHired' event (evid: 419)
 *
 * Event description: user clicks "Mark as hired" on the expert details page
 *
 * @param {markExpertAsHiredParams} params - The parameters for this event
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<markExpertAsHiredParams>} LogObject<markExpertAsHiredParams>
 */
export function markExpertAsHired(params) {
    return { evid: 419, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proFormSubmitedSuccessfully' event (evid: 42)
 *
 * Event description: Request was submitted: thank you page
 *
 * @param {proFormSubmitedSuccessfullyParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} processTime - depreciated
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proFormSubmitedSuccessfullyParams>} LogObject<proFormSubmitedSuccessfullyParams>
 */
export function proFormSubmitedSuccessfully(params) {
    return { evid: 42, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markAsHiredClosePopup' event (evid: 420)
 *
 * Event description: user clicks on cancel or X in the "Mark as hired" LB
 *
 * @param {markAsHiredClosePopupParams} params - The parameters for this event
 * @return {LogObject<markAsHiredClosePopupParams>} LogObject<markAsHiredClosePopupParams>
 */
export function markAsHiredClosePopup(params) {
    return { evid: 420, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'projectLeaveAReview' event (evid: 421)
 *
 * Event description: click on "review your experience" on a specific project
 *
 * @param {projectLeaveAReviewParams} params - The parameters for this event
 * @property {GUID} jobRequestId - job request id
 * @property {GUID} briefId - the brief id
 * @property {GUID} proGuid - the experts guid
 * @return {LogObject<projectLeaveAReviewParams>} LogObject<projectLeaveAReviewParams>
 */
export function projectLeaveAReview(params) {
    return { evid: 421, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishClicked' event (evid: 43)
 *
 * Event description: edit profile page loaded (after approved before live)
 *
 * @param {proProfileEditProfileChangePublishClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} profileTab - deprecated
 * @property {string} filledFields - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proProfileEditProfileChangePublishClickedParams>} LogObject<proProfileEditProfileChangePublishClickedParams>
 */
export function proProfileEditProfileChangePublishClicked(params) {
    return { evid: 43, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishRequest' event (evid: 44)
 *
 * Event description: expert press different tabs while updating profile
 *
 * @param {proProfileEditProfileChangePublishRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} isValid - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origTabName - {}
 * @property {string} profileTab - profile_tab
 * @property {string} filledFields - f_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} newTabName - {}
 * @return {LogObject<proProfileEditProfileChangePublishRequestParams>} LogObject<proProfileEditProfileChangePublishRequestParams>
 */
export function proProfileEditProfileChangePublishRequest(params) {
    return { evid: 44, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishDone' event (evid: 45)
 *
 * Event description: edit / hide / show / delete site in pro profile
 *
 * @param {proProfileEditProfileChangePublishDoneParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {Url} url - {site_url}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} profileTab - profile_tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} processTime - process_time
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - {hide/show}
 * @return {LogObject<proProfileEditProfileChangePublishDoneParams>} LogObject<proProfileEditProfileChangePublishDoneParams>
 */
export function proProfileEditProfileChangePublishDone(params) {
    return { evid: 45, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proProfileEditSaveButtonClicked' event (evid: 46)
 *
 * Event description: press save profile
 *
 * @param {proProfileEditSaveButtonClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between page load and submit}
 * @property {string} buttonType - {top/bottom}
 * @property {string} data - {json_string}
 * @property {boolean} isFirst - {first time the user edits}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} isFirstTimeLive - is_first_time_live
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {}
 * @return {LogObject<proProfileEditSaveButtonClickedParams>} LogObject<proProfileEditSaveButtonClickedParams>
 */
export function proProfileEditSaveButtonClicked(params) {
    return { evid: 46, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proProfileUserBrief' event (evid: 47)
 *
 * Event description: reviewed a user brief
 *
 * @param {proProfileUserBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {guid from server}
 * @property {string} typeOfService - type_of_service
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email / dashboard}
 * @property {boolean} isMultiplePros - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief_id
 * @property {GUID} proGuid - deprecated
 * @return {LogObject<proProfileUserBriefParams>} LogObject<proProfileUserBriefParams>
 */
export function proProfileUserBrief(params) {
    return { evid: 47, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userHomepageLoaded' event (evid: 49)
 *
 * Event description: user homepage loaded; if user logged in uuid provided.
 *
 * @param {userHomepageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} referral_name - {}
 * @property {GUID} visitorId - depreciated
 * @property {string} list_preset - {location of expert on page}
 * @property {number} height - Initial height of client window
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - arena_lang
 * @property {string} origin - {}
 * @property {number} loadTime - {time in MS from start to load until finish load}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - Initial width of client window
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHomepageLoadedParams>} LogObject<userHomepageLoadedParams>
 */
export function userHomepageLoaded(params) {
    return { evid: 49, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefPageLoaded' event (evid: 50)
 *
 * Event description: brief loaded
 *
 * @param {briefPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - data
 * @property {number} height - height
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {login}
 * @property {string} sessionId - session_id
 * @property {GUID} visitorid - {visitor guid if the user not logged in}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - width
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<briefPageLoadedParams>} LogObject<briefPageLoadedParams>
 */
export function briefPageLoaded(params) {
    return { evid: 50, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertsLpClickOnDownloadNow' event (evid: 501)
 *
 * Event description: user clicks on the button on the experts lp to submit the form
 *
 * @param {expertsLpClickOnDownloadNowParams} params - The parameters for this event
 * @property {boolean} formIsValid - true / false if the form is valid
 * @property {string} additional_info - additional info like location of a button
 * @property {string} button_name - The caption on the button on which the user clicked
 * @property {Url} full_url - url including utm / referral_info (to disclose where the user came from)
 * @property {string} topic - page topic, for example: Wix answers
 * @property {string} formDetailsJson - user info filled in the form
 * @property {string} leadId - _ID from corvid data
 * @return {LogObject<expertsLpClickOnDownloadNowParams>} LogObject<expertsLpClickOnDownloadNowParams>
 */
export function expertsLpClickOnDownloadNow(params) {
    return { evid: 501, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertsLpClickOnSignUpHere' event (evid: 502)
 *
 * Event description: user clicks on "Sign Up Here" button on the expert LPs (in the thank you page) or clicks on the "Get Started" on the popup after submitting the form
 *
 * @param {expertsLpClickOnSignUpHereParams} params - The parameters for this event
 * @return {LogObject<expertsLpClickOnSignUpHereParams>} LogObject<expertsLpClickOnSignUpHereParams>
 */
export function expertsLpClickOnSignUpHere(params) {
    return { evid: 502, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertsClickToOpenForm' event (evid: 503)
 *
 * Event description: user clicks on the button to open the form
 *
 * @param {expertsClickToOpenFormParams} params - The parameters for this event
 * @return {LogObject<expertsClickToOpenFormParams>} LogObject<expertsClickToOpenFormParams>
 */
export function expertsClickToOpenForm(params) {
    return { evid: 503, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'letSTalkOpenContactUsPage' event (evid: 504)
 *
 * Event description: Fires when user clicks on 'Let's talk' that leads to contact form for partners program
 *
 * @param {letSTalkOpenContactUsPageParams} params - The parameters for this event
 * @property {string} origin - page from which user clicked in link
 * @return {LogObject<letSTalkOpenContactUsPageParams>} LogObject<letSTalkOpenContactUsPageParams>
 */
export function letSTalkOpenContactUsPage(params) {
    return { evid: 504, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userExitBrief' event (evid: 51)
 *
 * Event description: brief window not in focus (user moved to another tab/ window)
 *
 * @param {userExitBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between brief loaded and exit}
 * @property {string} data - {json that contains the brief}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<userExitBriefParams>} LogObject<userExitBriefParams>
 */
export function userExitBrief(params) {
    return { evid: 51, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitBrief' event (evid: 52)
 *
 * Event description: user submits brief
 *
 * @param {submitBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - time_in_page
 * @property {boolean} sameBriefExperts - 1:same brief; 0 - not same brief
 * @property {string} data - data
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<submitBriefParams>} LogObject<submitBriefParams>
 */
export function submitBrief(params) {
    return { evid: 52, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressNext' event (evid: 53)
 *
 * Event description: user press next in brief
 *
 * @param {pressNextParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - time_in_page
 * @property {number} step - step_id
 * @property {string} data - data
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - origin
 * @property {string} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<pressNextParams>} LogObject<pressNextParams>
 */
export function pressNext(params) {
    return { evid: 53, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressBack' event (evid: 54)
 *
 * Event description: user press back in brief
 *
 * @param {pressBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between step loaded and press back}
 * @property {number} step - {page number where next pressed}
 * @property {string} screenName - screen name
 * @property {string} data - {json that contains the brief}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for testing
 * @property {string} origin - {button ; step_name}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressBackParams>} LogObject<pressBackParams>
 */
export function pressBack(params) {
    return { evid: 54, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefAcceptedByServer' event (evid: 55)
 *
 * Event description: brief accepted by server
 *
 * @param {briefAcceptedByServerParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} timeInterval - {milliseconds between brief submit and brief accepted -this event}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<briefAcceptedByServerParams>} LogObject<briefAcceptedByServerParams>
 */
export function briefAcceptedByServer(params) {
    return { evid: 55, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'askToSendBriefToProsRequestToServer' event (evid: 56)
 *
 * Event description: brief accepted by server and asked to send to pros
 *
 * @param {askToSendBriefToProsRequestToServerParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<askToSendBriefToProsRequestToServerParams>} LogObject<askToSendBriefToProsRequestToServerParams>
 */
export function askToSendBriefToProsRequestToServer(params) {
    return { evid: 56, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouForSubmittingBrief' event (evid: 57)
 *
 * Event description: thank you page after brief was submitted successfully
 *
 * @param {thankYouForSubmittingBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<thankYouForSubmittingBriefParams>} LogObject<thankYouForSubmittingBriefParams>
 */
export function thankYouForSubmittingBrief(params) {
    return { evid: 57, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressBackOnSubmitAPro' event (evid: 58)
 *
 * Event description: pressing back in pro brief
 *
 * @param {pressBackOnSubmitAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {since previous step}
 * @property {number} step - {step_number}
 * @property {string} buttonType - top , bottom
 * @property {string} data - {json data}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {}
 * @return {LogObject<pressBackOnSubmitAProParams>} LogObject<pressBackOnSubmitAProParams>
 */
export function pressBackOnSubmitAPro(params) {
    return { evid: 58, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'becomeAProPendingRequest' event (evid: 59)
 *
 * Event description: pro tries to submit again - got pending request page
 *
 * @param {becomeAProPendingRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<becomeAProPendingRequestParams>} LogObject<becomeAProPendingRequestParams>
 */
export function becomeAProPendingRequest(params) {
    return { evid: 59, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioEducationPlatformPageLoadSrc80Evid6' event (evid: 6)
 *
 * Event description: load page event for Studio Education in Studio builder
 *
 * @param {studioEducationPlatformPageLoadSrc80Evid6Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - From Wix Academy/From the Community
 * @property {string} entry - entry point to the studio Education page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<studioEducationPlatformPageLoadSrc80Evid6Params>} LogObject<studioEducationPlatformPageLoadSrc80Evid6Params>
 */
export function studioEducationPlatformPageLoadSrc80Evid6(params) {
    return { evid: 6, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proGoLive' event (evid: 60)
 *
 * Event description: pro press go live to profile
 *
 * @param {proGoLiveParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proGoLiveParams>} LogObject<proGoLiveParams>
 */
export function proGoLive(params) {
    return { evid: 60, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramZeroState' event (evid: 601)
 *
 * Event description: user opens one of the screen that are limited to partner program applicants and the screen is blocked
 *
 * @param {loyaltyProgramZeroStateParams} params - The parameters for this event
 * @property {string} section - marketplace / deals / product betas
 * @return {LogObject<loyaltyProgramZeroStateParams>} LogObject<loyaltyProgramZeroStateParams>
 */
export function loyaltyProgramZeroState(params) {
    return { evid: 601, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnJoinNow' event (evid: 602)
 *
 * Event description: user clicks on the "Join Now" button on one of the blocked screens
 *
 * @param {loyaltyProgramClickOnJoinNowParams} params - The parameters for this event
 * @property {string} section - marketplace / deals / product betas
 * @return {LogObject<loyaltyProgramClickOnJoinNowParams>} LogObject<loyaltyProgramClickOnJoinNowParams>
 */
export function loyaltyProgramClickOnJoinNow(params) {
    return { evid: 602, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnUpgradeASite' event (evid: 604)
 *
 * Event description: User clicks on the "upgrade a site" button in the "overview" screen
 *
 * @param {loyaltyProgramClickOnUpgradeASiteParams} params - The parameters for this event
 * @property {string} section - home/revenue-share
 * @return {LogObject<loyaltyProgramClickOnUpgradeASiteParams>} LogObject<loyaltyProgramClickOnUpgradeASiteParams>
 */
export function loyaltyProgramClickOnUpgradeASite(params) {
    return { evid: 604, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnTermsAndConditions' event (evid: 605)
 *
 * Event description: User clicks on the "terms and conditions" button
 *
 * @param {loyaltyProgramClickOnTermsAndConditionsParams} params - The parameters for this event
 * @return {LogObject<loyaltyProgramClickOnTermsAndConditionsParams>} LogObject<loyaltyProgramClickOnTermsAndConditionsParams>
 */
export function loyaltyProgramClickOnTermsAndConditions(params) {
    return { evid: 605, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnSeeAllBenefits' event (evid: 606)
 *
 * Event description: User clicks on the "see all benefits" button
 *
 * @param {loyaltyProgramClickOnSeeAllBenefitsParams} params - The parameters for this event
 * @property {string} section - rev share / home
 * @return {LogObject<loyaltyProgramClickOnSeeAllBenefitsParams>} LogObject<loyaltyProgramClickOnSeeAllBenefitsParams>
 */
export function loyaltyProgramClickOnSeeAllBenefits(params) {
    return { evid: 606, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnTakeMeThere' event (evid: 607)
 *
 * Event description: User clicks on the "go to partner dashboard" from the partner program sections
 *
 * @param {loyaltyProgramClickOnTakeMeThereParams} params - The parameters for this event
 * @property {string} section - home/revenue-share
 * @return {LogObject<loyaltyProgramClickOnTakeMeThereParams>} LogObject<loyaltyProgramClickOnTakeMeThereParams>
 */
export function loyaltyProgramClickOnTakeMeThere(params) {
    return { evid: 607, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnGetPointsForIt' event (evid: 608)
 *
 * Event description: User clicks on the "get points for it" button on the how to earn points section in the "overview" screen
 *
 * @param {loyaltyProgramClickOnGetPointsForItParams} params - The parameters for this event
 * @property {string} section - home/revenue-share
 * @return {LogObject<loyaltyProgramClickOnGetPointsForItParams>} LogObject<loyaltyProgramClickOnGetPointsForItParams>
 */
export function loyaltyProgramClickOnGetPointsForIt(params) {
    return { evid: 608, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnSubmitASiteOutsideYourAccount' event (evid: 609)
 *
 * Event description: User clicks on the "submit" button on the "submit a site outside your account" popup. Both for points and for rev-share
 *
 * @param {loyaltyProgramClickOnSubmitASiteOutsideYourAccountParams} params - The parameters for this event
 * @property {string} businessName - the business name filled by the user
 * @property {string} submissionType - points / rev-share
 * @property {string} siteUrl - the site url from the form
 * @return {LogObject<loyaltyProgramClickOnSubmitASiteOutsideYourAccountParams>} LogObject<loyaltyProgramClickOnSubmitASiteOutsideYourAccountParams>
 */
export function loyaltyProgramClickOnSubmitASiteOutsideYourAccount(params) {
    return { evid: 609, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userAlreadySentGroupRequest' event (evid: 61)
 *
 * Event description: User submit request and received a page: "you have already sent a group request"
 *
 * @param {userAlreadySentGroupRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userAlreadySentGroupRequestParams>} LogObject<userAlreadySentGroupRequestParams>
 */
export function userAlreadySentGroupRequest(params) {
    return { evid: 61, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramShareLevel' event (evid: 610)
 *
 * Event description: user clicks on "share level" from the partner program home screen
 *
 * @param {loyaltyProgramShareLevelParams} params - The parameters for this event
 * @property {number} points - Partner's Points
 * @property {string} level - Partner's level
 * @return {LogObject<loyaltyProgramShareLevelParams>} LogObject<loyaltyProgramShareLevelParams>
 */
export function loyaltyProgramShareLevel(params) {
    return { evid: 610, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramDownloadBadge' event (evid: 611)
 *
 * Event description: user clicks on "download badge" from the level popup
 *
 * @param {loyaltyProgramDownloadBadgeParams} params - The parameters for this event
 * @property {string} level - pioneer/explorer
 * @property {number} points - Partner's Points
 * @return {LogObject<loyaltyProgramDownloadBadgeParams>} LogObject<loyaltyProgramDownloadBadgeParams>
 */
export function loyaltyProgramDownloadBadge(params) {
    return { evid: 611, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramBenefitLearnMore' event (evid: 612)
 *
 * Event description: user clicks on "learn more" in the benefit popup
 *
 * @param {loyaltyProgramBenefitLearnMoreParams} params - The parameters for this event
 * @property {string} benefitName - the benefit name
 * @return {LogObject<loyaltyProgramBenefitLearnMoreParams>} LogObject<loyaltyProgramBenefitLearnMoreParams>
 */
export function loyaltyProgramBenefitLearnMore(params) {
    return { evid: 612, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramBenefitRequest' event (evid: 613)
 *
 * Event description: user clicks on contact us to submit a benefit request
 *
 * @param {loyaltyProgramBenefitRequestParams} params - The parameters for this event
 * @property {string} section - rev-share/home
 * @return {LogObject<loyaltyProgramBenefitRequestParams>} LogObject<loyaltyProgramBenefitRequestParams>
 */
export function loyaltyProgramBenefitRequest(params) {
    return { evid: 613, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramSubmitBenefitRequest' event (evid: 614)
 *
 * Event description: user clicks on "submit" in the benefit request popup
 *
 * @param {loyaltyProgramSubmitBenefitRequestParams} params - The parameters for this event
 * @property {string} benefitName - the benefit name
 * @property {string} origin - origin
 * @return {LogObject<loyaltyProgramSubmitBenefitRequestParams>} LogObject<loyaltyProgramSubmitBenefitRequestParams>
 */
export function loyaltyProgramSubmitBenefitRequest(params) {
    return { evid: 614, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramCheckLevel' event (evid: 616)
 *
 * Event description: user clicks on "see me level" in the not-eligible screen/top banner
 *
 * @param {loyaltyProgramCheckLevelParams} params - The parameters for this event
 * @property {string} source - welcome-screen/top-banner
 * @return {LogObject<loyaltyProgramCheckLevelParams>} LogObject<loyaltyProgramCheckLevelParams>
 */
export function loyaltyProgramCheckLevel(params) {
    return { evid: 616, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramClickOnConnectEditPayment' event (evid: 617)
 *
 * Event description: user clicks on "connect/edit payment" in the rev-share section
 *
 * @param {loyaltyProgramClickOnConnectEditPaymentParams} params - The parameters for this event
 * @property {string} action - connect-payment/edit-payment
 * @return {LogObject<loyaltyProgramClickOnConnectEditPaymentParams>} LogObject<loyaltyProgramClickOnConnectEditPaymentParams>
 */
export function loyaltyProgramClickOnConnectEditPayment(params) {
    return { evid: 617, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertTryToContactAnotherExpert' event (evid: 62)
 *
 * Event description: expert receives explanation message that he can't contact another expert but can contact himself
 *
 * @param {expertTryToContactAnotherExpertParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertTryToContactAnotherExpertParams>} LogObject<expertTryToContactAnotherExpertParams>
 */
export function expertTryToContactAnotherExpert(params) {
    return { evid: 62, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertTryContactOtherExpertsInFindMeAPro' event (evid: 63)
 *
 * Event description: expert receives explanation message that he can't contact another experts in the "find me a pro" flow
 *
 * @param {expertTryContactOtherExpertsInFindMeAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertTryContactOtherExpertsInFindMeAProParams>} LogObject<expertTryContactOtherExpertsInFindMeAProParams>
 */
export function expertTryContactOtherExpertsInFindMeAPro(params) {
    return { evid: 63, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramSiteOwnerVerificationSiteSupportClick' event (evid: 630)
 *
 * Event description: Clicked for Support on verify site claim site
 *
 * @param {loyaltyProgramSiteOwnerVerificationSiteSupportClickParams} params - The parameters for this event
 * @property {GUID} submissionId - Submission Guid
 * @property {string} businessName - Partner's business name
 * @property {GUID} msid - msid being claimed
 * @property {string} siteUrl - URL
 * @return {LogObject<loyaltyProgramSiteOwnerVerificationSiteSupportClickParams>} LogObject<loyaltyProgramSiteOwnerVerificationSiteSupportClickParams>
 */
export function loyaltyProgramSiteOwnerVerificationSiteSupportClick(params) {
    return { evid: 630, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyProgramSubmitASiteErrors' event (evid: 632)
 *
 * Event description: Fires when users can see an error on siteURL they want to submit
 *
 * @param {loyaltyProgramSubmitASiteErrorsParams} params - The parameters for this event
 * @property {string} errorType - The error blocking the submission
 * @property {string} businessName - the business name filled by the user
 * @property {string} submissionType - points / rev-share
 * @property {string} siteUrl - the site url from the form
 * @return {LogObject<loyaltyProgramSubmitASiteErrorsParams>} LogObject<loyaltyProgramSubmitASiteErrorsParams>
 */
export function loyaltyProgramSubmitASiteErrors(params) {
    return { evid: 632, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingWelcomeScreenGenericClick' event (evid: 634)
 *
 * Event description: Event fires when user clicks on one of the buttons in the onboarding main screen- https://docs.google.com/presentation/d/1NM4sr2etNs71qagYPdu-zn22RqwA1D2GS5Uwph26nms/edit#slide=id.g12fa5cb91a2_1_17
 *
 * @param {partnersOnboardingWelcomeScreenGenericClickParams} params - The parameters for this event
 * @property {string} screenName - mandatory info/ optional info
 * @property {string} clickType - 'Become a Wix Partner'/ 'Learn More'/ 'Terms & Conditions'/ 'back'/ 'Revenue Share' / 'Marketplace' / 'X- Exit modal' / 'View Benefits'
 * @property {string} origin - where user came from (referral)
 * @property {string} platform - The platform the user is using - Wix.com/ Wix Studio
 * @return {LogObject<partnersOnboardingWelcomeScreenGenericClickParams>} LogObject<partnersOnboardingWelcomeScreenGenericClickParams>
 */
export function partnersOnboardingWelcomeScreenGenericClick(params) {
    return { evid: 634, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersOnboardingFillInfoGenericClick' event (evid: 635)
 *
 * Event description: Event fires when user clicks on one of the buttons in the onboarding user info screen- https://docs.google.com/presentation/d/1NM4sr2etNs71qagYPdu-zn22RqwA1D2GS5Uwph26nms/edit#slide=id.g12fa5cb91a2_1_17
 *
 * @param {partnersOnboardingFillInfoGenericClickParams} params - The parameters for this event
 * @property {string} screenName - mandatory info/ optional info
 * @property {string} data - json data extracted from the filled form
 * @property {string} clickType - cancel/submit/drop-downs/x /skip
 * @property {string} origin - where user came from (referral)
 * @return {LogObject<partnersOnboardingFillInfoGenericClickParams>} LogObject<partnersOnboardingFillInfoGenericClickParams>
 */
export function partnersOnboardingFillInfoGenericClick(params) {
    return { evid: 635, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramLevelWidgetView' event (evid: 637)
 *
 * Event description: View of the partner program widget
 *
 * @param {partnerProgramLevelWidgetViewParams} params - The parameters for this event
 * @property {string} page - the full page name where the user see the widget
 * @property {string} widget_type - the type of info shown, depends on the user level
 * @property {string} platform - The platform the widget was viewed
 * @property {GUID} dashboard_msid - partners dashboard msid
 * @return {LogObject<partnerProgramLevelWidgetViewParams>} LogObject<partnerProgramLevelWidgetViewParams>
 */
export function partnerProgramLevelWidgetView(params) {
    return { evid: 637, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramWidgetClick' event (evid: 638)
 *
 * Event description: Click on the partners program widget
 *
 * @param {partnerProgramWidgetClickParams} params - The parameters for this event
 * @property {string} partner_level - the level of the partner in the partners program
 * @property {string} clcik_type - where the user clicked
 * @property {string} widget_type - the type of widget shown, depends on the user level and platform
 * @property {string} platform - the platform the used while clicking
 * @property {GUID} dashboard_msid - The msid of the partner dashboard - unique per account
 * @return {LogObject<partnerProgramWidgetClickParams>} LogObject<partnerProgramWidgetClickParams>
 */
export function partnerProgramWidgetClick(params) {
    return { evid: 638, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramPointsModalView' event (evid: 639)
 *
 * Event description: Viewing the partners program points modal
 *
 * @param {partnerProgramPointsModalViewParams} params - The parameters for this event
 * @property {string} tab_type - The tab the user is viewing in the modal
 * @property {string} entry_point - The entry point to the points modal
 * @property {string} platform - The platform the user is using
 * @property {string} dashboard_msid - msid of the partners dashboard - unique per account
 * @return {LogObject<partnerProgramPointsModalViewParams>} LogObject<partnerProgramPointsModalViewParams>
 */
export function partnerProgramPointsModalView(params) {
    return { evid: 639, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeSiteFromApplication' event (evid: 64)
 *
 * Event description: pressing remove a site from application (become an expert)
 *
 * @param {removeSiteFromApplicationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} url - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<removeSiteFromApplicationParams>} LogObject<removeSiteFromApplicationParams>
 */
export function removeSiteFromApplication(params) {
    return { evid: 64, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramPointsModalClick' event (evid: 640)
 *
 * Event description: Clicking on the partners program points modal
 *
 * @param {partnerProgramPointsModalClickParams} params - The parameters for this event
 * @property {string} click_type - What the user clicked on in the modal
 * @property {string} tab_type - The tab the user is viewing in the modal
 * @property {string} platform - The platform the user is using
 * @property {string} dashboard_msid - msid of the partners dashboard - unique per account
 * @return {LogObject<partnerProgramPointsModalClickParams>} LogObject<partnerProgramPointsModalClickParams>
 */
export function partnerProgramPointsModalClick(params) {
    return { evid: 640, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'joinPartnerProgramFial' event (evid: 641)
 *
 * Event description: Fail to join the partner program
 *
 * @param {joinPartnerProgramFialParams} params - The parameters for this event
 * @property {string} platform - The platform the user is using - Wix.com / Wix Studio
 * @return {LogObject<joinPartnerProgramFialParams>} LogObject<joinPartnerProgramFialParams>
 */
export function joinPartnerProgramFial(params) {
    return { evid: 641, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketplaceTabApplyToJoinPageHover' event (evid: 642)
 *
 * Event description: fires, when a partner hover on a button at the Partner Dashboard marketplace tab, on all states prior to being Marketplace partner
 *
 * @param {marketplaceTabApplyToJoinPageHoverParams} params - The parameters for this event
 * @property {string} hover_type - hover type where the user hover
 * @property {string} pageState - 'allegeable to join'  and all other states
 * @property {string} platform - The platform the user is using - Wix.com / Wix studio
 * @return {LogObject<marketplaceTabApplyToJoinPageHoverParams>} LogObject<marketplaceTabApplyToJoinPageHoverParams>
 */
export function marketplaceTabApplyToJoinPageHover(params) {
    return { evid: 642, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'productBetasStudioEntryPointClick' event (evid: 644)
 *
 * Event description: Event is fired when user is clicking to check out Studio from the Betas page in the partners dashboard
 *
 * @param {productBetasStudioEntryPointClickParams} params - The parameters for this event
 * @property {string} click_type - click type
 * @return {LogObject<productBetasStudioEntryPointClickParams>} LogObject<productBetasStudioEntryPointClickParams>
 */
export function productBetasStudioEntryPointClick(params) {
    return { evid: 644, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'productBetasStudioEntryPointView' event (evid: 645)
 *
 * Event description: Event is fired when the entry point to studio is viewed in the betas page
 *
 * @param {productBetasStudioEntryPointViewParams} params - The parameters for this event
 * @return {LogObject<productBetasStudioEntryPointViewParams>} LogObject<productBetasStudioEntryPointViewParams>
 */
export function productBetasStudioEntryPointView(params) {
    return { evid: 645, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsOverviewPageView' event (evid: 646)
 *
 * Event description: Fires on any page view in the Earnings overview page
 *
 * @param {earningsOverviewPageViewParams} params - The parameters for this event
 * @property {string} screen - Name of the screen the user is seeing
 * @return {LogObject<earningsOverviewPageViewParams>} LogObject<earningsOverviewPageViewParams>
 */
export function earningsOverviewPageView(params) {
    return { evid: 646, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsOverviewGenericClick' event (evid: 647)
 *
 * Event description: Fires on any click in the Earning overview page
 *
 * @param {earningsOverviewGenericClickParams} params - The parameters for this event
 * @property {string} click_type - click type
 * @property {string} data - data extracted from action
 * @property {string} screen - Name of the screen the user is seeing
 * @return {LogObject<earningsOverviewGenericClickParams>} LogObject<earningsOverviewGenericClickParams>
 */
export function earningsOverviewGenericClick(params) {
    return { evid: 647, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsAppSalesPageView' event (evid: 648)
 *
 * Event description: Fires on any page view in the app sales page
 *
 * @param {earningsAppSalesPageViewParams} params - The parameters for this event
 * @property {string} screen - Name of the screen the user is seeing
 * @return {LogObject<earningsAppSalesPageViewParams>} LogObject<earningsAppSalesPageViewParams>
 */
export function earningsAppSalesPageView(params) {
    return { evid: 648, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsAppSalesPageGenericClick' event (evid: 649)
 *
 * Event description: Fires on any click in the Earning App sales page
 *
 * @param {earningsAppSalesPageGenericClickParams} params - The parameters for this event
 * @property {string} click_type - click type
 * @property {string} data - data extracted from action
 * @property {string} screen - Name of the screen the user is seeing
 * @return {LogObject<earningsAppSalesPageGenericClickParams>} LogObject<earningsAppSalesPageGenericClickParams>
 */
export function earningsAppSalesPageGenericClick(params) {
    return { evid: 649, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'approveRemoveSiteFromApplication' event (evid: 65)
 *
 * Event description: pressing yes on the are you sure screen before removing a site from application (become an expert)
 *
 * @param {approveRemoveSiteFromApplicationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} url - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<approveRemoveSiteFromApplicationParams>} LogObject<approveRemoveSiteFromApplicationParams>
 */
export function approveRemoveSiteFromApplication(params) {
    return { evid: 65, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramJoiningFormScreenView' event (evid: 650)
 *
 * Event description: Fires when a screen of the partners program joining form is viewed
 *
 * @param {partnerProgramJoiningFormScreenViewParams} params - The parameters for this event
 * @property {string} origin - origin url where the user got from
 * @property {string} version - the version of the PP flow
 * @return {LogObject<partnerProgramJoiningFormScreenViewParams>} LogObject<partnerProgramJoiningFormScreenViewParams>
 */
export function partnerProgramJoiningFormScreenView(params) {
    return { evid: 650, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramJoiningFormClick' event (evid: 651)
 *
 * Event description: Fires when a clicking on the partners program joining form
 *
 * @param {partnerProgramJoiningFormClickParams} params - The parameters for this event
 * @property {string} services_you_provide - services_you_provide
 * @property {string} client_site_url - client_site_url
 * @property {string} click_type - click type
 * @property {string} business_site_url - business_site_url
 * @property {number} number_of_teammates - number_of_teammates
 * @property {string} origin - origin url where the user got from
 * @property {string} social_url - social_url
 * @property {string} version - the version of form
 * @return {LogObject<partnerProgramJoiningFormClickParams>} LogObject<partnerProgramJoiningFormClickParams>
 */
export function partnerProgramJoiningFormClick(params) {
    return { evid: 651, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioCustomBrandingGenericPageView' event (evid: 652)
 *
 * Event description: Page view on the Studio Custom branding Set-up page
 *
 * @param {studioCustomBrandingGenericPageViewParams} params - The parameters for this event
 * @property {string} screen_name - The screen name the user viewed
 * @return {LogObject<studioCustomBrandingGenericPageViewParams>} LogObject<studioCustomBrandingGenericPageViewParams>
 */
export function studioCustomBrandingGenericPageView(params) {
    return { evid: 652, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioCustomBrandingGenericClick' event (evid: 653)
 *
 * Event description: Click on the Studio Custom branding Set-up page
 *
 * @param {studioCustomBrandingGenericClickParams} params - The parameters for this event
 * @property {string} screen_name - The screen name the user viewed
 * @property {string} click_type - click
 * @property {string} data - extra data
 * @return {LogObject<studioCustomBrandingGenericClickParams>} LogObject<studioCustomBrandingGenericClickParams>
 */
export function studioCustomBrandingGenericClick(params) {
    return { evid: 653, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioCustomBrandingLogoWasAddedSuccessfully' event (evid: 654)
 *
 * Event description: Event is sent when the user uploaded the custom branding logo successfully
 *
 * @param {studioCustomBrandingLogoWasAddedSuccessfullyParams} params - The parameters for this event
 * @return {LogObject<studioCustomBrandingLogoWasAddedSuccessfullyParams>} LogObject<studioCustomBrandingLogoWasAddedSuccessfullyParams>
 */
export function studioCustomBrandingLogoWasAddedSuccessfully(params) {
    return { evid: 654, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'switchingToStudioModalModalLoaded' event (evid: 655)
 *
 * Event description: This event fires when the 'moving from partner dashboard to wix studio' loaded
 *
 * @param {switchingToStudioModalModalLoadedParams} params - The parameters for this event
 * @property {string} entry - where the modal is being loaded from
 * @return {LogObject<switchingToStudioModalModalLoadedParams>} LogObject<switchingToStudioModalModalLoadedParams>
 */
export function switchingToStudioModalModalLoaded(params) {
    return { evid: 655, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leaveThePartnerProgramModalModalLoaded' event (evid: 656)
 *
 * Event description: This event fires when the 'Leave the Partner Program' modal loaded
 *
 * @param {leaveThePartnerProgramModalModalLoadedParams} params - The parameters for this event
 * @property {string} entry - where the modal is being loaded from
 * @return {LogObject<leaveThePartnerProgramModalModalLoadedParams>} LogObject<leaveThePartnerProgramModalModalLoadedParams>
 */
export function leaveThePartnerProgramModalModalLoaded(params) {
    return { evid: 656, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsPayoutsPageViewSrc80Evid657' event (evid: 657)
 *
 * Event description: Fires on any page view in the Earnings payouts page
 *
 *
 * @param {earningsPayoutsPageViewSrc80Evid657Params} params - The parameters for this event
 * @return {LogObject<earningsPayoutsPageViewSrc80Evid657Params>} LogObject<earningsPayoutsPageViewSrc80Evid657Params>
 */
export function earningsPayoutsPageViewSrc80Evid657(params) {
    return { evid: 657, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsPayoutsGenericClickSrc80Evid658' event (evid: 658)
 *
 * Event description: Fires on any click in payouts
 *
 *
 * @param {earningsPayoutsGenericClickSrc80Evid658Params} params - The parameters for this event
 * @property {string} click_type - The name of the button the user clicked on
 * @property {string} data - data extracted from action
 * @return {LogObject<earningsPayoutsGenericClickSrc80Evid658Params>} LogObject<earningsPayoutsGenericClickSrc80Evid658Params>
 */
export function earningsPayoutsGenericClickSrc80Evid658(params) {
    return { evid: 658, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsPayoutsHoverSrc80Evid659' event (evid: 659)
 *
 * Event description: fires when a partner hover on a button at the Payouts tab
 *
 * @param {earningsPayoutsHoverSrc80Evid659Params} params - The parameters for this event
 * @property {string} hover_type - hover type where the user hover
 * @return {LogObject<earningsPayoutsHoverSrc80Evid659Params>} LogObject<earningsPayoutsHoverSrc80Evid659Params>
 */
export function earningsPayoutsHoverSrc80Evid659(params) {
    return { evid: 659, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'internalInfoPageLoaded' event (evid: 66)
 *
 * Event description: internal "info" page loaded
 *
 * @param {internalInfoPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {become_an_expert;T&C;how_it_works }
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email;direct;homepage}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<internalInfoPageLoadedParams>} LogObject<internalInfoPageLoadedParams>
 */
export function internalInfoPageLoaded(params) {
    return { evid: 66, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsTemplatesMarketplacePageViewSrc80Evid660' event (evid: 660)
 *
 * Event description: page view of the earnings template page
 *
 * @param {earningsTemplatesMarketplacePageViewSrc80Evid660Params} params - The parameters for this event
 * @property {string} screen - name of the screen
 * @return {LogObject<earningsTemplatesMarketplacePageViewSrc80Evid660Params>} LogObject<earningsTemplatesMarketplacePageViewSrc80Evid660Params>
 */
export function earningsTemplatesMarketplacePageViewSrc80Evid660(params) {
    return { evid: 660, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'earningsTemplatesMarketplaceGenericClickSrc80Evid661' event (evid: 661)
 *
 * Event description: click on the earnings templates marketplace page
 *
 * @param {earningsTemplatesMarketplaceGenericClickSrc80Evid661Params} params - The parameters for this event
 * @property {string} screen - name of the screen
 * @property {string} click_type - click_type
 * @property {string} data - click data
 * @return {LogObject<earningsTemplatesMarketplaceGenericClickSrc80Evid661Params>} LogObject<earningsTemplatesMarketplaceGenericClickSrc80Evid661Params>
 */
export function earningsTemplatesMarketplaceGenericClickSrc80Evid661(params) {
    return { evid: 661, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerDailyGpvPayoutSiteSrc80Evid662' event (evid: 662)
 *
 * Event description: Partners GPV Payout Site - Daily Indication
 *
 * @param {partnerDailyGpvPayoutSiteSrc80Evid662Params} params - The parameters for this event
 * @property {number} gpvSitePaymentDate - gpv date
 * @property {GUID} metaSiteId - the msid from which the account received revshare
 * @property {string} targetAccountId - account_id
 * @return {LogObject<partnerDailyGpvPayoutSiteSrc80Evid662Params>} LogObject<partnerDailyGpvPayoutSiteSrc80Evid662Params>
 */
export function partnerDailyGpvPayoutSiteSrc80Evid662(params) {
    return { evid: 662, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioSitesSrc80Evid663' event (evid: 663)
 *
 * Event description: Studio site
 *
 * @param {studioSitesSrc80Evid663Params} params - The parameters for this event
 * @property {string} metaSiteId - msid of the Studio site
 * @return {LogObject<studioSitesSrc80Evid663Params>} LogObject<studioSitesSrc80Evid663Params>
 */
export function studioSitesSrc80Evid663(params) {
    return { evid: 663, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramWelcomeToPartnerProgramModalSrc80Evid664' event (evid: 664)
 *
 * Event description: page view Welcome to partner program modal
 *
 * @param {partnerProgramWelcomeToPartnerProgramModalSrc80Evid664Params} params - The parameters for this event
 * @property {string} origin - origin url where the user got from
 * @property {string} screenName -
 * Welcome modal / Welcome modal submit template/ welcome widget
 * @return {LogObject<partnerProgramWelcomeToPartnerProgramModalSrc80Evid664Params>} LogObject<partnerProgramWelcomeToPartnerProgramModalSrc80Evid664Params>
 */
export function partnerProgramWelcomeToPartnerProgramModalSrc80Evid664(params) {
    return { evid: 664, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerProgramWelcomeToPartnerProgramModalClickSrc80Evid665' event (evid: 665)
 *
 * Event description: fires when clicking on Welcome to partner program modal
 *
 * @param {partnerProgramWelcomeToPartnerProgramModalClickSrc80Evid665Params} params - The parameters for this event
 * @property {string} origin - origin url where the user got from
 * @property {string} clickType - click type
 * @property {string} screenName -
 * Welcome modal / Welcome modal submit template/ welcome widget
 * @return {LogObject<partnerProgramWelcomeToPartnerProgramModalClickSrc80Evid665Params>} LogObject<partnerProgramWelcomeToPartnerProgramModalClickSrc80Evid665Params>
 */
export function partnerProgramWelcomeToPartnerProgramModalClickSrc80Evid665(params) {
    return { evid: 665, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnFiltersMobile' event (evid: 68)
 *
 * Event description: filter field was clicked in mobile only (since this stage doesn't exist in desktop)
 *
 * @param {clickOnFiltersMobileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clickOnFiltersMobileParams>} LogObject<clickOnFiltersMobileParams>
 */
export function clickOnFiltersMobile(params) {
    return { evid: 68, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newOrExistingBriefNotification' event (evid: 69)
 *
 * Event description: new-or-existing-brief notification
 *
 * @param {newOrExistingBriefNotificationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {page name}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<newOrExistingBriefNotificationParams>} LogObject<newOrExistingBriefNotificationParams>
 */
export function newOrExistingBriefNotification(params) {
    return { evid: 69, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'studioEducationPlatformGenericClickSrc80Evid7' event (evid: 7)
 *
 * Event description: Generic click event in the Templates page in the Studio Workspace
 *
 *
 *
 *
 * @param {studioEducationPlatformGenericClickSrc80Evid7Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} screen_name - Wix Academy/
 * Community
 * @property {string} entry - entry point to the studio Education page
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} click_type - click type
 * @return {LogObject<studioEducationPlatformGenericClickSrc80Evid7Params>} LogObject<studioEducationPlatformGenericClickSrc80Evid7Params>
 */
export function studioEducationPlatformGenericClickSrc80Evid7(params) {
    return { evid: 7, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginIntroPage' event (evid: 71)
 *
 * Event description: login intro page load
 *
 * @param {loginIntroPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} type - {direct/indirect}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<loginIntroPageParams>} LogObject<loginIntroPageParams>
 */
export function loginIntroPage(params) {
    return { evid: 71, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressProceedToLoginOnIntroPage' event (evid: 72)
 *
 * Event description: press proceed to login or signup on intro page
 *
 * @param {pressProceedToLoginOnIntroPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {login/signup}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressProceedToLoginOnIntroPageParams>} LogObject<pressProceedToLoginOnIntroPageParams>
 */
export function pressProceedToLoginOnIntroPage(params) {
    return { evid: 72, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newBriefLoadedSrc80Evid73' event (evid: 73)
 *
 * Event description: Brief is loaded
 *
 * @param {newBriefLoadedSrc80Evid73Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - {1;2; e.g. small fix; new website}
 * @property {number} innerType - {1;2}
 * @property {string} entry - e.g, generalMenu, support_banner
 * @property {string} data - {}
 * @property {number} height - {}
 * @property {string} briefType - {WoW/three_steps/six_steps/dedicated}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for Testing
 * @property {string} origin - {login}
 * @property {string} sessionId - {}
 * @property {string} productName - the product the brief was opened in ( auto-match/ results page / explore/ partner profile)
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - {}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<newBriefLoadedSrc80Evid73Params>} LogObject<newBriefLoadedSrc80Evid73Params>
 */
export function newBriefLoadedSrc80Evid73(params) {
    return { evid: 73, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitBriefSrc80Evid74' event (evid: 74)
 *
 * Event description: User press on submit in the new brief
 *
 * @param {submitBriefSrc80Evid74Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} phoneFilled - if phone was filled
 * @property {number} serviceType - embedded_service_id
 * @property {string} phoneCountryCode - US, GB, etc
 * @property {string} matching_algorithm_engine - random/ low demand/ high demand
 * @property {number} innerType - innerType
 * @property {string} budget_number - number the user added for the budget
 * @property {string} state - state (sub-country)
 * @property {string} entry - entry point to brief
 * @property {string} data - {}
 * @property {string} briefType - brief_type
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} job_id - list of job ids for the brief
 * @property {string} wowVersion - wow_version for testing
 * @property {string} origin - {existing brief}
 * @property {string} budget_currency - Currency the user chose for the budget
 * @property {string} sessionId - {}
 * @property {boolean} added_budget - True if the user added a budget, false if the user marked he isn't sure what's his budget is
 * @property {string} productName - the product the brief came from - auto-match/results page/explore/partner profile
 * @property {boolean} is_exclusive - true if exclusive brief
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @property {boolean} inMarketplace - is partner is in marketplace
 * @return {LogObject<submitBriefSrc80Evid74Params>} LogObject<submitBriefSrc80Evid74Params>
 */
export function submitBriefSrc80Evid74(params) {
    return { evid: 74, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'briefSuccessPageRequestCreated' event (evid: 75)
 *
 * Event description: Brief Success Page (for contact details): your request was created page
 *
 * @param {briefSuccessPageRequestCreatedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief submitted id
 * @return {LogObject<briefSuccessPageRequestCreatedParams>} LogObject<briefSuccessPageRequestCreatedParams>
 */
export function briefSuccessPageRequestCreated(params) {
    return { evid: 75, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressSendRequestNow' event (evid: 76)
 *
 * Event description: press send request now on 'project created' page
 *
 * @param {pressSendRequestNowParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressSendRequestNowParams>} LogObject<pressSendRequestNowParams>
 */
export function pressSendRequestNow(params) {
    return { evid: 76, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressAddDetailsOnProjectCreatedPage' event (evid: 77)
 *
 * Event description: press 'add details' on 'project created' page
 *
 * @param {pressAddDetailsOnProjectCreatedPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressAddDetailsOnProjectCreatedPageParams>} LogObject<pressAddDetailsOnProjectCreatedPageParams>
 */
export function pressAddDetailsOnProjectCreatedPage(params) {
    return { evid: 77, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'step1InBriefLoaded' event (evid: 78)
 *
 * Event description: you already sent a group request (new brief)
 *
 * @param {step1InBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<step1InBriefLoadedParams>} LogObject<step1InBriefLoadedParams>
 */
export function step1InBriefLoaded(params) {
    return { evid: 78, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressSkipInStep1' event (evid: 79)
 *
 * Event description: press skip in step 1
 *
 * @param {pressSkipInStep1Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSkipInStep1Params>} LogObject<pressSkipInStep1Params>
 */
export function pressSkipInStep1(params) {
    return { evid: 79, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressAddFinalDetailsInStep1' event (evid: 80)
 *
 * Event description: press add final details in step 1
 *
 * @param {pressAddFinalDetailsInStep1Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressAddFinalDetailsInStep1Params>} LogObject<pressAddFinalDetailsInStep1Params>
 */
export function pressAddFinalDetailsInStep1(params) {
    return { evid: 80, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'step2InBriefLoaded' event (evid: 81)
 *
 * Event description: step 2 in brief loaded
 *
 * @param {step2InBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<step2InBriefLoadedParams>} LogObject<step2InBriefLoadedParams>
 */
export function step2InBriefLoaded(params) {
    return { evid: 81, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressSkipInStep2' event (evid: 82)
 *
 * Event description: press skip in step 2
 *
 * @param {pressSkipInStep2Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSkipInStep2Params>} LogObject<pressSkipInStep2Params>
 */
export function pressSkipInStep2(params) {
    return { evid: 82, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pressSaveInStep2' event (evid: 83)
 *
 * Event description: press save in step 2
 *
 * @param {pressSaveInStep2Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSaveInStep2Params>} LogObject<pressSaveInStep2Params>
 */
export function pressSaveInStep2(params) {
    return { evid: 83, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submittedDoneAllDonePage' event (evid: 85)
 *
 * Event description: submitted done (all done) page
 *
 * @param {submittedDoneAllDonePageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {step_id that was submitted 1 or 2}
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<submittedDoneAllDonePageParams>} LogObject<submittedDoneAllDonePageParams>
 */
export function submittedDoneAllDonePage(params) {
    return { evid: 85, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnMagnifyingGlassSearch' event (evid: 86)
 *
 * Event description: click on magnifying glass (search)
 *
 * @param {clickOnMagnifyingGlassSearchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clickOnMagnifyingGlassSearchParams>} LogObject<clickOnMagnifyingGlassSearchParams>
 */
export function clickOnMagnifyingGlassSearch(params) {
    return { evid: 86, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitSearchTerm' event (evid: 87)
 *
 * Event description: Submit search term
 *
 * @param {submitSearchTermParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - {country if filter was used}
 * @property {string} language - {lng if filter was used}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitSearchTermParams>} LogObject<submitSearchTermParams>
 */
export function submitSearchTerm(params) {
    return { evid: 87, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchResultsShown' event (evid: 88)
 *
 * Event description: search results shown
 *
 * @param {searchResultsShownParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} itemsCount - {number of results; no results =0}
 * @property {string} data - {array of providers guid first page}
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - {country if filter was used}
 * @property {string} language - {lng if filter was used}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<searchResultsShownParams>} LogObject<searchResultsShownParams>
 */
export function searchResultsShown(params) {
    return { evid: 88, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertClickGetStarted' event (evid: 89)
 *
 * Event description: click get started on banner leading to the project page
 *
 * @param {expertClickGetStartedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {guid}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email / dashboard}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertClickGetStartedParams>} LogObject<expertClickGetStartedParams>
 */
export function expertClickGetStarted(params) {
    return { evid: 89, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertNotAvailableToggle' event (evid: 90)
 *
 * Event description: expert changing the toggle
 *
 * @param {expertNotAvailableToggleParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} availability_modified - {true=available; false=not avaliable}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {toggle / top bar notification}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertNotAvailableToggleParams>} LogObject<expertNotAvailableToggleParams>
 */
export function expertNotAvailableToggle(params) {
    return { evid: 90, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'replyInDashboard' event (evid: 91)
 *
 * Event description: press "Yes, reopen" for reopening the canceled brief
 *
 * @param {replyInDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {string} button_name - {button/link}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<replyInDashboardParams>} LogObject<replyInDashboardParams>
 */
export function replyInDashboard(params) {
    return { evid: 91, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callClientInDashboard' event (evid: 92)
 *
 * Event description: Expert presses "call" in dashboard
 *
 * @param {callClientInDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {string} button_name - {button/link}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<callClientInDashboardParams>} LogObject<callClientInDashboardParams>
 */
export function callClientInDashboard(params) {
    return { evid: 92, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertRejectedProject' event (evid: 93)
 *
 * Event description: expert dashboard change tab: requests and submitted websites
 *
 * @param {expertRejectedProjectParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {}
 * @property {string} tabName - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertRejectedProjectParams>} LogObject<expertRejectedProjectParams>
 */
export function expertRejectedProject(params) {
    return { evid: 93, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expertSubmitRejectStatus' event (evid: 94)
 *
 * Event description: Expert presses "notify wix arena" in dashboard that he's not working on the project
 *
 * @param {expertSubmitRejectStatusParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertSubmitRejectStatusParams>} LogObject<expertSubmitRejectStatusParams>
 */
export function expertSubmitRejectStatus(params) {
    return { evid: 94, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorExpertTriesToOpenABriefThatDoesnTBelongToHim' event (evid: 95)
 *
 * Event description: error expert tries to open a brief that doesn't belong to him
 *
 * @param {errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - number of the brief's form
 * @property {number} typeid - {}
 * @property {string} errorName - error name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams>} LogObject<errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams>
 */
export function errorExpertTriesToOpenABriefThatDoesnTBelongToHim(params) {
    return { evid: 95, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tellMeMoreInExpertDashboard' event (evid: 96)
 *
 * Event description: press 'tell me more' in expert dashboard
 *
 * @param {tellMeMoreInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<tellMeMoreInExpertDashboardParams>} LogObject<tellMeMoreInExpertDashboardParams>
 */
export function tellMeMoreInExpertDashboard(params) {
    return { evid: 96, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyAutomatedEmailInExpertDashboard' event (evid: 97)
 *
 * Event description: press 'copy this automated email' in expert dashboard
 *
 * @param {copyAutomatedEmailInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<copyAutomatedEmailInExpertDashboardParams>} LogObject<copyAutomatedEmailInExpertDashboardParams>
 */
export function copyAutomatedEmailInExpertDashboard(params) {
    return { evid: 97, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyToClipboardAutomatedEmailInExpertDashboard' event (evid: 98)
 *
 * Event description: press 'copy to clipboard' in expert dashboard
 *
 * @param {copyToClipboardAutomatedEmailInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<copyToClipboardAutomatedEmailInExpertDashboardParams>} LogObject<copyToClipboardAutomatedEmailInExpertDashboardParams>
 */
export function copyToClipboardAutomatedEmailInExpertDashboard(params) {
    return { evid: 98, src: 80, endpoint: '', params };
}
/**
 * A function to create a log object for the 'notInterestedInProjectInExpertDashboard' event (evid: 99)
 *
 * Event description: press 'not interested in project' in expert dashboard
 *
 * @param {notInterestedInProjectInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<notInterestedInProjectInExpertDashboardParams>} LogObject<notInterestedInProjectInExpertDashboardParams>
 */
export function notInterestedInProjectInExpertDashboard(params) {
    return { evid: 99, src: 80, endpoint: '', params };
}
//# sourceMappingURL=index.js.map